const local = {
  view: {
    grid: 'Grid',
    list: 'List',
    compact: 'Compact'
  },
  calculator: {
    title: 'API cost calculator',
    description: 'Estimate provider usage for one request or a growing production workload.',
    estimateSetup: 'Estimate setup',
    totalPayable: 'Total payable',
    providerUsageCost: 'Provider usage cost',
    platformFeeZero: 'AvalAI platform fee (0%)',
    effectivePerRequest: 'Effective cost per request',
    dominantCostDriver: 'Dominant cost driver',
    providerUsageTruth: 'The provider response usage object is the billing source of truth.',
    exchangeUnavailable: 'Exchange rate unavailable',
    currentExchangeRate: 'Current exchange rate',
    unitDefinition: '1 UNIT = 1 USD',
    fallbackCatalog: 'Limited public catalog fallback is active.',
    unsupportedPrice: 'Not yet calculable',
    requests: 'Requests',
    monthlyGrowth: 'Monthly growth',
    forecastHorizon: 'Forecast horizon',
    maxResults: 'Maximum results per query',
    monthCount: '{count} months',
    assumptions: 'Rates and assumptions',
    retry: 'Retry',
    retryExchange: 'Retry exchange rate',
    copyEstimate: 'Copy estimate summary',
    copySuccess: 'Estimate copied',
    copyFailed: 'Estimate could not be copied',
    resetExample: 'Reset example',
    openTokenizer: 'Open tokenizer',
    model: 'Model',
    serviceTier: 'Service tier',
    catalogUnavailable: 'Public pricing is unavailable',
    noPricing: 'No calculable pricing is published for this model.',
    thresholdRateApplied: 'A higher context-window rate is active for this workload.',
    usageType: 'Usage type',
    quantity: 'Quantity',
    rate: 'Provider rate',
    serviceTier_standard: 'Standard',
    serviceTier_flex: 'Flex',
    serviceTier_batch: 'Batch',
    serviceTier_priority: 'Priority',
    serviceTier_default: 'Standard',
    unit_million_tokens: '1M tokens',
    unit_thousand_tokens: '1K tokens',
    rateScale: 'Rate scale',
    rateScalePerMillion: 'per 1M tokens',
    rateScalePerThousand: 'per 1K tokens',
    unit_character: 'character',
    unit_second: 'second',
    unit_image: 'image',
    unit_video_second: 'video second',
    unit_page: 'page',
    unit_query: 'query',
    unit_megapixel: 'megapixel',
    unit_citation: 'citation',
    pricing_input: 'Input tokens',
    pricing_cached_input: 'Cached input tokens',
    pricing_cache_creation_input: 'Cache creation tokens',
    pricing_output: 'Output tokens',
    pricing_reasoning_output: 'Reasoning output tokens',
    pricing_audio_input: 'Audio input tokens',
    pricing_audio_cached_input: 'Cached audio input tokens',
    pricing_audio_output: 'Audio output tokens',
    pricing_image_input: 'Image input tokens',
    pricing_image_cached_input: 'Cached image input tokens',
    pricing_image_output: 'Image output tokens',
    pricing_video_input: 'Video input tokens',
    pricing_character_input: 'Input characters',
    pricing_time: 'Duration',
    pricing_video_output: 'Generated video',
    pricing_image_generation: 'Generated images',
    pricing_page_input: 'Input pages',
    pricing_annotation_page_input: 'Annotation pages',
    pricing_query_input: 'Queries',
    pricing_megapixel: 'Megapixels',
    pricing_citation: 'Citations',
    pricing_other: 'Other usage',
    compareModels: 'Compare models',
    maxComparison: 'Compare up to four models',
    estimatedCost: 'Estimated cost',
    differenceFromLowest: 'Difference from lowest',
    context: 'Context',
    endpoints: 'Endpoints',
    capabilities: 'Capabilities',
    pricingSource: 'Pricing source',
    provider: 'Provider',
    minimumTier: 'Minimum tier',
    serviceTiers: 'Service tiers',
    lifecycleRelease: 'Release date',
    lifecycleSnapshot: 'Snapshot date',
    lifecycleDeprecation: 'Deprecates',
    lifecycleUnpublished: 'Not published',
    estimateUnavailable: 'Estimate unavailable',
    cumulativeCost: 'Cumulative cost',
    forecastTable: 'Forecast details',
    month: 'Month',
    rateInput: 'In',
    rateCached: 'Cached',
    rateOutput: 'Out',
    unit: 'UNIT',
    irt: 'IRT',
    tokenRange: '{input} / {output}',
    emptyEstimateTitle: 'Enter usage to estimate cost',
    emptyEstimateHint: 'Add token counts or requests above to see a live estimate.',
    comparisonSelected: '{count} / {max} selected',
    comparisonEmptyTitle: 'Select models to compare',
    comparisonEmptyHint: 'Pick up to four models above to see costs, rates, and capabilities side by side.',
    comparisonBestValue: 'Best value',
    comparisonMoreItems: '+{count} more'
  },
  tokenizer: {
    title: 'Browser tokenizer',
    description: 'Inspect how supported OpenAI text encodings split plain text in your browser.',
    providerUsageTitle: 'Provider usage is authoritative',
    providerUsageTruth:
      'AvalAI does not define tokenization or billable token counts. The provider usage object relayed in your API response is the single source of truth.',
    localEstimateOnly:
      'This local estimate covers plain text only. Tools, schemas, files, images, audio, and provider framing may add usage.',
    supportedModel: 'Supported model',
    encoding: 'Encoding',
    placeholder: 'Paste text to inspect its tokens…',
    showExample: 'Show example',
    clear: 'Clear',
    copyText: 'Copy text',
    tokens: 'Tokens',
    characters: 'Characters',
    words: 'Words',
    averageCharacters: 'Average characters per token',
    contextUsage: 'Context used',
    visualization: 'Token visualization',
    textView: 'Text',
    idView: 'Token IDs',
    visualizationTruncated: 'Showing the first {count} tokens. The total count remains complete.',
    textTooLarge: 'Text must contain no more than 2,000,000 characters.',
    workerFailed: 'The browser tokenizer could not start. Try again.',
    noSupportedModels: 'No catalog model is supported by the installed tokenizer library.',
    localPrivacy: 'Tokenization runs locally. Your text is not sent to AvalAI.',
    useInCalculator: 'Use in calculator',
    copySuccess: 'Text copied',
    copyFailed: 'Text could not be copied',
    emptyVisualization: 'Enter text to inspect token boundaries.',
    catalogUnavailable: 'The public model catalog is unavailable',
    retry: 'Retry'
  },
  support: {
    title: 'Support Center',
    description: 'Get help and manage your support tickets',
    myTickets: 'My Tickets',
    createTicket: 'Create Ticket',
    agent: 'Support',

    aiOperations: {
      title: 'Support AI Operations',
      description: 'Review privacy-safe runtime health and cross-ticket run metadata.',
      accessDenied: 'You do not have the Support AI Operations capability.',
      openRun: 'Open in AI Operations',
      tabs: {
        overview: 'Overview',
        runs: 'Runs',
        evaluations: 'Evaluations',
        replays: 'Replays',
        releases: 'Releases'
      },
      workflow: {
        progress: 'Release workflow progress',
        currentPhase: 'Current phase',
        blockerCount: '{count} blockers',
        phases: {
          evidence: 'Evidence review',
          approval: 'Independent approval',
          shadow: 'Shadow rollout',
          support_admin: 'Support-admin pilot',
          selected_agents: 'Selected agents',
          all_support: 'All support',
          steady_state: 'Steady state',
          terminal: 'Terminal'
        },
        statuses: {
          blocked: 'Blocked',
          waiting: 'Waiting',
          ready: 'Ready',
          active: 'Active',
          complete: 'Complete',
          terminal: 'Terminal'
        },
        stepStates: {
          complete: 'Complete',
          current: 'Current',
          upcoming: 'Upcoming',
          terminal: 'Not advanced'
        },
        blockers: {
          customer_activation_disabled: 'Customer activation remains disabled.',
          hard_gate_failed: 'A required hard gate did not pass.',
          dataset_expired: 'The bound dataset evidence has expired.',
          approval_terminal: 'The approval lifecycle is terminal.',
          approval_incomplete: 'The required approval is incomplete.',
          independent_approver_required: 'An independent approver is required.',
          minimum_soak_incomplete: 'The minimum stage soak is incomplete.',
          eligible_runs_insufficient: 'The stage has insufficient eligible runs.',
          health_safety_failure: 'Health or safety evidence did not pass.',
          rollout_paused: 'The rollout is paused.',
          rollout_fenced: 'The rollout is fenced.',
          rollout_rolled_back: 'The rollout was rolled back.'
        },
        actions: {
          approve: 'Approve release',
          reject: 'Reject release',
          cancel: 'Cancel approval',
          escalate: 'Escalate approval',
          re_request: 'Request approval again',
          execute_release: 'Execute approved release',
          start_support_admin: 'Start support-admin pilot',
          advance: 'Advance rollout',
          mark_steady_state: 'Mark steady state',
          pause: 'Pause rollout',
          resume: 'Resume rollout',
          fence: 'Fence rollout',
          rollback: 'Roll back rollout',
          development_precondition: 'Create development evidence'
        },
        evidence: {
          title: 'Workflow evidence checklist',
          showDetails: 'Show details',
          hideDetails: 'Hide details',
          hardGate: 'Hard-gate evidence',
          hardGateSummary: 'Review the complete hard-gate counts and integrity checks below.',
          datasetFreshness: 'Dataset freshness',
          datasetFreshnessSummary: 'Review the bound dataset version, hash, and freshness deadline below.',
          calibration: 'Calibration evidence',
          calibrationSummary: 'Review the calibration outcome, counts, error rate, and category coverage below.',
          adversarial: 'Adversarial evidence',
          adversarialSummary: 'Review the bounded adversarial generation and coverage summary below.',
          approval: 'Approval evidence',
          approvalSummary: 'Review the full version-bound approval lifecycle below.',
          statuses: {
            pass: 'Passed',
            fail: 'Failed',
            unavailable: 'Unavailable',
            pending: 'Pending'
          }
        },
        actionPanel: {
          currentState: 'Current workflow state',
          unavailable: 'Workflow unavailable',
          blockers: 'Ordered blockers',
          customerReadOnly: 'Customer workflow records are read-only and expose no action.',
          invalidReadOnly: 'Invalid or unavailable workflow data is read-only.',
          noAction: 'No backend-authorized action is currently available.',
          nextActions: 'Available next actions',
          openLinkedRollout: 'Open linked rollout'
        },
        approvalDialog: {
          title: 'Release approval action',
          description: 'Review the bound candidate and provide the required reason and evidence.'
        },
        rolloutDialog: {
          title: 'Rollout control action',
          description: 'Provide evidence for the exact revision-bound action advertised by the backend.'
        },
        fields: {
          close: 'Close dialog',
          candidateHash: 'Candidate hash',
          approvalVersion: 'Approval version',
          action: 'Action',
          reason: 'Reason',
          evidence: 'Evidence',
          cancel: 'Cancel',
          submit: 'Submit action',
          currentStage: 'Current stage',
          expectedRevision: 'Expected revision',
          safetyEvidence: 'Safety pass evidence',
          healthEvidence: 'Health pass evidence',
          evaluatedCount: 'Evaluated count',
          failureCount: 'Failure count',
          passed: 'Evidence passed',
          clearTriggers: 'Clear rollout triggers',
          pauseTrigger: 'Pause trigger count',
          fenceTrigger: 'Fence trigger count',
          rollbackTrigger: 'Rollback trigger count',
          triggerClear: 'Trigger is clear',
          stageCompletion: 'Stage completion evidence',
          completed: 'Stage completed',
          safetyPassed: 'Stage safety passed',
          healthPassed: 'Stage health passed',
          firedTrigger: 'Fired trigger evidence',
          reasonCode: 'Trigger reason code',
          triggerCount: 'Fired trigger count',
          confirmDestructive: 'I confirm this destructive rollout action.'
        },
        validation: {
          reasonLength: 'Reason must contain 8 to 1000 characters.',
          evidenceLength: 'Evidence must contain 8 to 2000 characters.',
          reasonCode:
            'Use 1 to 128 lowercase characters: English letters, numbers, periods (.), underscores (_), colons (:), or hyphens (-).',
          firedTrigger: 'Record at least one fired trigger.',
          passEvidence: 'Evaluated and failure counts must be valid, and the evidence must pass.',
          clearTriggers: 'Every pause, fence, and rollback trigger must be clear.',
          confirmationRequired: 'Explicit confirmation is required.'
        },
        warnings: {
          pause: 'Pausing stops rollout progress until a permitted resume action is available.',
          fence: 'Fencing prevents further rollout activation.',
          rollback: 'Rollback disables this rollout and requires explicit recovery work.',
          rollbackNoPhaseOneRestore: 'Rollback does not automatically restore Phase 1.'
        },
        errors: {
          stepUpRequired: 'Fresh step-up authentication is required before this action can continue.',
          forbidden: 'You are no longer authorized to perform this action.',
          conflict: 'The workflow changed. Canonical state must be reloaded.',
          invalidInput: 'The submitted workflow evidence is invalid.',
          auditUnavailable: 'The required audit service is temporarily unavailable.',
          rateLimited: 'Too many workflow requests were made. Try again shortly.',
          requestFailed: 'The workflow action could not be completed.',
          invalidResponse: 'The workflow service returned an invalid safe response.'
        },
        results: {
          ready: 'Ready for reviewed input.',
          submitting: 'Submitting the workflow action…',
          succeeded: 'The action succeeded and canonical state is refreshing.',
          failed: 'The action did not complete.',
          refreshed: 'Canonical workflow state was refreshed.'
        }
      },
      developmentPreconditionDialog: {
        title: 'Create development rollout evidence',
        description:
          'Confirm the server-bound fixture, stage, and revision, then identify the existing QA ticket and internal requester.',
        warning: 'Development-only: this creates retained synthetic rollout evidence and is not production approval.',
        close: 'Close dialog',
        fixtureId: 'Fixture ID',
        stage: 'Stage',
        revision: 'Expected revision',
        ticketId: 'Existing QA ticket ID',
        requesterId: 'Internal requester UUID',
        confirm: 'Create development evidence',
        cancel: 'Cancel',
        submitting: 'Creating retained development evidence…',
        success: 'Development evidence was created and canonical rollout state refreshed.',
        rolloutId: 'Rollout ID',
        candidateHash: 'Candidate hash',
        runCount: 'Fixture-owned run count',
        runDigest: 'Fixture-owned run ID digest',
        receiptHash: 'Receipt hash',
        validation: {
          ticketId: 'Enter a positive whole-number ticket ID.',
          requesterId: 'Enter a canonical lowercase UUID.'
        },
        errors: {
          stepUpRequired: 'Fresh step-up authentication is required before creating development evidence.',
          forbidden: 'You are no longer authorized to create development evidence.',
          conflict:
            'The rollout changed. Canonical state was refreshed; close this dialog and review the new stage and revision.',
          invalidInput: 'The development precondition input is invalid.',
          auditUnavailable: 'The required development evidence audit is temporarily unavailable.',
          rateLimited: 'Too many development precondition requests were made. Try again shortly.',
          requestFailed: 'The development precondition request could not be completed.',
          invalidResponse: 'The development precondition service returned an invalid safe response.'
        }
      },
      filters: {
        window: 'Time window',
        language: 'Language',
        operation: 'Operation',
        state: 'State',
        ticket: 'Ticket number',
        ticketPlaceholder: 'TK-…',
        datasetKey: 'Dataset key',
        datasetKeyPlaceholder: 'support-core',
        evaluationSetId: 'Evaluation set ID',
        all: 'All'
      },
      windows: {
        '1h': 'Last hour',
        '24h': 'Last 24 hours',
        '7d': 'Last 7 days',
        '30d': 'Last 30 days'
      },
      languages: {
        en: 'English',
        fa: 'Persian'
      },
      audiences: {
        internal: 'Internal',
        agent: 'Agent'
      },
      evidenceStatus: {
        dataset: {
          missing: 'Missing',
          fresh: 'Fresh',
          expired: 'Expired'
        },
        hardGate: {
          missing: 'Missing',
          passed: 'Passed',
          failed: 'Failed'
        },
        calibration: {
          missing: 'Missing',
          uncalibrated: 'Uncalibrated',
          eligible: 'Eligible',
          passed: 'Passed',
          failed: 'Failed'
        }
      },
      metrics: {
        totalRuns: 'Total runs',
        completion: 'Completion rate',
        blocked: 'Block rate',
        failure: 'Failure rate',
        timeout: 'Timeout rate',
        latency: 'Latency events',
        retrieval: 'Retrieval health',
        degraded: 'Degraded',
        zeroResults: 'Zero results',
        evaluation: 'Evaluation evidence',
        dataset: 'Dataset',
        hardGates: 'Hard gates',
        calibration: 'Calibration',
        rollouts: 'Rollout summary',
        active: 'Enabled',
        paused: 'Paused',
        fenced: 'Fenced'
      },
      runs: {
        title: 'Run queue',
        empty: 'No runs match these filters.',
        select: 'Select a run to inspect safe metadata.',
        resultCount: '{count} runs on this page',
        rowLabel: 'Open run {run} for ticket {ticket}',
        loading: 'Loading runs…'
      },
      evaluations: {
        title: 'Evaluation datasets',
        empty: 'No evaluation datasets match this filter.',
        select: 'Select an evaluation dataset to inspect safe metadata.',
        resultCount: '{count} evaluation datasets on this page',
        rowLabel: 'Open evaluation dataset {dataset}, version {version}',
        loading: 'Loading evaluation datasets…'
      },
      evaluationDetail: {
        title: 'Evaluation dataset details',
        datasetKey: 'Dataset key',
        version: 'Version',
        datasetHash: 'Dataset hash',
        schemaHash: 'Schema hash',
        created: 'Created',
        exampleCount: 'Examples',
        languages: 'Languages',
        categories: 'Categories',
        examples: 'Evaluation examples',
        inputHash: 'Input hash',
        expectedHash: 'Expected-output hash',
        sourceRun: 'Source run ID',
        attested: 'Curator attested',
        redactionAttested: 'Redaction attested',
        expires: 'Content expires',
        purged: 'Content purged'
      },
      evaluationOrigins: {
        synthetic: 'Synthetic',
        manually_redacted: 'Manually redacted'
      },
      evaluationCategories: {
        response_quality: 'Response quality',
        citation_grounding: 'Citation grounding',
        safety: 'Safety',
        privacy: 'Privacy',
        routing: 'Routing',
        multilingual: 'Multilingual'
      },
      adversarial: {
        coverageTitle: 'Adversarial coverage',
        evidenceTitle: 'Adversarial replay evidence',
        releaseSummaryTitle: 'Adversarial release summary',
        kind: 'Adversarial kind',
        schemaVersion: 'Schema version',
        registryVersion: 'Registry version',
        state: 'State',
        total: 'Total cases',
        requiredCells: 'Required language cells',
        coveredCells: 'Covered language cells',
        languageColumns: {
          en: 'English',
          fa: 'Persian'
        },
        evidence: {
          total: 'Total',
          passed: 'Passed',
          failed: 'Failed',
          blocked: 'Blocked'
        },
        states: {
          passed: 'Passed',
          failed: 'Failed',
          blocked: 'Blocked'
        },
        kinds: {
          prompt_injection: 'Prompt injection',
          secret_pii_exfiltration: 'Secret or PII exfiltration',
          unsafe_output: 'Unsafe output',
          authorization_bypass: 'Authorization bypass',
          audience_confusion: 'Audience confusion',
          cross_ticket_leakage: 'Cross-ticket leakage',
          unsafe_url_markdown: 'Unsafe URL or Markdown',
          factual_citation_manipulation: 'Factual or citation manipulation',
          retrieval_tampering: 'Retrieval tampering',
          unicode_bidi_obfuscation: 'Unicode bidi obfuscation'
        }
      },
      releaseSections: {
        candidates: 'Candidates',
        rollouts: 'Rollouts'
      },
      customerReadiness: {
        title: 'Customer readiness',
        activationDisabled: 'Customer activation remains disabled.',
        refresh: 'Refresh',
        retry: 'Retry',
        loading: 'Loading customer readiness…',
        evaluatedAt: 'Evaluated at',
        evidenceAt: 'Evidence recorded at',
        approvalProgress: 'Approval progress',
        openRelease: 'Open internal release candidate',
        openRollout: 'Open internal rollout',
        openCustomerRelease: 'Open customer release candidate',
        openEvaluation: 'Open evaluation set',
        openReplay: 'Open evaluation replay',
        internalBaseline: 'Internal baseline',
        customerCandidate: 'Customer candidate',
        statuses: {
          not_ready: 'Not ready',
          pilot_ready: 'Pilot-ready'
        },
        groups: {
          baseline: 'Baseline',
          evaluation: 'Evaluation',
          governance: 'Governance',
          policy: 'Policy',
          safety: 'Safety',
          operations: 'Operations',
          invariant: 'Invariant'
        },
        errors: {
          stepUpRequired: 'Fresh step-up authentication is required to view this status.',
          evidenceUnavailable: 'Customer-readiness evidence is unavailable.',
          auditUnavailable: 'Customer-readiness audit is temporarily unavailable.',
          rateLimited: 'Too many readiness requests were made. Try again shortly.',
          invalidResponse: 'The readiness service returned an invalid safe response.',
          revoked: 'Customer-readiness access is no longer available.',
          unavailable: 'The customer-readiness service is temporarily unavailable.',
          requestFailed: 'The customer-readiness request could not be completed.'
        },
        gates: {
          internal_steady_state: 'Internal steady state',
          internal_safety_health: 'Baseline safety and health',
          internal_operational_clear: 'Internal operational clearance',
          customer_candidate_present: 'Customer release candidate',
          customer_privacy_safety: 'Customer privacy and safety',
          customer_authorization_isolation: 'Authorization and isolation',
          customer_safe_rendering: 'Safe customer rendering',
          customer_grounding: 'Evidence-supported answers',
          customer_retrieval_deployment: 'Retrieval and deployment integrity',
          customer_bilingual_coverage: 'Bilingual customer coverage',
          customer_adversarial_replay: 'Customer adversarial replay',
          customer_evidence_freshness: 'Customer evidence freshness',
          customer_dual_approval: 'Dual customer approval',
          customer_separation_of_duty: 'Approval separation of duty',
          customer_category_allowlist: 'Customer category allowlist',
          customer_explicit_consent: 'Explicit customer consent',
          customer_bot_disclosure: 'Customer bot disclosure',
          customer_budget_limits: 'Customer budget limits',
          customer_human_intervention: 'Human intervention routing',
          customer_feedback_voting: 'Customer feedback and voting',
          customer_stale_ticket_fence: 'Stale-ticket publication fence',
          customer_monitoring_visibility: 'Customer monitoring visibility',
          customer_rollback_rehearsal: 'Customer rollback rehearsal',
          customer_activation_disabled: 'Customer activation remains disabled'
        },
        states: {
          passed: 'Passed',
          missing: 'Missing',
          failed: 'Failed',
          expired: 'Expired'
        },
        reasons: {
          requirements_met: 'Requirements met.',
          evidence_missing: 'Required evidence is missing.',
          evidence_not_recorded: 'Required durable evidence has not been recorded.',
          evidence_failed: 'Required evidence did not pass.',
          evidence_expired: 'Required evidence has expired.',
          internal_baseline_not_recorded: 'Internal baseline evidence has not been recorded.',
          internal_steady_state_incomplete: 'Internal steady state is incomplete.',
          internal_safety_health_not_recorded: 'Internal safety and health evidence has not been recorded.',
          internal_safety_health_failed: 'Internal safety or health evidence did not pass.',
          internal_operational_clear_not_recorded: 'Internal operational-clearance evidence has not been recorded.',
          internal_operational_clear_failed: 'Internal operations are not clear.',
          customer_candidate_not_recorded: 'A customer candidate has not been recorded.',
          privacy_safety_failure: 'Customer privacy or safety evidence did not pass.',
          authorization_isolation_failure: 'Authorization or isolation evidence did not pass.',
          unsafe_rendering_detected: 'Unsafe customer rendering was detected.',
          unsupported_factual_claims: 'Unsupported factual claims were detected.',
          retrieval_deployment_failure: 'Retrieval or deployment integrity did not pass.',
          bilingual_coverage_missing: 'Required English and Persian coverage is missing.',
          dataset_freshness_failure: 'Dataset freshness evidence did not pass.',
          dataset_evidence_expired: 'Dataset evidence has expired.',
          adversarial_evidence_not_recorded: 'Adversarial replay evidence has not been recorded.',
          adversarial_coverage_incomplete: 'Required adversarial coverage is incomplete.',
          adversarial_replay_failed: 'An adversarial replay case failed or was blocked.',
          adversarial_evidence_expired: 'Adversarial replay evidence has expired.',
          adversarial_evidence_integrity_failure: 'Adversarial replay evidence integrity did not pass.',
          customer_policy_evidence_not_recorded: 'Customer policy evidence has not been recorded.',
          customer_category_allowlist_invalid: 'Customer category allowlist evidence did not pass.',
          customer_explicit_consent_policy_invalid: 'Customer explicit-consent policy evidence did not pass.',
          customer_bot_disclosure_policy_invalid: 'Customer bot-disclosure policy evidence did not pass.',
          customer_budget_limits_invalid: 'Customer budget-limit evidence did not pass.',
          customer_policy_evidence_integrity_failure: 'Customer policy evidence integrity did not pass.',
          customer_control_evidence_not_recorded: 'Customer control evidence has not been recorded.',
          customer_control_evidence_integrity_failure: 'Customer control evidence integrity did not pass.',
          customer_control_evidence_expired: 'Customer control evidence has expired.',
          customer_human_intervention_invalid: 'Human intervention routing checks did not pass.',
          customer_feedback_voting_invalid: 'Customer feedback and voting checks did not pass.',
          customer_stale_ticket_fence_invalid: 'Stale-ticket publication fence checks did not pass.',
          approval_incomplete: 'Required customer approval is incomplete.',
          approval_not_approved: 'Customer approval was not approved.',
          approval_expired: 'Customer approval has expired.',
          actors_not_independent: 'Approval actors are not independent.',
          actor_authorization_invalid: 'An approval actor is no longer authorized.'
        }
      },
      releaseCandidates: {
        title: 'Release candidates',
        empty: 'No release candidates match these filters.',
        select: 'Select a release candidate to inspect governed evidence.',
        resultCount: 'Release candidates on this page: {count}',
        rowLabel:
          'Open release candidate {id}, audience {audience}, approval {approval}, hard gate {hardGate}, calibration {calibration}, workflow phase {phase}, workflow status {status}, {blockers}',
        loading: 'Loading release candidates…',
        audienceFilter: 'Audience',
        calibrationFilter: 'Calibration status',
        approvalFilter: 'Approval status',
        evaluationSetFilter: 'Evaluation set ID',
        evaluationSetPlaceholder: '019fc900-0000-7000-8000-000000000000',
        pagination: 'Release candidate pages',
        page: 'Page'
      },
      releaseDetail: {
        title: 'Release candidate details',
        candidateId: 'Candidate ID',
        candidateHash: 'Candidate hash',
        evidenceHash: 'Evidence hash',
        audience: 'Audience',
        createdAt: 'Created',
        dataset: 'Dataset evidence',
        datasetVersion: 'Dataset version',
        datasetHash: 'Dataset hash',
        datasetFreshUntil: 'Dataset fresh until',
        configuration: 'Release configuration',
        policyIdentity: 'Policy identity',
        policyHash: 'Policy hash',
        promptIdentity: 'Prompt identity',
        promptHash: 'Prompt hash',
        modelIdentity: 'Model identity',
        modelHash: 'Model hash',
        embeddingIdentity: 'Embedding identity',
        embeddingHash: 'Embedding hash',
        indexIdentity: 'Index identity',
        indexHash: 'Index hash',
        thresholdsHash: 'Thresholds hash',
        evaluationRun: 'Evaluation replay',
        evaluationSetId: 'Evaluation set ID',
        evaluationDatasetKey: 'Evaluation dataset key',
        evaluationDatasetVersion: 'Evaluation dataset version',
        evaluationDatasetHash: 'Evaluation dataset hash',
        evaluationSchemaHash: 'Evaluation schema hash',
        evaluationSetCreatedAt: 'Evaluation set created',
        evaluationRunId: 'Evaluation run ID',
        baselineConfigurationHash: 'Baseline configuration hash',
        candidateConfigurationHash: 'Candidate configuration hash',
        evaluationState: 'Evaluation state',
        totalExamples: 'Total examples',
        processedExamples: 'Processed examples',
        passedExamples: 'Passed examples',
        failedExamples: 'Failed examples',
        blockedExamples: 'Blocked examples',
        evaluationStartedAt: 'Evaluation started',
        evaluationCompletedAt: 'Evaluation completed',
        evaluationRunCreatedAt: 'Evaluation run created',
        hardGates: 'Hard-gate evidence',
        hardGatePassed: 'Hard gate passed',
        calibration: 'Calibration evidence',
        calibrationStatus: 'Calibration status',
        calibrationPassed: 'Calibration passed',
        calibrationEvidence: 'Calibration evidence values',
        calibrationCounts: 'Projected calibration values',
        calibrationEvidenceCategories: 'Evidence category coverage',
        calibrationCategories: 'Projected category coverage',
        approval: 'Approval lifecycle',
        approvalId: 'Approval ID',
        approvalAction: 'Approval action',
        approvalStatus: 'Approval status',
        customerDisabled: 'Customer activation remains disabled.',
        requiredApprovers: 'Required approvers',
        approvalVersion: 'Approval version',
        requestedAt: 'Requested',
        expiresAt: 'Expires',
        decidedAt: 'Decided',
        secondaryDecidedAt: 'Second decision',
        executedAt: 'Executed',
        escalationLevel: 'Escalation level',
        escalatedAt: 'Escalated',
        cancelledAt: 'Cancelled',
        expiredAt: 'Expired',
        lifecycleUpdatedAt: 'Lifecycle updated'
      },
      customerPolicy: {
        title: 'Customer policy evidence',
        schemaVersion: 'Schema version',
        identity: 'Policy identity',
        hash: 'Policy hash',
        categoryCount: 'Allowed categories',
        customFieldCount: 'Allowed custom fields',
        categoryRegistryHash: 'Category registry hash',
        consentContractVersion: 'Consent contract version',
        disclosureVersion: 'Disclosure version',
        budgetContractVersion: 'Budget contract version',
        budgetScopeCount: 'Budget scopes'
      },
      customerControls: {
        title: 'Customer control evidence',
        snapshotHash: 'Snapshot hash',
        contractHash: 'Contract hash',
        validatorVersion: 'Validator version',
        validatedAt: 'Validated at',
        freshUntil: 'Fresh until',
        freshness: 'Freshness',
        current: 'Current',
        expired: 'Expired',
        status: 'Status',
        contractVersion: 'Contract version',
        reason: 'Reason',
        statuses: {
          passed: 'Passed',
          failed: 'Failed'
        },
        requiredChecks: 'Required checks',
        passedChecks: 'Passed checks',
        humanIntervention: 'Human intervention routing',
        feedbackVoting: 'Customer feedback and voting',
        staleTicketFence: 'Stale-ticket publication fence'
      },
      releaseApprovalStatuses: {
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Rejected',
        executed: 'Executed',
        cancelled: 'Cancelled',
        expired: 'Expired'
      },
      releaseAudiences: {
        internal: 'Internal support',
        customer: 'Customer'
      },
      releaseErrors: {
        list: 'Release candidates are temporarily unavailable.',
        detail: 'This release candidate is temporarily unavailable.',
        invalidQuery: 'These release filters are invalid.',
        invalidCursor: 'This release page is no longer available. Return to the first page.',
        notFound: 'The requested release candidate was not found.',
        auditUnavailable: 'Release governance audit is temporarily unavailable.',
        rateLimited: 'Too many release read requests were made. Try again shortly.',
        invalidResponse: 'The release service returned an invalid safe response.',
        revoked: 'Support AI Operations access is no longer available.',
        unavailable: 'Release governance is temporarily unavailable.',
        requestFailed: 'The release request could not be completed.'
      },
      rollouts: {
        title: 'Rollouts',
        empty: 'No rollouts match these filters.',
        select: 'Select a rollout to inspect governed progress and evidence.',
        resultCount: 'Rollouts on this page: {count}',
        rowLabel:
          'Open rollout {id}, audience {audience}, stage {stage}, status {status}, revision {revision}, release candidate {candidateHash}, updated {updated}, workflow phase {phase}, workflow status {workflowStatus}, {blockers}',
        loading: 'Loading rollouts…',
        audienceFilter: 'Audience',
        stageFilter: 'Rollout stage',
        statusFilter: 'Rollout status',
        pagination: 'Rollout pages',
        page: 'Page'
      },
      rolloutDetail: {
        title: 'Rollout details',
        rolloutId: 'Rollout ID',
        audience: 'Audience',
        stage: 'Stage',
        status: 'Status',
        enabled: 'Enabled',
        customerActivationEnabled: 'Customer activation enabled',
        activationAvailable: 'Activation available',
        releaseCandidate: 'Release candidate',
        revision: 'Revision',
        createdAt: 'Created',
        updatedAt: 'Updated',
        stageTiming: 'Stage timing',
        startedAt: 'Rollout started',
        stageStartedAt: 'Stage started',
        priorStage: 'Prior stage',
        steadyStateReachedAt: 'Steady state reached',
        counts: 'Eligibility and run counts',
        eligibleAgentCount: 'Eligible agents',
        activatedAgentCount: 'Activated agents',
        eligibleRunCount: 'Eligible runs',
        priorStageDurationSeconds: 'Prior-stage duration (seconds)',
        priorStageEligibleRunCount: 'Prior-stage eligible runs',
        allSupportDurationSeconds: 'All-support duration (seconds)',
        allSupportEligibleRunCount: 'All-support eligible runs',
        completion: 'Completion evidence',
        safety: 'Safety evidence',
        health: 'Health evidence',
        pause: 'Pause evidence',
        fence: 'Fence evidence',
        rollback: 'Rollback evidence',
        pauseAt: 'Paused at',
        fenceAt: 'Fenced at',
        rollbackAt: 'Rolled back at',
        pauseEvidence: 'Pause trigger evidence',
        fenceEvidence: 'Fence trigger evidence',
        rollbackEvidence: 'Rollback trigger evidence',
        fenceReasonCode: 'Fence reason code',
        rollbackReasonCode: 'Rollback reason code',
        dataset: 'Dataset evidence',
        datasetVersion: 'Dataset version',
        datasetHash: 'Dataset hash',
        datasetFreshUntil: 'Dataset fresh until',
        hardGates: 'Hard-gate evidence',
        hardGatePassed: 'Hard gate passed',
        calibration: 'Calibration evidence',
        calibrationStatus: 'Calibration status',
        calibrationPassed: 'Calibration passed',
        calibrationEvidence: 'Calibration evidence values',
        calibrationCounts: 'Projected calibration values',
        calibrationEvidenceCategories: 'Evidence category coverage',
        calibrationCategories: 'Projected category coverage',
        customerDisabled: 'Customer activation remains disabled.'
      },
      rolloutStages: {
        shadow: 'Shadow',
        support_admin: 'Support-admin pilot',
        selected_agents: 'Selected agents',
        all_support: 'All support'
      },
      rolloutStatuses: {
        disabled: 'Disabled',
        enabled: 'Enabled',
        paused: 'Paused',
        fenced: 'Fenced',
        rolled_back: 'Rolled back'
      },
      rolloutEvidence: {
        priorStage: 'Prior-stage completion',
        currentStage: 'Current-stage completion',
        passSummary: '{evaluated} checks, {failures} failures, passed: {status}',
        triggerSummary: '{triggers} triggers, clear: {status}',
        completionSummary: 'Completed: {completed}; safety: {safety}; health: {health}',
        reasonCode: 'Reason code'
      },
      rolloutErrors: {
        list: 'Rollouts are temporarily unavailable.',
        detail: 'This rollout is temporarily unavailable.',
        invalidQuery: 'These rollout filters are invalid.',
        invalidCursor: 'This rollout page is no longer available. Return to the first page.',
        notFound: 'The requested rollout was not found.',
        auditUnavailable: 'Rollout governance audit is temporarily unavailable.',
        rateLimited: 'Too many rollout read requests were made. Try again shortly.',
        invalidResponse: 'The rollout service returned an invalid safe response.',
        revoked: 'Support AI Operations access is no longer available.',
        unavailable: 'Rollout governance is temporarily unavailable.',
        requestFailed: 'The rollout request could not be completed.'
      },
      replays: {
        title: 'Evaluation replays',
        empty: 'No evaluation replays match these filters.',
        select: 'Select a replay to inspect privacy-safe progress and evidence.',
        resultCount: '{count} replays on this page',
        rowLabel: 'Open replay {id} for dataset {dataset}, state {state}',
        loading: 'Loading evaluation replays…',
        error: 'Evaluation replays are temporarily unavailable.',
        stateFilter: 'Replay state',
        evaluationSetFilter: 'Evaluation set ID',
        evaluationSetPlaceholder: '00000000-0000-0000-0000-000000000000',
        replayId: 'Replay ID',
        progress: 'Progress',
        pagination: 'Replay pages',
        page: 'Page'
      },
      replayDetail: {
        title: 'Evaluation replay details',
        select: 'Select a replay to inspect its safe aggregate results.',
        loading: 'Loading replay details…',
        replayId: 'Replay ID',
        progress: 'Progress',
        totalExamples: 'Total examples',
        processedExamples: 'Processed examples',
        passedExamples: 'Passed examples',
        failedExamples: 'Failed examples',
        blockedExamples: 'Blocked examples',
        progressRevision: 'Progress revision',
        started: 'Started',
        completed: 'Completed',
        dataset: 'Evaluation dataset',
        evaluationSetId: 'Evaluation set ID',
        configurations: 'Configuration comparison',
        baselineConfiguration: 'Baseline configuration',
        candidateConfiguration: 'Candidate configuration',
        configurationId: 'Configuration ID',
        configurationHash: 'Configuration hash',
        policyIdentity: 'Policy identity',
        policyHash: 'Policy hash',
        promptIdentity: 'Prompt identity',
        promptHash: 'Prompt hash',
        modelIdentity: 'Model identity',
        modelHash: 'Model hash',
        embeddingIdentity: 'Embedding identity',
        embeddingHash: 'Embedding hash',
        indexVersion: 'Index version',
        indexManifest: 'Index manifest hash',
        thresholdsHash: 'Thresholds hash',
        hardGates: 'Hard-gate evidence',
        baselineComparison: 'Baseline comparison',
        calibration: 'Calibration evidence'
      },
      replayPreflight: {
        title: 'Run evaluation replay',
        description: 'Confirm the fixed evaluation set and resolved baseline and candidate configurations.',
        bootstrapWarning: 'Bootstrap configuration evidence is not release approval. Release remains separately gated.',
        createdReplayReady: 'This replay already exists. Opening it starts no new replay or run.',
        expires: 'Configuration discovery expires',
        validUntil: 'Valid until',
        refresh: 'Refresh configurations',
        confirm: 'Run replay',
        loading: 'Resolving replay configurations…',
        unavailable: 'Replay configuration discovery is unavailable.',
        expired: 'These resolved configurations have expired. Refresh before continuing.',
        notReady: 'A replay cannot start until every configuration blocker is resolved.',
        evaluation: 'Evaluation dataset',
        configurationComparison: 'Resolved configurations',
        baseline: 'Baseline',
        candidate: 'Candidate',
        exampleCount: 'Examples',
        englishCount: 'English examples',
        persianCount: 'Persian examples'
      },
      replayCancel: {
        title: 'Cancel evaluation replay?',
        description: 'Cancellation is authoritative and does not accept a free-text reason.'
      },
      replayTransport: {
        idle: 'Idle',
        live: 'Live',
        reconnecting: 'Reconnecting',
        polling: 'Polling',
        terminal: 'Terminal',
        unavailable: 'Unavailable'
      },
      replayErrors: {
        list: 'The replay list is temporarily unavailable.',
        detail: 'This replay detail is temporarily unavailable.',
        discovery: 'Replay configurations could not be resolved.',
        create: 'The replay could not be created. Try again safely.',
        cancel: 'The replay could not be cancelled. Try again.',
        configurationChanged: 'Replay configurations changed. Review the refreshed comparison before confirming again.',
        datasetUnavailable: 'The evaluation dataset is unavailable for replay.',
        auditUnavailable: 'Replay audit evidence is unavailable.',
        revoked: 'Replay access is no longer available.',
        invalidResponse: 'The replay service returned an invalid safe response.',
        notFound: 'The requested replay was not found.',
        invalidRequest: 'The replay request is no longer valid. Refresh and try again.',
        invalidCursor: 'This replay page is no longer available. Return to the first page.',
        idempotencyConflict: 'This replay request conflicts with an existing request.',
        streamUnavailable: 'Live replay updates are temporarily unavailable.',
        rateLimited: 'Too many replay update connections are active. Polling will continue when available.',
        conflict: 'The replay changed before this action completed. Refresh and try again.',
        unavailable: 'The replay service is temporarily unavailable.',
        navigationFailed: 'The replay was created, but navigation to its detail failed. Open Replays to continue.',
        requestFailed: 'The replay request could not be completed.'
      },
      replayActions: {
        runReplay: 'Run replay',
        backToReplays: 'Back to replays',
        cancel: 'Cancel replay',
        confirm: 'Confirm cancellation',
        keep: 'Keep replay running',
        close: 'Close',
        refreshConfigurations: 'Refresh configurations',
        confirmReplay: 'Confirm replay'
      },
      replayStates: {
        queued: 'Queued',
        running: 'Running',
        completed: 'Completed',
        blocked: 'Blocked',
        failed: 'Failed',
        cancelled: 'Cancelled'
      },
      replayBlockers: {
        candidate_unavailable: 'Candidate configuration is unavailable.',
        baseline_unavailable: 'Baseline configuration is unavailable.',
        runtime_unsupported: 'The resolved runtime does not support replay.',
        replay_configuration_changed: 'A replay configuration changed.',
        configuration_unresolved: 'A required configuration could not be resolved.',
        configuration_mismatch: 'The resolved configurations do not match the replay contract.',
        retrieval_integrity_failed: 'Retrieval integrity requirements are not satisfied.'
      },
      replayHardGates: {
        evaluatedCaseCount: 'Evaluated cases',
        englishCaseCount: 'English cases',
        persianCaseCount: 'Persian cases',
        secretPiiLeakCount: 'Secret or PII leaks',
        criticalUnsafeOutputCount: 'Critical unsafe outputs',
        authorizationFailureCount: 'Authorization failures',
        audienceFailureCount: 'Audience failures',
        crossTicketFailureCount: 'Cross-ticket failures',
        unsafeUrlMarkdownCount: 'Unsafe URL or Markdown outputs',
        factualClaimCount: 'Factual claims',
        supportedFactualClaimCount: 'Supported factual claims',
        retrievalIntegrityPassed: 'Retrieval integrity passed',
        deploymentIntegrityPassed: 'Deployment integrity passed',
        datasetFreshnessPassed: 'Dataset freshness passed'
      },
      replayBaseline: {
        evaluatedCaseCount: 'Evaluated cases',
        baselinePassedCaseCount: 'Baseline passed cases',
        candidatePassedCaseCount: 'Candidate passed cases',
        regressionCount: 'Regressions',
        passed: 'Comparison passed'
      },
      replayCalibration: {
        independentlyLabeledOutcomeCount: 'Independently labeled outcomes',
        englishOutcomeCount: 'English outcomes',
        persianOutcomeCount: 'Persian outcomes',
        heldOutErrorBasisPoints: 'Held-out error (basis points)'
      },
      replayCalibrationCategories: {
        safety: 'Safety',
        privacy: 'Privacy',
        authorization: 'Authorization',
        audience: 'Audience',
        cross_ticket: 'Cross-ticket isolation',
        url_markdown: 'URL and Markdown safety',
        factual_grounding: 'Factual grounding',
        retrieval_integrity: 'Retrieval integrity',
        deployment_integrity: 'Deployment integrity'
      },
      detail: {
        title: 'Run details',
        ticket: 'Ticket',
        request: 'Request ID',
        requester: 'Requester ID',
        conversation: 'Conversation ID',
        operation: 'Operation',
        language: 'Language',
        state: 'State',
        stage: 'Stage',
        cursor: 'Event cursor',
        created: 'Created',
        updated: 'Updated',
        completed: 'Completed',
        blockCategory: 'Block category',
        failureCategory: 'Failure category',
        model: 'Model',
        prompt: 'Prompt version',
        attempts: 'Attempts',
        sources: 'Sources',
        events: 'Safe event history'
      },
      actions: {
        refresh: 'Refresh',
        reset: 'Reset',
        retry: 'Try again',
        previous: 'Previous page',
        next: 'Next page',
        backToRuns: 'Back to runs',
        backToEvaluations: 'Back to evaluations',
        runReplay: 'Run replay',
        backToReplays: 'Back to replays',
        cancelReplay: 'Cancel replay',
        confirmCancelReplay: 'Confirm cancellation',
        keepReplayRunning: 'Keep replay running',
        close: 'Close',
        refreshConfigurations: 'Refresh configurations',
        confirmReplay: 'Confirm replay',
        openCreatedReplay: 'Open created replay',
        backToReleaseCandidates: 'Back to release candidates',
        backToRollouts: 'Back to rollouts',
        openReleaseCandidate: 'Open release candidate'
      },
      status: {
        loading: 'Loading Support AI Operations…',
        refreshed: 'Support AI Operations data updated.'
      },
      errors: {
        summary: 'The operations summary is temporarily unavailable.',
        runs: 'The run queue is temporarily unavailable.',
        detail: 'This run detail is temporarily unavailable.',
        evaluations: 'The evaluation datasets are temporarily unavailable.',
        evaluationDetail: 'This evaluation dataset detail is temporarily unavailable.',
        revoked: 'Support AI Operations access is no longer available.'
      },
      common: {
        notAvailable: 'Not available',
        yes: 'Yes',
        no: 'No'
      }
    },

    // Navigation
    navigation: {
      dashboard: 'Dashboard',
      backToDashboard: 'Back to Dashboard',
      createTicket: 'Create Ticket',
      myTickets: 'My Tickets',
      allTickets: 'All Tickets',
      openTickets: 'Open Tickets',
      inProgress: 'In Progress',
      resolved: 'Resolved'
    },

    // Ticket properties
    ticket: {
      subject: 'Subject',
      description: 'Description',
      status: 'Status',
      priority: 'Priority',
      category: 'Category',
      createdAt: 'Created',
      updatedAt: 'Updated',
      assignedTo: 'Assigned To',
      ticketNumber: 'Ticket #',
      replies: 'Replies',
      attachments: 'Attachments',
      details: 'Ticket Details',
      information: 'Ticket Information',
      createdBy: 'Created By',
      username: 'Username',
      email: 'Email',
      phone: 'Phone',
      notProvided: 'None',
      resolvedAt: 'Resolved At',
      slaDueAt: 'SLA Due At',
      internalNotes: 'Internal Notes',
      addressInfo: 'Address Information',
      customFields: 'Custom Fields',
      selectTicket: 'Select ticket {ticketNumber}',
      read: 'Read',
      unread: 'Unread',
      newBadge: 'NEW',
      updatedBadge: 'Updated',
      unseenByAgents: 'Not viewed by any agent yet',
      updatedSinceView: 'Updated since your last view',
      newCustomerReply: 'New reply',
      newCustomerReplyHint: 'The customer has replied — awaiting your response',
      newAgentReply: 'New reply',
      newAgentReplyHint: 'Support has replied — you have a new response',
      unassigned: 'Unassigned',
      unassignedHint: 'This ticket is not assigned to any agent yet',
      lastAgentViewAt: 'Last viewed by an agent',
      customerLastViewedAt: 'Last viewed by customer',
      cardAriaLabel: 'Ticket {ticketNumber}: {subject}',
      activityBy: 'By: {name}',
      agentReplied: 'Agent replied',
      customerReplied: 'Customer replied',
      supportReplied: 'Support replied',
      youReplied: 'You replied',
      lastUpdated: 'Last updated',
      replyCount: '{count} replies',
      customerContact: 'Customer contact details',
      contactNotProvided: 'No email or phone provided',
      createdLabel: 'Created',
      customerReference: 'Customer {id}',
      unknownCustomer: 'Customer',
      apiTier4PriorityHint: 'API Tier 4 customer — elevated support priority.',
      apiTier5PriorityHint: 'API Tier 5 customer — highest support priority.'
    },

    queue: {
      awaitingAgent: 'Awaiting response',
      neverAnswered: 'Never answered',
      waitingUnder12h: 'Waiting < 12h',
      waiting12To24h: 'Waiting 12–24h',
      waitingOver24h: 'Waiting > 24h',
      neverAnsweredBadge: 'Never answered',
      neverAnsweredHint: 'No agent has sent a public reply to this customer',
      notHandled: 'Not handled',
      userReplied: 'Customer replied',
      waitingForAgent: 'Waiting for agent {duration}',
      waitingAgeAria: 'Customer has been waiting for an agent {duration}',
      aria: {
        awaitingAgent: '{count} tickets awaiting an agent response',
        neverAnswered: '{count} tickets never answered by an agent',
        waitingUnder12h: '{count} tickets waiting less than 12 hours',
        waiting12To24h: '{count} tickets waiting between 12 and 24 hours',
        waitingOver24h: '{count} tickets waiting more than 24 hours'
      }
    },

    account: {
      title: 'Customer Account',
      joinedDate: 'Joined',
      totalPaid: 'Total paid (units)',
      subscriptionType: 'Subscription type',
      subscriptionStart: 'Subscription started',
      subscriptionEnd: 'Subscription ends',
      apiTier: 'API tier',
      active: 'Active',
      expired: 'Expired',
      noSubscription: 'No subscription'
    },

    customerAdmin: {
      title: 'Customer administration center',
      open: 'Open administration center',
      openAria: 'Open the administration center for the customer on ticket {ticket}',
      staffOnly: 'Support agents and admins only',
      sectionNavigation: 'Customer administration sections',
      ticketScopedIdentity: 'Customer identity is fixed by this ticket',
      userScopedIdentity: 'Customer resolved by account id (support search)',
      privacyTitle: 'Sensitive, audited access',
      privacyNotice:
        'Data is demand-loaded for ticket {ticket}. Every successful read is audited and cleared when this window closes.',
      privacyNoticeUser:
        'Data is demand-loaded for this customer account. Every successful read is audited and cleared when this window closes.',
      loadingSection: 'Loading customer administration data',
      refreshingSection: 'Refreshing this section…',
      refreshSection: 'Refresh {section}',
      sectionLoaded: '{section} loaded',
      scrollableTable: 'Scrollable customer administration table',
      scrollHint: 'Scroll horizontally to see more columns. Expand a row for lifecycle and financial details.',
      accountActions: {
        menuAria: 'Contact and account actions for {customer}',
        copyEmail: 'Copy email',
        emailCopied: 'Customer email copied',
        copyPhone: 'Copy phone number',
        phoneCopied: 'Customer phone number copied',
        copyId: 'Copy account ID',
        idCopied: 'Account ID copied',
        copyFailed: 'Could not copy the customer information',
        openManagement: 'Open account management in a new tab'
      },
      sections: {
        overview: 'Account overview',
        tickets: 'Tickets',
        credits: 'Credits & packages',
        activity: 'API activity',
        apiKeys: 'API keys',
        payments: 'Payments',
        affiliates: 'Affiliate',
        reports: 'Reports'
      },
      sectionDescriptions: {
        overview: 'Review identity, account state, verification, usage totals, and subscription context.',
        tickets: 'Review the customer\u2019s recent tickets, their stages, and likely duplicate submissions.',
        credits: 'Inspect current balances, grants, purchased packages, expiry, and service scope.',
        activity: 'Analyze request volume, token usage, cost, models, providers, and service tiers.',
        apiKeys: 'Review masked key inventory, operational status, limits, budgets, and last use.',
        payments: 'Filter and inspect customer transactions, lifecycle states, amounts, and safe failure context.',
        affiliates: 'Review referral performance, commissions, withdrawals, and lifecycle details.',
        reports: 'Create customer-visible usage reports and manage their delivery and download state.'
      },
      tickets: {
        total: 'Total',
        open: 'Open',
        empty: 'This customer has no tickets.',
        noSubject: '(no subject)',
        truncated: 'Showing the {count} most recent tickets',
        duplicatesTitle: 'Possible duplicate tickets ({count})',
        duplicateCount: '{count} tickets ({open} open) opened close together',
        actions: {
          menuAria: 'Actions for ticket {ticket}',
          copyId: 'Copy ticket ID',
          copied: 'Ticket {ticket} copied',
          copyFailed: 'Could not copy the ticket ID',
          openManagement: 'Open in ticket management'
        },
        columns: {
          ticket: 'Ticket',
          subject: 'Subject',
          status: 'Status',
          priority: 'Priority',
          category: 'Category',
          created: 'Created'
        }
      },
      search: {
        launch: 'Find customer',
        openAria: 'Search for a customer and open the administration center',
        title: 'Find a customer',
        notice: 'Search by username, email, or phone to open the administration center for any account.',
        placeholder: 'Username, email, or phone…',
        submit: 'Search',
        minLength: 'Enter at least {count} characters',
        fastHint: 'Enter a full phone number or email, or the start of a username, then press Search.',
        searching: 'Searching…',
        prompt: 'Start typing to search customers.',
        noResults: 'No matching customers found.',
        truncated: 'More matches exist — refine your search.',
        error: 'Search failed. Please try again.',
        open: 'Open',
        copyId: 'Copy id',
        idCopied: 'Customer id copied',
        openTickets: '{count} open',
        deepHint: 'Deleted accounts are only found by a deep search, which scans every field and is slower.',
        deepSubmit: 'Deep search',
        deepBadge: 'Deep search',
        matchedBy: {
          phone: 'Matched by phone',
          email: 'Matched by email',
          username: 'Matched by username',
          deep: 'Deep search'
        },
        state: {
          active: 'Active',
          deleted: 'Deleted',
          suspended: 'Suspended',
          inactive: 'Inactive',
          guest: 'Guest'
        }
      },
      common: {
        yes: 'Yes',
        no: 'No',
        retry: 'Retry',
        noRecords: 'No records found',
        confirm: 'Confirm',
        cancel: 'Cancel'
      },
      timeframes: {
        lastHour: 'Last hour',
        last6Hours: 'Last 6 hours',
        last12Hours: 'Last 12 hours',
        lastDay: 'Last 24 hours',
        last2Days: 'Last 2 days',
        last3Days: 'Last 3 days',
        lastWeek: 'Last 7 days',
        last28Days: 'Last 28 days',
        last30Days: 'Last 30 days',
        lastMonth: 'Last month',
        last3Months: 'Last 3 months',
        hours: '{count} hours'
      },
      purchaseItems: {
        api: 'API credit',
        credit_package: 'Credit package',
        tier1: 'Tier 1',
        tier2: 'Plus',
        tier2_30: 'Plus · 30 days',
        tier2_90: 'Plus · 90 days',
        tier2_180: 'Plus · 180 days',
        tier2_365: 'Plus · 365 days',
        tier3: 'Tier 3'
      },
      fields: {
        fullName: 'Full name',
        joinedAt: 'Joined',
        lastLogin: 'Last login',
        country: 'Country',
        accountType: 'Account type',
        registrationMethod: 'Registration method',
        language: 'Language',
        updatedAt: 'Updated',
        name: 'Name',
        scope: 'Scope',
        status: 'Status',
        lastUsed: 'Last used',
        model: 'Model',
        provider: 'Provider',
        serviceTier: 'Service tier',
        type: 'Type',
        amount: 'Amount',
        details: 'Details',
        createdAt: 'Created',
        expiresAt: 'Expires',
        trackingCode: 'Tracking code',
        actions: 'Actions'
      },
      overview: {
        verification: 'Verification and security indicators',
        emailVerified: 'Email verification',
        phoneVerified: 'Phone verification',
        googleVerified: 'Google email verification',
        twoFactor: 'Two-factor authentication',
        suspended: 'Suspended',
        deleted: 'Deleted',
        guest: 'Guest account',
        dataConsent: 'Data-usage consent',
        totalPaid: 'Total paid',
        suspensionDate: 'Suspended at',
        suspensionReason: 'Safe suspension reason',
        deletedAt: 'Deleted at',
        chats: 'Active chats',
        messages: 'Active messages',
        apiKeys: 'API keys',
        activeApiKeys: 'Active API keys',
        subscription: 'Subscription',
        periodDays: 'Period (days)'
      },
      credits: {
        noCredit: 'No credit account found',
        remainingIrt: 'Remaining IRT',
        remainingUnit: 'Remaining UNIT',
        limit: 'Credit limit',
        grants: 'Credit grants',
        packages: 'Purchased packages',
        updatedAt: 'Credit updated',
        lastToppedUp: 'Last topped up',
        linkedOrganization: 'Uses linked organization credit',
        exhausted: 'Exhausted',
        price: 'Purchase price',
        discount: 'Discount',
        purchasedAt: 'Purchased',
        instrument: 'Instrument',
        packageInstanceId: 'Purchased package ID',
        packageTemplateId: 'Package template ID',
        noPackageTemplate: 'No linked template',
        allowedServices: 'Allowed services',
        allServices: 'All services',
        scopeDetails: 'Scope details',
        unrestrictedScope: 'No scoped restrictions',
        openPackageDetails: 'Open details for {package}',
        filterByStatus: 'Filter by status',
        searchPlaceholder: 'Search by name, purchased ID, or template ID',
        visibleCount: 'Showing {visible} of {total}',
        extend: {
          button: 'Extend',
          packageTitle: 'Extend credit package',
          grantTitle: 'Extend grant',
          target: 'Instrument',
          newEndDate: 'New expiry date',
          datePlaceholder: 'Select a future date',
          policyNotice:
            'Extending only moves the expiry date forward and reactivates the instrument. It never changes the remaining balance or amount.',
          clearRevoked: 'Revoked',
          clearRevokedHint: 'Also clear the revoked flag',
          clearSuspended: 'Suspended',
          clearSuspendedHint: 'Also clear the suspended flag',
          success: 'Expiry extended successfully',
          errors: {
            packageNotFound: 'This credit package could not be found for this customer.',
            grantNotFound: 'This grant could not be found for this customer.',
            invalidEndDate: 'The new expiry date must be in the future.',
            endDateTooFar: 'The new expiry date is too far in the future (max 365 days).',
            invalidActor: 'Your account is not eligible to perform this action.',
            unavailable: 'The extension could not be completed. Please try again.'
          }
        }
      },
      metrics: {
        requests: 'Requests',
        successful: 'Successful',
        successRate: 'Success rate',
        failed: 'Failed',
        tokens: 'Tokens',
        costUnit: 'Cost (UNIT)',
        paidUnit: 'Paid (UNIT)',
        paidIrt: 'Paid (IRT)',
        paidGrantIrt: 'Paid by grant (IRT)',
        promptTokens: 'Prompt tokens',
        completionTokens: 'Completion tokens',
        reasoningTokens: 'Reasoning tokens',
        cachedTokens: 'Cached tokens'
      },
      activity: {
        models: 'Model usage',
        providers: 'Providers',
        serviceTiers: 'Service tiers',
        tokenBreakdown: 'Token breakdown'
      },
      apiKeys: {
        maskedKey: 'Masked key',
        models: 'Models',
        endpoints: 'Endpoints',
        monthlyQuota: 'Monthly quota',
        totalBudget: 'Total budget',
        budgetUsed: 'Budget used',
        internal: 'Internal key',
        maskingNotice: 'Only masked key metadata is available. Raw API keys and IP restrictions are never exposed.'
      },
      filters: {
        any: 'Any',
        apply: 'Apply filters',
        clear: 'Clear filters',
        activeCount: '{count} active filters',
        confirmed: 'Confirmed',
        failed: 'Failed',
        hasError: 'Has error',
        dateRange: 'Date range',
        status: 'Filter by status'
      },
      payments: {
        tracking: 'Payment identifier',
        trackingPlaceholder: 'Exact numeric ID, transaction UUID, or tracking code',
        paymentId: 'Payment ID',
        transactionId: 'Transaction ID',
        item: 'Purchase item',
        amount: 'Amount',
        discountAmount: 'Discount amount',
        netAmount: 'Net amount',
        paidAmount: 'Paid amount',
        method: 'Method',
        paymentType: 'Payment type',
        vat: 'VAT required',
        confirmedAt: 'Confirmed at',
        failedAt: 'Failed at',
        failureReason: 'Safe failure reason',
        bankDetails: 'Bank transaction details',
        recheck: 'Recheck',
        recheckConfirmTitle: 'Recheck this payment?',
        recheckConfirmDescription:
          "This asks the payment provider to verify {identifier} again and may confirm the payment and apply the customer's purchase. The attempt is audited.",
        recheckConfirmAction: 'Recheck payment',
        recheckConfirmed: 'The provider confirmed the payment. The payment record has been refreshed.',
        recheckNotConfirmed: 'The provider did not confirm the payment. The latest payment state is shown.',
        recheckUnavailable: 'This payment cannot be rechecked in its current state.',
        recheckRateLimited: 'Too many payment rechecks. Wait a moment and try again.',
        recheckFailed: 'The payment could not be rechecked. No provider details were exposed.',
        recheckIneligible: {
          already_confirmed: 'This payment is already confirmed.',
          missing_tracking: 'This payment has no tracking code to verify.',
          unavailable: 'This payment is not linked to a verifiable provider transaction.'
        }
      },
      recordTypes: {
        all: 'All records',
        commission: 'Commissions',
        withdrawal: 'Withdrawals'
      },
      affiliates: {
        referral: 'Referral summary',
        code: 'Referral code',
        createdAt: 'Referral created',
        lastSuccessful: 'Last successful referral',
        completedAt: 'Completed at',
        rejectedAt: 'Rejected at',
        totalReferrals: 'Total referrals',
        successfulReferrals: 'Successful referrals',
        earnings: 'Total earnings',
        confirmed_commission: 'Confirmed commission',
        pending_commission: 'Pending commission',
        withdrawn: 'Withdrawn',
        pending_withdrawal: 'Pending withdrawal'
      },
      reports: {
        generate: 'Generate report',
        generateCustomerVisible: 'Generate customer-visible report',
        frame: 'Time frame',
        language: 'Language',
        origin: 'Origin',
        expiresAt: 'Expires',
        copyLink: 'Copy customer link',
        download: 'Download',
        created: 'Customer report submitted',
        statusUpdated: 'A pending report changed status.',
        submitSummary:
          'This creates a {frame} report in {language} for the customer and adds it to their Reports page.',
        unavailable_pending: 'The report is still being generated.',
        unavailable_failed: 'The report failed and cannot be downloaded.',
        unavailable_completed: 'The report file is unavailable or expired.',
        linkCopied: 'Customer-facing report link copied',
        copyFailed: 'Could not copy the report link',
        downloadFailed: 'Could not download the report',
        customerVisibleNotice:
          'Support-generated reports belong to this customer and appear in their existing Reports page. The shared link is an authenticated platform link, never a storage URL.'
      },
      origins: {
        self_service: 'Self service',
        support: 'Support'
      },
      status: {
        total: 'Total',
        yes: 'Yes',
        no: 'No',
        enabled: 'Enabled',
        disabled: 'Disabled',
        active: 'Active',
        inactive: 'Inactive',
        revoked: 'Revoked',
        suspended: 'Suspended',
        expired: 'Expired',
        draft: 'Draft',
        locked: 'Locked',
        processing: 'Processing',
        confirmed: 'Confirmed',
        pending: 'Pending',
        completed: 'Completed',
        rejected: 'Rejected',
        cancelled: 'Cancelled',
        failed: 'Failed'
      },
      validation: {
        tracking:
          'Enter an exact numeric payment ID, transaction UUID, or tracking code using only letters, numbers, period, underscore, colon, slash, or hyphen.',
        dateRange: 'Choose a chronological date range no longer than 366 days.',
        confirmedAndFailed: 'A payment cannot be both confirmed and failed.',
        confirmedStateFailed: 'A confirmed payment state cannot also be filtered as failed.',
        failedStateConfirmed: 'A failed payment state cannot also be filtered as confirmed.'
      },
      gatewayBypass: {
        title: 'Gateway card-to-mobile bypass',
        status: 'Current status',
        enabled: 'Bypass enabled',
        disabled: 'Bypass disabled',
        description:
          'When enabled, this trusted customer bypasses Zibal card-to-mobile verification for purchase payments. It does not bypass the weekly unverified-phone payment limit.',
        enableAction: 'Enable bypass',
        disableAction: 'Disable bypass',
        confirmTitle: 'Change gateway bypass?',
        confirmEnable:
          'Enable the card-to-mobile verification bypass for this customer? Only do this for vetted, trusted accounts.',
        confirmDisable: 'Disable the card-to-mobile verification bypass for this customer?',
        enabledSuccess: 'Gateway bypass enabled for this customer.',
        disabledSuccess: 'Gateway bypass disabled for this customer.',
        unavailable: 'The gateway bypass could not be changed for this customer.'
      },
      subscription: {
        title: 'Plus subscription cancellation and refund',
        noPaidSubscription: 'This customer has no active paid subscription.',
        remainingDays: 'Remaining days',
        estimatedRefund: 'Estimated refund',
        purchasedAt: 'Purchase date',
        payment: 'Associated payment',
        bankDetails: 'Bank transaction details',
        refundTitle: 'Refund processed',
        refundAmount: 'Refund amount',
        paidAmount: 'Amount actually paid',
        cancelAction: 'Cancel subscription and refund',
        notCancellable:
          'This subscription cannot be cancelled here. Only active Plus (tier2) subscriptions with a tracked payment are eligible.',
        cancelModalTitle: 'Cancel Plus subscription',
        cancelWarning:
          'This immediately ends the subscription, removes remaining subscription grants, and computes the refund. This action cannot be undone.',
        trackingConfirmLabel: 'Type the payment tracking code to confirm',
        trackingConfirmHint:
          'The cancel button unlocks only when the typed tracking code matches the subscription payment exactly.',
        cancelConfirmAction: 'Cancel and refund',
        cancelSuccess: 'Subscription cancelled and refund computed.',
        cancelUnavailable: 'The subscription could not be cancelled. Check the tracking code and subscription state.',
        policy: {
          title: 'Refund policy',
          elapsed: 'Elapsed since purchase',
          daysUnit: 'days',
          refundAmount: 'Refund by policy',
          full24h: 'Full refund (within 24h)',
          full3d: 'Full refund (within 3 days)',
          prorated: 'Prorated refund',
          ineligible: 'Not automatically computable'
        },
        templates: {
          copyButton: 'Copy response template',
          proposal: 'Refund proposal (Persian)',
          done: 'Refund completed (Persian)',
          copied: 'Template copied to clipboard.',
          copyFailed: 'Could not copy the template to the clipboard.'
        }
      },
      errors: {
        title: 'Unable to load this section',
        refreshTitle: 'This section could not be refreshed',
        forbidden: 'Your support-admin permission could not be verified.',
        notFound: 'The ticket or customer-scoped record was not found.',
        rateLimited: 'Too many sensitive requests. Wait a moment and retry.',
        loadFailed: 'Sensitive customer data is temporarily unavailable.',
        writeFailed: 'The operation could not be completed.',
        writeQuotaExceeded: 'You have reached the daily limit for sensitive support write actions.'
      }
    },

    // Status values
    statuses: {
      open: 'Open',
      inProgress: 'In Progress',
      waitingCustomer: 'Waiting for Customer',
      waitingForAgent: 'Waiting for Agent',
      resolved: 'Resolved',
      closed: 'Closed'
    },

    // Status values (alternative format for compatibility)
    status: {
      open: 'Open',
      in_progress: 'In Progress',
      inProgress: 'In Progress',
      waiting_customer: 'Waiting for Customer',
      waitingCustomer: 'Waiting for Customer',
      waiting_for_agent: 'Waiting for Agent',
      waitingForAgent: 'Waiting for Agent',
      resolved: 'Resolved',
      closed: 'Closed'
    },

    // Priority values
    priorities: {
      low: 'Basic',
      medium: 'Medium',
      high: 'High',
      critical: 'Critical'
    },

    // Priority values (alternative format for compatibility)
    priority: {
      low: 'Basic',
      medium: 'Medium',
      high: 'High',
      critical: 'Critical'
    },

    // Categories
    categories: {
      title: 'Support Categories',
      technical: 'Technical Issue',
      billing: 'Billing',
      account: 'Account',
      feature: 'Feature Request',
      bug: 'Bug Report',
      other: 'Other'
    },

    // Actions
    actions: {
      create: 'Create Ticket',
      reply: 'Reply',
      previewReply: 'Preview Reply',
      attach: 'Attach File',
      filter: 'Filter',
      search: 'Search tickets...',
      submit: 'Submit',
      cancel: 'Cancel',
      save: 'Save',
      edit: 'Edit',
      delete: 'Delete',
      close: 'Close Ticket',
      reopen: 'Reopen Ticket',
      closeTicket: 'Close Ticket',
      reopenTicket: 'Reopen Ticket',
      moreActions: 'More Actions',
      assign: 'Assign',
      viewDetails: 'View Details',
      downloadAttachment: 'Download',
      viewAll: 'View All',
      back: 'Back',
      changeStatus: 'Change Status',
      changePriority: 'Change Priority',
      download: 'Download',
      searchAll: 'Search all tickets...',
      clearFilters: 'Clear Filters',
      retryNow: 'Retry Now',
      refresh: 'Refresh',
      refreshDashboardStats: 'Refresh dashboard statistics',
      refreshTicketDetails: 'Refresh ticket details',
      assignTicket: 'Open assignment controls for ticket {ticketNumber}',
      changeTicketStatus: 'Open status controls for ticket {ticketNumber}',
      ticketsRefreshed: 'Tickets refreshed',
      createTicket: 'Create Ticket',
      yes: 'Yes',
      no: 'No',
      resolveAndReply: 'Resolve and Reply',
      closeAndReply: 'Close and Reply'
    },

    // Preview modal for agent replies
    preview: {
      title: 'Reply Preview',
      subtitle: 'Review your reply before sending',
      internalNoteTitle: 'Internal Note Preview',
      replyContent: 'Reply Content',
      internalReply: 'Internal Note',
      publicReply: 'Public Reply',
      internalNote: 'This is an internal note and will only be visible to agents',
      publicNote: 'This reply will be visible to the customer',
      agentsOnly: 'Agents Only',
      characters: 'characters',
      statusChange: 'Status will change to',
      currentStatus: 'Current',
      confirmTitle: 'Ready to send?',
      confirmMessage:
        'Please review the content above carefully before sending. Once sent, this reply will be visible to the customer.',
      confirmMessageInternal:
        'This internal note will only be visible to agents and support staff. The customer will not see this message.',
      checkContent: 'I have reviewed the content for accuracy',
      checkTone: 'The tone is professional and helpful',
      checkCustomerVisible: 'I understand this will be visible to the customer',
      unmodifiedTemplateTitle: 'Unedited template detected',
      unmodifiedTemplateMessage:
        'You have not modified the inserted template or canned response. Please check and ensure this is the correct reply for this ticket before proceeding.',
      unmodifiedTemplateAcknowledge:
        'I understand I have not modified this template/canned response and confirm it is the correct reply',
      edit: 'Edit Reply',
      confirm: 'Send Reply',
      sendInternal: 'Send Internal Note',
      escToCancel: 'Press Esc to cancel'
    },

    // Forms
    forms: {
      subjectPlaceholder: 'Enter ticket subject',
      descriptionPlaceholder: 'Describe the issue...',
      replyPlaceholder: 'Type your reply...',
      selectCategory: 'Select a category',
      selectPriority: 'Select priority',
      selectOption: 'Select option',
      emailPlaceholder: 'name@example.com',
      cardNumberPlaceholder: '0000 0000 0000 0000',
      cardNumberLabel: 'Full 16-Digit Card Number',
      cardNumberHelp: 'Enter the full 16-digit card number.',
      ibanPlaceholder: 'IR 0000 0000 0000 0000 0000 00',
      fileUpload: 'Upload files',
      dragDropFiles: 'Drag and drop files here or click to browse',
      maxFileSize: 'Maximum file size: {size}MB',
      allowedTypes: 'Allowed file types: {types}',
      useTemplate: 'Use Template',
      selectTemplate: 'Select a template',
      cannedResponses: 'Canned Responses',
      selectCannedResponse: 'Select a canned response',
      categorySpecificFields: 'Category-specific fields',
      dynamicOptionsLoadError:
        'Could not load suggestions for this field. You can still enter a value manually if supported.',
      dynamicOptionsEmpty: 'No suggestions are available.',
      dynamicManualEntryHint: 'For a custom value, type it and press Enter.',
      unsupportedFieldType: 'Unsupported field type: {type}',
      unsupportedFieldContactSupport: 'This field type is not supported. Please contact support.'
    },

    customerAI: {
      initialResponseLabel: 'Request an AI-assisted initial response',
      initialResponseDisclosure:
        'AI can make mistakes. Responses use official AvalAI sources, and human review remains available.',
      queuedTitle: 'AI response queued',
      queuedNote: 'An AI-assisted response is being prepared. You can continue using support while it is processed.',
      replyDisclosure: 'This response was prepared by AvalAI AI and may contain mistakes.',
      sources: 'Sources',
      thumbsUp: 'Helpful response',
      thumbsDown: 'Not helpful',
      requestAgentReview: 'Request agent review',
      feedbackReason: 'Reason',
      feedbackComment: 'Additional details (optional)',
      submitFeedback: 'Submit feedback',
      cancelFeedback: 'Cancel',
      statusLoading: 'Checking the AI response status.',
      statusPending: 'An AI response is being prepared.',
      statusClarification: 'The AI response needs clarification from you.',
      statusHumanRequired: 'An agent needs to review this ticket.',
      statusHumanRequested: 'Agent review has been requested.',
      statusStopped: 'Automated responses have stopped.',
      statusAnswered: 'The AI response is available in the conversation.',
      statusNotRequested: 'No automated response is in progress.',
      feedbackReasons: {
        incorrect: 'Incorrect',
        outdated: 'Outdated',
        unhelpful: 'Unhelpful',
        unclear: 'Unclear',
        other: 'Other'
      },
      errors: {
        unavailable: 'AI response status is temporarily unavailable.',
        feedback: 'Feedback could not be saved. Try again.'
      },
      humanReview: {
        title: 'Request agent review?',
        confirmHistory:
          'Automated responses will stop. The existing conversation and response history will remain available.',
        confirm: 'Request review',
        cancel: 'Cancel',
        success: 'Agent review requested.',
        error: 'Agent review could not be requested. Try again.'
      },
      agentQueue: {
        state: 'AI state',
        feedback: 'Current feedback',
        responses: 'AI responses'
      },
      agentMeta: {
        answer: 'AI answer',
        clarification: 'AI clarification',
        grounded: 'Grounded',
        not_required: 'Sources not required',
        voteUp: 'Helpful vote',
        voteDown: 'Not helpful vote',
        humanPending: 'Human review pending',
        stopReasons: {
          enrolled: 'AI response enrolled',
          attempt_started: 'AI attempt started',
          answer_published: 'AI answer published',
          clarification_published: 'AI clarification published',
          clarification_answered: 'Clarification answered',
          customer_request: 'Stopped by customer request',
          human_activity: 'Stopped after human activity',
          policy_block: 'Stopped by policy',
          provider_failure: 'Stopped after provider failure',
          stale_ticket: 'Stopped because the ticket changed',
          disabled: 'Customer AI disabled',
          retention_cleanup: 'Stopped by retention cleanup'
        }
      }
    },

    // Priority selection guidance (create ticket)
    priorityGuide: {
      infoLabel: 'How ticket priority works',
      infoTrigger: 'Learn more',
      currentMax: 'Your plan can set priority up to {level}.',
      lockedTooltip: "{level} priority isn't available on your current plan.",
      lockedOption: '{level} (upgrade required)',
      modalTitle: 'Choosing the right priority',
      modalIntro:
        'Priority helps our support team understand how urgent your issue is. Higher priority levels are reserved for accounts with a Plus subscription or a higher API access level, so our team can respond to the most time-sensitive cases first.',
      yourAccess: 'Your current access',
      yourAccessLow:
        'Your account can create tickets with Basic priority. This is perfect for general questions and non-urgent requests.',
      yourAccessMedium:
        'Your account can set priority up to Medium — thank you for being a Plus member or reaching API access level 3.',
      yourAccessHigh: 'Your account can set priority up to High, thanks to your API access level 4.',
      yourAccessCritical:
        'Your account can set priority up to Critical, the highest level, thanks to your API access level 5.',
      unlockedBySubscription: 'Unlocked by your Plus subscription',
      unlockedByApiTier: 'Unlocked by your API access level',
      ladderTitle: 'Priority levels',
      levels: {
        lowTitle: 'Basic',
        lowRequirement: 'Available to everyone',
        lowDescription: 'General questions and non-urgent requests.',
        mediumTitle: 'Medium',
        mediumRequirement: 'Plus subscription or API access level 3+',
        mediumDescription: 'Issues affecting your work that can wait a short while.',
        highTitle: 'High',
        highRequirement: 'API access level 4+',
        highDescription: 'Significant problems that need prompt attention.',
        criticalTitle: 'Critical',
        criticalRequirement: 'API access level 5',
        criticalDescription: 'Urgent, business-impacting outages.'
      },
      availableBadge: 'Available on your plan',
      lockedBadge: 'Not on your plan',
      upgradeTitle: 'Need higher priority?',
      upgradeDescription:
        'Upgrade to a Plus subscription or raise your API access level to unlock higher priority levels.',
      viewPlusPlans: 'View Plus plans',
      viewApiTiers: 'View API access levels',
      agentNote:
        "Our support agents can adjust the priority of any ticket after it's created, so please don't worry if you can't select the level you'd like.",
      close: 'Got it'
    },

    // Filters
    filters: {
      title: 'Filters',
      status: 'Status',
      statusHint: "Filter the agent queue by the ticket's current workflow status.",
      allStatuses: 'All statuses',
      priority: 'Priority',
      category: 'Category',
      dateRange: 'Date Range',
      assignedTo: 'Assigned To',
      createdBy: 'Created By',
      clearFilters: 'Clear Filters',
      applyFilters: 'Apply Filters',
      showFilters: 'Show Filters',
      hideFilters: 'Hide Filters',
      activeFilters: 'Active Filters',
      search: 'Search',
      searchPlaceholder: 'Search tickets, email, or phone…',
      searchHint: 'Search ticket text and numbers, or paste a complete customer email or phone number.',
      searchSubmit: 'Search',
      unassigned: 'Unassigned',
      assignedToMe: 'Assigned to Me',
      assignee: 'Assignee',
      customerAccount: 'Customer account',
      apiAccounts: 'API access level',
      chatAccounts: 'Chat subscription',
      apiTier: 'API tier',
      apiTierZero: 'API not activated',
      apiTier0: 'API Tier 0',
      apiTier1: 'API Tier 1',
      apiTier2: 'API Tier 2',
      apiTier3: 'API Tier 3',
      apiTier4: 'API Tier 4',
      apiTier5: 'API Tier 5',
      plusSubscription: 'Plus subscription',
      freeAccount: 'Free account',
      collaboration: 'Support tracking',
      needsHumanReview: 'Needs human review'
    },

    // View modes
    viewModes: {
      grid: 'Grid View',
      list: 'List View'
    },

    // Views
    views: {
      grid: 'Grid',
      list: 'List'
    },

    // Sorting
    sorting: {
      sortBy: 'Sort by',
      newest: 'Newest First',
      oldest: 'Oldest First',
      priority: 'Priority',
      status: 'Status',
      updated: 'Recently Updated',
      createdAt: 'Created Date',
      updatedAt: 'Updated Date',
      subject: 'Subject',
      recommended: 'Recommended priority',
      waitingTime: 'Waiting time',
      ascending: 'Sort ascending',
      descending: 'Sort descending'
    },

    // Messages
    messages: {
      noTickets: 'No tickets found',
      noTicketsDescription: "You haven't created any support tickets yet.",
      ticketCreated: 'Ticket created successfully',
      ticketUpdated: 'Ticket updated successfully',
      replyAdded: 'Reply added successfully',
      fileUploaded: 'File uploaded successfully',
      ticketClosed: 'Ticket closed successfully',
      ticketReopened: 'Ticket reopened successfully',
      confirmCloseTicket:
        'Are you sure you want to close this ticket? This will prevent further replies until the ticket is reopened.',
      confirmReopenTicket: 'Are you sure you want to reopen this ticket? This will allow new replies to be added.',
      errorClosingTicket: 'Failed to close ticket',
      errorReopeningTicket: 'Failed to reopen ticket',
      loadingTickets: 'Loading tickets...',
      loadingTicket: 'Loading ticket details...',
      errorLoadingTickets: 'Failed to load tickets',
      errorLoadingTicket: 'Failed to load ticket details',
      errorLoadingDashboard: 'Failed to load support dashboard',
      profileUnavailable: 'Support profile is temporarily unavailable.',
      statisticsUnavailable: 'Support statistics are temporarily unavailable.',
      ticketNotFoundWithNumber: 'Ticket #{ticketNumber} was not found. It may have been deleted.',
      ticketLoadFailedWithNumber: 'Failed to load ticket #{ticketNumber}. Please try again.',
      errorRefreshingDashboardStats: 'Failed to refresh dashboard stats',
      errorCreatingTicket: 'Failed to create ticket',
      errorAddingReply: 'Failed to add reply',
      aiReplySubmissionUncertain:
        'The reply may have been sent. Retry without changing it, or refresh the ticket before sending a different reply.',
      aiReplyChangedAfterUncertainSubmission:
        'This reply changed after an uncertain send. Refresh the ticket before sending the edited version.',
      statusUpdated: 'Status updated successfully',
      errorUpdatingStatus: 'Failed to update status',
      priorityUpdated: 'Priority updated successfully',
      errorUpdatingPriority: 'Failed to update priority',
      ticketAssigned: 'Ticket assigned successfully',
      ticketUnassigned: 'Ticket unassigned successfully',
      errorAssigningTicket: 'Failed to assign ticket',
      ticketNotFound: 'Ticket Not Found',
      ticketNotFoundDesc: "The ticket you're looking for doesn't exist or you don't have permission to view it.",
      retrySuccess: 'Operation completed successfully',
      retryFailed: 'Retry failed. Please try again.',
      resetSuccess: 'Reset completed successfully',
      resetFailed: 'Reset failed. Please try again.',
      ticketsRefreshed: 'Tickets refreshed successfully',
      loadError: 'Failed to load data. Please try again.',
      searchError: 'Search failed. Please try again.',
      feedbackError: 'Failed to submit feedback. Please try again.',
      exportSuccess: 'Tickets exported successfully',
      exportError: 'Failed to export tickets',
      networkError: 'Network error. Please check your connection and try again.'
    },

    // Dashboard
    dashboard: {
      title: 'Support',
      returnToChat: 'Return to Chat',
      returnToChatHint: 'Manage your support requests here, then return to your conversations at any time.',
      overview: 'Overview',
      myStats: 'My Statistics',
      recentActivity: 'Recent Activity',
      quickActions: 'Quick Actions',
      totalTickets: 'Total Tickets',
      openTickets: 'Open Tickets',
      resolvedTickets: 'Resolved Tickets',
      avgResponseTime: 'Avg Response Time'
    },

    // Ticket details
    ticketDetails: {
      conversation: 'Conversation',
      information: 'Ticket Information',
      createdBy: 'Created by',
      assignedTo: 'Assigned to',
      lastUpdated: 'Last updated',
      timeSpent: 'Time spent',
      slaStatus: 'SLA Status',
      onTime: 'On Time',
      overdue: 'Overdue',
      dueIn: 'Due in {time}',
      toggleInformation: 'Toggle ticket information'
    },

    // Message and reply types
    message: {
      original: 'Original Message',
      viewRaw: 'View raw text',
      viewFormatted: 'View formatted',
      copy: 'Copy message',
      copyFormatted: 'Copy',
      copyRaw: 'Copy raw text',
      copiedFormatted: 'Content copied',
      copiedRaw: 'Raw text copied',
      copyFailed: 'Message could not be copied'
    },

    replyType: {
      public: 'Public',
      internal: 'Internal'
    },

    // Reply form labels
    reply: {
      type: 'Reply Type',
      public: 'Public Reply',
      internal: 'Internal Note',
      templateLanguage: 'Template language',
      templateFa: 'فارسی',
      templateEn: 'English',
      resetTemplate: 'Reset template',
      resetTemplateConfirm: 'Resetting will replace your current draft with the empty reply template. Continue?',
      templateHint: 'Write your reply between the greeting and the closing lines.',
      refreshTemplates: 'Refresh templates',
      refreshCannedResponses: 'Refresh responses',
      searchCannedResponses: 'Search responses by title, content, or category',
      cannedResponsesLoading: 'Loading canned responses…',
      cannedResponsesEmpty: 'No canned responses are available. Try refreshing.',
      cannedResponsesNoResults: 'No canned responses match your search.',
      clearCannedResponse: 'Clear selection',
      insertCannedResponse: 'Insert into draft',
      replaceCannedResponse: 'Replace body',
      appendCannedResponse: 'Append',
      cannedRelevance: {
        category: 'Recommended for this category',
        general: 'General response',
        other: 'Other category'
      },
      templatesUnavailable:
        'Reply templates are currently unavailable. You can still write a free-form reply, or try refreshing the templates.',
      scenario: 'Response scenario',
      selectScenario: 'Insert a scenario template',
      suggestedScenario: 'Suggested for this ticket: {title}',
      customFieldSummary: 'Ticket details provided by customer',
      insertCustomFieldSummary: 'Insert details'
    },

    aiAssistant: {
      title: 'AI assistant',
      suggestions: 'Suggestions',
      chat: 'Conversation',
      sources: 'Sources',
      operations: {
        chat: 'Conversation',
        generate_reply: 'Generate reply',
        improve: 'Improve draft',
        shorten: 'Shorten draft',
        expand: 'Expand draft',
        change_tone: 'Change tone',
        translate: 'Translate',
        custom: 'Custom instruction'
      },
      tones: {
        professional: 'Professional',
        empathetic: 'Empathetic',
        concise: 'Concise',
        friendly: 'Friendly'
      },
      operation: 'Operation',
      tone: 'Tone',
      customInstruction: 'Enter a specific instruction',
      generate: 'Generate',
      loading: 'Preparing a response...',
      emptySuggestions: 'No suggestion yet.',
      emptyChat: 'No messages in this conversation.',
      draftTooLong: 'The draft must be {max} characters or fewer.',
      requestTooLong: 'The draft and instruction together must be {max} characters or fewer.',
      chatRequestTooLong: 'The draft and message together must be {max} characters or fewer.',
      clarificationWarning: 'More information is needed. Review the clarification question before using this response.',
      insert: 'Insert at cursor',
      replace: 'Replace draft',
      append: 'Append to draft',
      applyMode: 'Apply mode',
      apply: 'Apply to draft',
      copy: 'Copy',
      regenerate: 'Generate again',
      discard: 'Discard',
      thumbsUp: 'Helpful',
      thumbsDown: 'Not helpful',
      newConversation: 'New conversation',
      archiveConversation: 'Archive conversation',
      selectConversation: 'Select a conversation',
      conversationLabel: 'Conversation {index}, {status}',
      conversationStatus: {
        active: 'Active',
        archived: 'Archived',
        expired: 'Expired'
      },
      loadOlder: 'Load older messages',
      chatPlaceholder: 'Write a message',
      send: 'Send',
      retry: 'Try again',
      retryCountdown: 'Try again in {seconds} seconds',
      retryCountdownSingular: 'Try again in 1 second',
      retryReady: 'You can try again now.',
      collapse: 'Collapse',
      expand: 'Expand',
      disabled: 'AI assistance is not enabled for this account.',
      expiredConversation: 'This conversation has expired. Start a new conversation to continue.',
      readOnlyConversation: 'This conversation is read-only.',
      ai_disabled: 'AI assistance is not enabled for this account.',
      ai_forbidden: 'You do not have permission to use AI assistance for this ticket.',
      ai_rollout_unavailable: 'AI assistance is unavailable until a governed support rollout is active. Ordinary replies remain available.',
      ai_rate_limited: 'Too many requests. Try again in {retry_after} seconds.',
      ai_rate_limited_singular: 'Too many requests. Try again in 1 second.',
      ai_rate_limited_generic: 'Too many requests. Try again shortly.',
      ai_context_rejected: 'The ticket context could not be used safely. Review the ticket and try again.',
      ai_output_blocked: 'The generated response was blocked by safety checks.',
      ai_provider_unavailable: 'AI assistance is temporarily unavailable. Try again later.',
      ai_timeout: 'The AI request timed out. Try again.',
      ai_invalid_output: 'The generated response was invalid. Generate a new response.',
      ai_conversation_expired: 'This conversation has expired. Start a new conversation.',
      ai_idempotency_conflict: 'This request conflicts with an earlier request. Refresh and try again.',
      not_authenticated: 'Your session has expired. Sign in again to use AI assistance.',
      not_found: 'This AI conversation or message is no longer available. Refresh and try again.',
      invalid_request: 'The AI request was invalid. Review the inputs and try again.',
      missing_idempotency_key: 'This request could not be retried safely. Refresh and try again.',
      invalid_idempotency_key: 'This request could not be retried safely. Refresh and try again.',
      ai_conversation_limit: 'Archive an active AI conversation before starting another.',
      privateSession: 'This session is private and visible only to authorized support staff.',
      reviewWarning: 'Review AI-assisted text for accuracy and safety before sending.',
      feedbackReasons: {
        incorrect: 'Incorrect',
        irrelevant: 'Irrelevant',
        incomplete: 'Incomplete',
        unsafe: 'Unsafe',
        outdated: 'Outdated',
        poorTone: 'Poor tone',
        other: 'Other'
      },
      feedbackComment: 'Additional details (optional)',
      feedbackDialogTitle: 'Tell us why this response was not helpful',
      feedbackFormLabel: 'AI response feedback',
      feedbackReason: 'Reason',
      feedbackReasonPlaceholder: 'Select a reason',
      feedbackSubmit: 'Submit feedback',
      feedbackCancel: 'Cancel',
      accessibility: {
        panel: 'AI assistant panel',
        conversationSelector: 'Select an AI conversation',
        chatInput: 'Message the AI assistant',
        sendMessage: 'Send message to the AI assistant'
      },
      run: {
        title: 'Run progress',
        connection: {
          connecting: 'Connecting to live updates',
          live: 'Live updates connected',
          reconnecting: 'Reconnecting to live updates',
          polling: 'Using periodic updates',
          stale: 'Live updates are delayed',
          offline: 'You are offline'
        },
        state: {
          queued: 'Queued',
          running: 'Running',
          completed: 'Completed',
          blocked: 'Blocked',
          failed: 'Failed',
          cancelled: 'Cancelled'
        },
        stage: {
          intake: 'Preparing request',
          context: 'Reading ticket context',
          retrieval: 'Finding relevant sources',
          generation: 'Drafting response',
          validation: 'Checking response',
          review: 'Reviewing response',
          repair: 'Correcting response',
          finalization: 'Finalizing response',
          persistence: 'Saving response',
          finished: 'Finished'
        },
        reviewerStatus: {
          approve: 'Review approved',
          repair: 'Review requested a correction',
          block: 'Review blocked release',
          unavailable: 'Reviewer unavailable'
        },
        repairStatus: {
          not_requested: 'No correction requested',
          requested: 'Correction requested',
          completed: 'Correction completed',
          exhausted: 'Correction limit reached'
        },
        blockCategory: {
          content_safety: 'Content safety',
          prompt_security: 'Instruction security',
          sensitive_data: 'Sensitive data',
          grounding: 'Source verification',
          policy: 'Support policy',
          human_review: 'Human review',
          unknown: 'Safety review'
        },
        failureCategory: {
          provider_unavailable: 'Service unavailable',
          reviewer_unavailable: 'Reviewer unavailable',
          timeout: 'Time limit reached',
          stale_context: 'Ticket changed during processing',
          permission_changed: 'Access changed during processing',
          internal: 'Processing error'
        },
        blockRemediation: {
          content_safety: 'Revise the draft to remove unsafe content, then start a new request.',
          prompt_security: 'Remove untrusted instructions from the ticket or draft, then start a new request.',
          sensitive_data: 'Remove credentials and unnecessary personal data before starting a new request.',
          grounding: 'Check the cited sources or add verified ticket context before starting a new request.',
          policy: 'Review the support policy and adjust the requested response before continuing.',
          human_review: 'Request or wait for review by an authorized support specialist.',
          unknown: 'Review the ticket context and start a new request when ready.'
        },
        failureRemediation: {
          provider_unavailable: 'Wait for the service to recover, then use retry when offered or start a new request.',
          reviewer_unavailable: 'Wait for the review service to recover before trying again.',
          timeout: 'Reduce the requested scope and start a new request.',
          stale_context: 'Refresh the ticket and start a new request from its current state.',
          permission_changed: 'Refresh your access. Contact a support administrator if access is still required.',
          internal: 'Review the ticket context and start a new request when ready.'
        },
        cancel: 'Cancel run',
        retry: 'Retry run',
        retryUnavailable: 'Retry is no longer available because its original request was released.',
        reconnect: 'Reconnect',
        transportDegraded: 'The run is still active, but live updates are degraded.',
        blocked: 'This run was stopped by a safety or review control.',
        failed: 'This run could not be completed.',
        remediation: 'Review the ticket context and start a new request when ready.',
        diagnostics: 'Administrator diagnostics',
        sources: 'Sources used by this run'
      }
    },

    collaboration: {
      title: 'Agent collaboration',
      internalNoteCollaboration: 'Internal collaboration',
      internalNoteHelp:
        'Use internal notes to request review, hand off work, add watchers, and make sure other agents know this ticket needs attention.',
      mentionedAgents: 'Mention agents',
      watchers: 'Watchers',
      selectAgents: 'Select agents to notify',
      selectWatchers: 'Select agents to watch this ticket',
      requestedAction: 'Requested action',
      selectAction: 'Select action',
      urgency: 'Urgency',
      dueAt: 'Due by',
      dueAtPlaceholder: 'YYYY-MM-DD HH:mm or ISO date',
      handoff: 'Handoff',
      handoffTo: 'Handoff to',
      selectHandoffAgent: 'Select handoff agent',
      requiresAcknowledgment: 'Require mentioned agents to acknowledge',
      requiresAcknowledgmentShort: 'Ack required',
      needsAttention: 'Needs attention',
      mentionedMe: 'Mentioned me',
      watching: 'Watching',
      handoffToMe: 'Handed off to me',
      acknowledge: 'Acknowledge',
      acknowledged: 'Attention request acknowledged',
      resolve: 'Resolve',
      resolved: 'Attention request resolved',
      errorAcknowledging: 'Failed to acknowledge attention request',
      errorResolving: 'Failed to resolve attention request',
      pendingAttentionCount: '{count} pending attention request(s)',
      actions: {
        review: 'Review',
        continue: 'Continue ticket',
        handoff: 'Take over',
        investigate: 'Investigate',
        approve: 'Approve',
        fyi: 'FYI'
      },
      urgencies: {
        low: 'Low',
        normal: 'Normal',
        high: 'High',
        urgent: 'Urgent'
      }
    },

    // Replies section
    replies: {
      title: 'Replies',
      add: 'Add Reply'
    },

    // Attachments section
    attachments: {
      title: 'Attachments',
      scanStatuses: {
        queued: 'Queued for scan',
        scanning: 'Scanning',
        clean: 'Clean',
        infected: 'Blocked',
        error: 'Scan failed'
      },
      scanPendingProcedure: 'Download unlocks after the security scan finishes.',
      scanErrorProcedure: 'Scan failed. Agents can retry the scan before release.',
      infectedProcedure: 'This file is blocked and cannot be downloaded.',
      scanFailedSafe: 'This file is temporarily unavailable while we verify it.',
      infectedSafe: 'This file was blocked by security scanning.',
      retryScan: 'Retry scan',
      retryScanSuccess: 'Attachment scan was queued again.',
      retryScanFailed: 'Unable to retry attachment scan.',
      downloadBlocked: 'This attachment is not available until it passes security scanning.',
      downloadFailed: 'Unable to download this attachment.',
      preview: 'Preview',
      previewFailed: 'Unable to preview this attachment.',
      previewUnavailable: 'Preview is available only for clean images, PDF, and plain text files.',
      previewLoading: 'Loading preview…',
      previewError: {
        title: 'Preview unavailable',
        fetch:
          "We couldn't load this file for preview. It may have been blocked by your browser or is temporarily unavailable. You can download it instead.",
        mismatch:
          "The file type reported by the server does not match the expected preview type, so it can't be shown safely. Download it to open it locally.",
        render: "This file couldn't be displayed in the preview. Download it to open it with another app.",
        unavailable: "This file can't be previewed here. Download it to open it locally."
      },
      downloadInstead: 'Download file',
      retryPreview: 'Try again',
      pdfPreviewBlockedTitle: 'PDF preview may be blocked',
      pdfPreviewFallback:
        'The browser privacy settings may block embedded PDF previews. Download the file, or open it in a new tab if your browser allows it.',
      previewAlt: 'Preview of {fileName}',
      actions: 'Attachment actions',
      openInNewTab: 'Open in new tab',
      contentTypeMismatch:
        'The file type reported by the server does not match the expected preview type. Preview was blocked.',
      unverifiedSource: 'This file was provided by a user. Preview it carefully and download only when needed.',
      ready: 'Ready',
      unavailable: 'Unavailable',
      states: {
        ready: 'Ready',
        preparing: 'Preparing',
        unavailable: 'Unavailable'
      },
      previewTypes: {
        image: 'Image',
        pdf: 'PDF',
        text: 'Text',
        file: 'File'
      }
    },

    // Knowledge Base
    knowledgeBase: {
      needHelp: 'Need Help?',
      title: 'Knowledge Base',
      articles: 'articles',
      popularArticles: 'Popular Articles',
      views: 'views',
      helpful: 'helpful',
      noArticles: 'No Articles Found',
      noArticlesDesc: 'There are no articles available at this time.',
      noArticlesInCategory: "This category doesn't have any articles yet.",
      stillNeedHelp: 'Still Need Help?',
      wasHelpful: 'Was this article helpful?',
      yes: 'Yes',
      no: 'No',
      thanksFeedback: 'Thanks for your feedback!',
      sorryNotHelpful: "Sorry this wasn't helpful. Please contact support for more assistance.",
      searchPlaceholder: 'Search articles...',
      browseByCategory: 'Browse by Category',
      searchResults: 'Search Results',
      articleResults: 'Knowledge base articles',
      documentationResults: 'Documentation',
      readDocs: 'Read docs',
      noResults: 'No Results Found',
      noResultsDesc: 'No articles or documentation matched your search. Try different keywords.',
      ticketSubjectPrefix: 'Question about:',
      ticketSubjectFallback: 'Support Request',
      readingTime: '{minutes} min read',
      resultsFor: 'Results for "{query}"',
      resultsCount: '{count} results',
      publishedOn: 'Published',
      categories: {
        gettingStarted: {
          name: 'Getting Started',
          description: 'Introductory guides for setting up and using AvalAI'
        },
        accountManagement: {
          name: 'Account Management',
          description: 'Managing your account and profile'
        },
        billingPayments: {
          name: 'Billing & Payments',
          description: 'Billing, invoices, and payment information'
        },
        technicalSupport: {
          name: 'Technical Support',
          description: 'Troubleshooting technical issues and service access'
        },
        featuresTips: {
          name: 'Features & Tips',
          description: 'Practical tips for using platform features effectively'
        },
        apiDocumentation: {
          name: 'API Documentation',
          description: 'Developer guides, API references, and integration help'
        },
        troubleshooting: {
          name: 'Troubleshooting',
          description: 'Step-by-step help for resolving common issues'
        },
        featureGuides: {
          name: 'Feature Guides',
          description: 'Guides for learning and applying product features'
        }
      }
    },

    // File upload
    fileUpload: {
      selectFiles: 'Select Files',
      uploadFiles: 'Upload Files',
      uploading: 'Uploading...',
      uploadComplete: 'Upload complete',
      uploadFailed: 'Upload failed',
      removeFile: 'Remove file',
      removeFileNamed: 'Remove {fileName}',
      fileCount: '{current} / {max} files',
      fileSize: 'File size',
      fileName: 'File name',
      units: {
        bytes: 'Bytes',
        kilobytes: 'KB',
        megabytes: 'MB',
        gigabytes: 'GB'
      },
      errors: {
        fileTooLarge: 'File is too large. Maximum size is {maxSize}',
        invalidFileType: 'Invalid file type',
        fileAlreadyAdded: 'File has already been added'
      },
      messages: {
        uploadSuccess: '{count} file(s) uploaded successfully',
        uploadFailed: '{count} file(s) failed to upload',
        uploadError: 'An error occurred during upload'
      }
    },

    // Polling
    polling: {
      maxRetriesExceeded: 'Maximum retry attempts exceeded. Polling stopped.',
      fetchError: 'Failed to fetch data',
      tooManyRequests: 'Too many requests',
      tooManyRequestsDesc:
        "Too many requests. Please wait a moment and try again. We've temporarily limited requests to ensure system stability."
    },

    // Errors
    errors: {
      partialLoadTitle: 'Some support data could not be loaded',
      partialLoadDescription:
        'Some support data is temporarily unavailable. You can still create tickets, view available tickets, or retry loading.',
      networkError: 'Network Error',
      permissionError: 'Permission Denied',
      notFoundError: 'Not Found',
      genericError: 'Something went wrong',
      timeoutError: 'Request Timeout',
      serverError: 'Server Error',
      maintenanceError: 'Under Maintenance',
      networkErrorDesc: 'Unable to connect to the server. Please check your internet connection and try again.',
      permissionErrorDesc: "You don't have permission to access this resource. Please contact your administrator.",
      notFoundErrorDesc: 'The requested resource could not be found.',
      genericErrorDesc: 'An error occurred while loading data. Please try again.',
      timeoutErrorDesc: 'The request took too long to complete. Please try again.',
      serverErrorDesc:
        'The server encountered an error (502). Please try again later or contact support if the issue persists.',
      maintenanceErrorDesc: 'The system is currently undergoing maintenance. Please try again later.',
      withErrorCode: '{message} (Error: {code})',
      tryAgain: 'Try Again',
      contactSupport: 'Contact Support'
    },

    // Auth required
    authRequired: {
      title: 'Authentication Required',
      description: 'Please log in to access the support system and manage your tickets.',
      loginButton: 'Log In'
    },

    // Empty states
    emptyStates: {
      noTickets: {
        title: 'No tickets found',
        description: 'Create your first support ticket to get started.',
        action: 'Create Ticket'
      },
      noReplies: {
        title: 'No replies yet',
        description: 'Be the first to reply to this ticket.'
      },
      noAttachments: {
        title: 'No attachments',
        description: 'No files have been attached to this ticket.'
      },
      noSearchResults: {
        description: 'Try adjusting your search terms or filters.'
      },
      noData: {
        description: 'No data available.'
      }
    },

    // Validation
    validation: {
      subjectRequired: 'Subject is required',
      descriptionRequired: 'Description is required',
      categoryRequired: 'Please select a category',
      priorityRequired: 'Please select a priority',
      fileTooBig: 'File {fileName} is too large. Maximum size is {size}MB',
      tooManyFiles: 'Too many files. Maximum is {max} files',
      invalidFileType: 'File {fileName} has invalid type. Allowed types: {allowedTypes}',
      maxFilesExceeded: 'Maximum number of files exceeded',
      formErrors: 'Please fix the form errors before submitting',
      replyRequired: 'Reply content is required',
      // Dynamic field validation
      fieldRequired: 'Field {field} is required',
      invalidCardNumber: 'Invalid card number',
      invalidIBAN: 'Invalid IBAN number',
      invalidNumber: 'Invalid number',
      numberTooSmall: 'Number must be at least {min}',
      numberTooLarge: 'Number must not exceed {max}',
      invalidDate: 'Invalid date',
      invalidEmail: 'Invalid email address',
      textTooShort: 'Text must be at least {min} characters',
      textTooLong: 'Text must not exceed {max} characters',
      invalidFormat: 'Invalid format',
      invalidOption: 'Invalid option selected',
      addressRequired: 'Address selection is required',
      invalidAddress: 'Invalid address selected',
      backendFieldInvalid: 'Please check {field} and try again'
    },

    address: {
      type: 'Address Type',
      city: 'City',
      companyName: 'Company Name',
      fullAddress: 'Full Address',
      types: {
        individual: 'Individual',
        company: 'Company',
        home: 'Home',
        business: 'Business',
        other: 'Other'
      }
    },

    addresses: {
      selectAddress: 'Select address',
      createAddress: 'Create address',
      createAddressTitle: 'Create billing address',
      createAddressDescription: 'Save a billing address for this ticket.',
      addressLabel: 'Address label',
      addressLabelPlaceholder: 'Main billing address',
      companyName: 'Company name',
      fullAddress: 'Full address',
      city: 'City',
      state: 'State / Province',
      province: 'Province',
      chooseProvince: 'Choose province',
      cityPlaceholder: 'Select or enter city',
      fullAddressPlaceholder: 'Street, alley, plaque, unit',
      selectedFullAddress: 'Selected full address',
      quickSelect: 'Quick select',
      countryIran: 'Iran',
      postalCode: 'Postal code',
      postalCodePlaceholder: '10 digits, no dash',
      postalCodeHint: 'Postal code must be 10 digits',
      country: 'Country',
      phoneNumber: 'Phone number',
      emailAddress: 'Email address',
      defaultAddress: 'Default',
      setAsDefault: 'Set as default address',
      defaultAddressHint: 'This address will replace your current default address.',
      defaultAddressLockedHint:
        'Your first address is always the default. Set another address as default to replace it.',
      saveAddress: 'Save address',
      addNewAddress: 'Add new address',
      editAddress: 'Edit address',
      editAddressDescription: 'Update the selected address for this ticket.',
      updateAddress: 'Update address',
      updateSuccess: 'Address updated',
      updateFailed: 'Failed to update address',
      createSuccess: 'Address saved',
      createFailed: 'Failed to save address',
      noAddresses: 'No addresses found',
      noAddressesDescription: 'Create a billing address before submitting invoice-related tickets.',
      types: {
        individual: 'Individual',
        company: 'Company',
        home: 'Home',
        business: 'Business',
        other: 'Other'
      }
    },

    // Help section
    help: {
      beforeCreating: 'Before Creating a Ticket',
      searchKnowledge: 'Search our knowledge base for quick answers to common questions.',
      tips: 'Tips for Better Support',
      tip1: 'Be specific about your issue and include relevant details',
      tip2: 'Attach screenshots or files that help explain the problem',
      tip3: 'Choose the correct category and priority for faster resolution',
      urgentIssues: 'Urgent Issues',
      urgentContact: 'For critical issues that need immediate attention, contact our support team directly.',
      contactSupport: 'Contact Support'
    },

    // Stats for agent dashboard
    stats: {
      total: 'Total',
      unassigned: 'Unassigned',
      assignedToMe: 'Assigned to Me',
      open: 'Open',
      inProgress: 'In Progress',
      overdue: 'Overdue',
      unseen: 'Unseen',
      openTickets: 'Open Tickets',
      resolutionRate: 'Resolution Rate',
      filtersAria: 'Ticket statistics filters',
      aria: {
        total: '{count} total tickets. Show all tickets',
        unassigned: '{count} unassigned tickets. Filter unassigned tickets',
        assignedToMe: '{count} tickets assigned to me. Filter my tickets',
        open: '{count} open tickets. Filter open tickets',
        inProgress: '{count} tickets in progress',
        overdue: '{count} overdue tickets. Filter overdue tickets',
        unseen: '{count} tickets not viewed by any agent on this page. Filter unseen tickets'
      }
    },

    // Agent Dashboard
    agentDashboard: {
      title: 'Agent Dashboard',
      viewAllTickets: 'View All Tickets',
      myQueue: 'My Queue',
      unassignedQueue: 'Unassigned Queue',
      ticketsNeedingAttention: 'Tickets Needing Attention',
      responseQueue: 'Response queue',
      responseQueueHint: 'Prioritize customers by response state and elapsed waiting time.',
      openOldestFirst: 'Open oldest first'
    },

    // Role labels
    roles: {
      agent: 'Agent',
      admin: 'Admin',
      user: 'User'
    },

    // Access denied
    accessDenied: {
      title: 'Access Denied',
      agentRequired: 'You need agent or admin privileges to access this page.'
    },

    // All Tickets view
    allTickets: 'All Tickets',

    // Agent actions
    agentActions: {
      title: 'Agent Actions',
      noAgentsAvailable: 'No agents available',
      assignToMe: 'Assign to Me',
      unassign: 'Unassign'
    },

    // Bulk Actions
    bulkActions: {
      selectedCount: '{count} ticket(s) selected',
      changeStatus: 'Change Status',
      changePriority: 'Change Priority',
      assign: 'Assign',
      unassign: 'Unassign',
      clearSelection: 'Clear Selection',
      statusChangeSuccess: '{count} ticket(s) status updated successfully',
      statusChangeFailed: 'Failed to update ticket status',
      priorityChangeSuccess: '{count} ticket(s) priority updated successfully',
      priorityChangeFailed: 'Failed to update ticket priority',
      assignSuccess: '{count} ticket(s) assigned successfully',
      unassignSuccess: '{count} ticket(s) unassigned successfully',
      assignFailed: 'Failed to assign tickets',
      // Loading messages
      updatingStatus: 'Updating ticket status...',
      updatingPriority: 'Updating ticket priority...',
      updatingAssignment: 'Updating ticket assignment...',
      processing: 'Processing...',
      selectTickets: 'bulk actions',
      cancelSelect: 'Cancel'
    },

    // Activity Timeline
    activity: {
      title: 'Activity Timeline',
      noActivity: 'No activity recorded yet',
      loadMore: 'Load More',
      internal: 'Internal',
      by: 'by',
      botUser: 'Bot',
      systemUser: 'System',
      types: {
        created: 'Created',
        status_changed: 'Status Changed',
        priority_changed: 'Priority Changed',
        assigned: 'Assigned',
        unassigned: 'Unassigned',
        reply_added: 'Reply Added',
        internal_note: 'Internal Note',
        internal_note_added: 'Internal Note Added',
        attachment_added: 'Attachment Added',
        reopened: 'Reopened',
        sla_breached: 'SLA Breached',
        escalated: 'Escalated',
        merged: 'Merged',
        split: 'Split',
        category_changed: 'Category Changed',
        custom_field_updated: 'Custom Field Updated'
      },
      messages: {
        created: 'Ticket created',
        status_changed: 'Status changed from {oldValue} to {newValue}',
        priority_changed: 'Priority changed from {oldValue} to {newValue}',
        assigned: 'Ticket assigned',
        unassigned: 'Ticket unassigned',
        reply_added: 'Reply added',
        internal_note: 'Internal note added',
        attachment_added: 'Attachment added',
        reopened: 'Ticket reopened',
        sla_breached: 'SLA breached'
      }
    },

    // Export
    export: {
      title: 'Export Tickets',
      button: 'Export',
      format: 'Format',
      csv: 'CSV',
      excel: 'Excel',
      exporting: 'Exporting...',
      success: 'Tickets exported successfully',
      failed: 'Failed to export tickets',
      noTickets: 'No tickets to export',
      json: 'JSON'
    },

    // Notification Preferences
    notifications: {
      title: 'Notification Preferences',
      settings: 'Notification Settings',
      loadErrorTitle: 'Error Loading Settings',
      loadError: 'Failed to load notification preferences. Please try again.',
      saveSuccess: 'Notification preferences saved successfully',
      saveError: 'Failed to save notification preferences',
      resetSuccess: 'Notification preferences reset to defaults',
      resetError: 'Failed to reset notification preferences',
      enabledAll: 'All notifications enabled',
      disabledAll: 'All notifications disabled',
      toggleError: 'Failed to toggle notifications',
      enableAll: 'Enable All Email Notifications',
      enableAllDesc: 'Toggle all email notification settings at once',
      quickToggleDesc: 'Quickly enable or disable every email notification type.',
      toggleAll: 'Toggle all email notifications',
      ticketUpdates: 'Ticket Updates',
      slaAlerts: 'SLA & Escalation Alerts',
      important: 'Important',
      critical: 'Critical',
      emailNotifications: 'Email Notifications',
      newTicket: 'New Ticket',
      newTicketDesc: 'Receive an email when a new ticket is created',
      ticketAssigned: 'Ticket Assigned',
      ticketAssignedDesc: 'Receive an email when a ticket is assigned to you',
      ticketReply: 'Ticket Reply',
      ticketReplyDesc: 'Receive an email when someone replies to your ticket',
      statusChange: 'Status Change',
      statusChangeDesc: 'Receive an email when ticket status changes',
      escalation: 'Escalation',
      escalationDesc: 'Receive an email when a ticket is escalated',
      slaWarning: 'SLA Warning',
      slaWarningDesc: 'Receive an email when a ticket is approaching SLA deadline',
      slaBreach: 'SLA Breach',
      slaBreachDesc: 'Receive an email when a ticket breaches SLA',
      emailDigest: 'Email Digest',
      digestFrequencyLabel: 'Digest Frequency',
      digestFrequencyDesc: 'Receive a summary of ticket activity',
      selectFrequency: 'Select frequency',
      digestFrequency: {
        none: 'None',
        daily: 'Daily',
        weekly: 'Weekly'
      },
      inAppNotifications: 'In-App Notifications',
      enableInApp: 'Enable In-App Notifications',
      enableInAppDesc: 'Show notifications within the application',
      resetDefaults: 'Reset to Defaults',
      resetConfirmMessage: 'Are you sure you want to reset all notification settings to their defaults?',
      saveChanges: 'Save Changes'
    },

    // Time formatting
    time: {
      justNow: 'Just now',
      minutesAgo: '{count} minutes ago',
      hoursAgo: '{count} hours ago',
      daysAgo: '{count} days ago',
      weeksAgo: '{count} weeks ago',
      monthsAgo: '{count} months ago'
    }
  },
  models: {
    name: 'Name',
    provider: 'Provider',
    tier: 'Tier',
    maxTokens: 'Max Tokens',
    price: 'Price',
    costoptimizedModels: 'Cost-Optimized Models',
    costoptimizedModelsDes: 'Smaller, faster models that cost less to run',
    flagshipModels: 'Flagship Models',
    flagshipModelsDes: 'Most versatile, high-intelligence flagship models',
    imageGeneration: 'Image Generation',
    imageGenerationDes: 'Models that generate images from text descriptions',
    reasoningModels: 'Reasoning Models',
    reasoningModelsDes: 'Advanced models that excel at complex, multi-step tasks',
    embeddingModels: 'Embedding Models',
    embeddingModelsDes: 'Models that convert text to vector embeddings',
    stt: 'Speech-to-Text',
    sttDes: 'Models that transcribe speech to text',
    tts: 'Text-to-Speech',
    ttsDes: 'Models that convert text to natural-sounding speech',
    visionModels: 'Vision Models',
    visionModelsDes: 'Models that can analyze and understand images',
    chatModels: 'Chat Models',
    chatModelsDes: 'General purpose conversational AI models',
    multimodalModels: 'Multimodal Models',
    multimodalModelsDes: 'Models that support multiple input/output types (text, image, audio, video)',
    moderationModels: 'Moderation Models',
    moderationModelsDes: 'Models that detect and filter harmful or inappropriate content',
    codeModels: 'Code Models',
    codeModelsDes: 'Models specialized in code generation, analysis, and completion',
    noRateLimitReceived: 'No rate limit data received',
    loadingModels: 'Loading models',
    featuredModels: 'Featured Models',
    modelsFound: 'models found',
    searchByModel: 'Search models by name, provider, or capability...',
    searchByModelDes: 'Most popular and recommended models',
    filterModels: 'Filter Models',
    quickFilters: 'Quick Filters',
    myAccessibleModels: 'My Accessible Models',
    accessibleModelsDes: 'Models I can access',
    visionModelsTxt: 'Vision Models',
    visionModelsDes2: 'Models with image capabilities',
    reasoningModelsTxt: 'Reasoning Models',
    reasoningModelsDes2: 'Advanced reasoning capabilities',
    costEffective: 'Cost Effective',
    costEffectiveDes: 'Budget-friendly options',
    providers: 'Providers',
    selectProviders: 'Select providers',
    capabilities: 'Capabilities',
    selectCapabilities: 'Select capabilities',
    accessTiers: 'Access Tiers',
    selectTiers: 'Select tiers',
    priceRange: 'Price Range (per 1M tokens)',
    sortBy: 'Sort By',
    newest: 'Newest',
    new: 'New',
    onlyAccessible: 'Only show accessible models',
    of: 'of',
    models: 'models',
    filter: 'filter',
    filters: 'filters',
    active: 'active',
    showMore: 'Show More',
    showLess: 'Show Less',
    more: 'more',
    applyFiltersClose: 'Apply Filters & Close',
    providersPlaceholder: 'Providers',
    capabilitiesPlaceholder: 'Capabilities',
    tiersPlaceholder: 'Tiers',
    categoryPlaceholder: 'Category',
    allCategories: 'All Categories',
    tierLabel: 'Tier {0}',
    clearFilters: 'Clear Filters',
    categoryModelsCount: 'models',
    noModelsFound: 'No models found',
    filtersActive: 'filters active'
  },
  tooltip: {
    tpm: 'Token per Minute Limit (TPM) based on the selected level',
    rpm: 'Requests per Minute Limit (RPM) based on the selected level',
    negativeBalance: 'Negative Balance',
    negativeBalanceExplanation:
      'Your account has a negative balance due to concurrent API requests. Please recharge your account.',
    negativeTotalBalance: 'Negative Total Balance Details',
    currentBalance: 'Current Balance',
    pendingCharges: 'Pending Charges',
    rechargeAdvice: 'Please recharge your account to continue using our services without interruption.',
    remainingIRT: 'Remaining credit in Toman',
    remainingUNIT: 'Remaining credit converted to units (Tether rate)',
    imagePricingAlert:
      'The cost calculation in image generation models is based on the model type, image size, quality, and the number of steps (if the model supports step adjustment). Therefore, the stated rate per image is considered an average rate. Except for the gpt-image-1 model, other models do not have an actual output token rate; this value is assigned only for system compatibility. For example, when calling the dall-e-3 model with HD quality and a size of 1024 by 1024, the token amount is considered to be 1000. At a rate of 40 units per one million tokens, this equals 0.04 units, which is the base output rate per image.',
    remainingInUNIT:
      "Total value of Toman credit converted to units plus credit converted to units. This amount represents the total value of the account's credit in units at the real-time conversion rate.",
    aboveTokensPricing:
      'When the total tokens exceed the specified amount, the rate is calculated based on this. In cases where the total tokens are below this amount, the base rate is used as the calculation basis. For more information, please refer to the provider’s documentation.',
    endpointMightNotAvailable:
      'Certain endpoints may not be available in AvalAI at this time. Please check the documentation for further details.',
    remainingCreditInIrtEquivalent:
      'The total balance of your wallet in Tomans. This balance includes the remaining Tomans plus the remaining ‘Units’ multiplied by the current exchange rate. Because credit packages are priced in Tomans, if your wallet balance contains currency in ‘Units’, its equivalent in Tomans is calculated based on the current exchange rate.'
  },
  limits: {
    selectModalities: 'Modalities',
    selectEndpoints: 'Endpoints',
    rateLimits: 'Rate Limits',
    supported_endpoints: 'Supported Endpoints',
    supports_parallel_function_calling: 'Parallel Function Calling',
    supports_web_search: 'Supports Web Search',
    max_images_per_prompt: 'Max Images per Prompt',
    max_videos_per_prompt: 'Max Videos per Prompt',
    max_video_length: 'Max Videos Length',
    max_audio_length_hours: 'Max Audio Hours',
    max_audio_per_prompt: 'Max Audio per Prompt',
    max_pdf_size_mb: 'Max PDF size (mb)',
    supported_modalities: 'Supported Input Modialities',
    supported_output_modalities: 'Supported Output Modialities',
    costPerOneMillionTokens: 'Cost in UNIT per 1M tokens',
    details: 'Details',
    name: 'Model',
    max_tokens: 'Max output Tokens',
    max_input_tokens: 'Max Input Tokens',
    max_requests_per_1_minute: 'RPM',
    max_tokens_per_1_minute: 'TPM',
    pricing: {
      input_cost_per_token: 'Input Cost per Token',
      output_cost_per_token: 'Output Cost per Token',
      input_cost_per_page: 'Input Cost per Page',
      input_cost_per_query: 'Input Cost per Query',
      kTokens: 'k Tokens',
      input: 'Input Price',
      output: 'Output Price',
      cached_input: 'Cached Input Price',
      cache_creation_input: 'Cache Creation Input Price',
      audio_input: 'Audio Input Price',
      audio_output: 'Audio Output Price',
      audio_cached_input: 'Audio Cached Input Price',
      image_input: 'Image Input Price',
      image_output: 'Image Output Price',
      image_cached_input: 'Cached Image Input Price',
      video_input: 'Video Input Price',
      input_cost_per_character: 'Cost per Character',
      input_cost_per_second: 'Input Cost per Second',
      output_cost_per_second: 'Output Cost per Second',
      output_cost_per_image: 'Output Cost per Image',
      output_cost_per_video_per_second: 'Output Cost per Video Second',
      input_cost_per_annotation_page: 'Cost per Annotation Page',
      // Generic, interpolated templates used for any dynamically-detected modifier.
      // `{base}` is one of the base labels above; `{threshold}` e.g. "128k"; `{resolution}` e.g. "720x1280".
      aboveTemplate: '{base} Above {threshold} Tokens',
      resolutionTemplate: '{base} ({resolution})',
      source: 'Source'
    },
    outputVideo: 'Output Video',
    outputImage: 'Output Image',
    perOneImage: 'Per 1 Image',
    outputSeconds: 'Output Seconds',
    perOneSecond: 'Per 1 second',
    inputSeconds: 'Input Seconds',
    perOneCharacterInput: 'per 1 single character',
    characterInput: 'Character Input',
    modelCapabilities: 'Model Capabilities',
    maxTokens: 'Maximum Tokens',
    maxInputTokens: 'Maximum Input Tokens',
    maxOutputTokens: 'Maximum Output Tokens',
    mode: 'Mode',
    source: 'Source',
    supportsSystemMessages: 'System Messages',
    supportsFunctionCalling: 'Function Calling',
    supportsVision: 'Vision',
    supportsToolChoice: 'Tool Choice',
    supportsResponseSchema: 'Response Schema',
    supportsPromptCaching: 'Prompt Caching',
    supportsReasoning: 'Reasoning',
    howToUseApi1: 'Get the models data via API',
    audioPerMinute: 'Audio per Minute',
    imagesPerMinute: 'Images per Minute',
    searchModel: 'Search Model',
    selectOwner: 'Select Owner',
    owner: 'Owner',
    tier0: 'Starter',
    tier1: 'Level 1',
    tier2: 'Level 2',
    tier3: 'Level 3',
    tier4: 'Level 4',
    tier5: 'Level 5',
    audioInputTokens: 'Audio Input Tokens',
    audioOutputTokens: 'Audio Output Tokens',
    audioCachedInputTokens: 'Audio Cached Input Tokens',
    minute: 'minute',
    perMinute: 'per minute',
    perOneMillionTokens: 'per 1M tokens',
    currency: 'Currency',
    costCalculator: 'Cost Calculator',
    inputTokens: 'Input Tokens',
    cachedInputTokens: 'Cached Input Tokens',
    outputTokens: 'Output Tokens',
    audioInputMinutes: 'Audio Input Minutes',
    audioCachedInputMinutes: 'Audio Cached Input Minutes',
    audioOutputMinutes: 'Audio Output Minutes',
    estimatedCost: 'Estimated Cost',
    tokenBasedPricing: 'Token-based Pricing',
    audioBasedPricing: 'Audio-based Pricing',
    modelDetails: 'Model details',
    copyModelName: 'Copy model name',
    openModelSource: 'Open model source',
    openPricingSource: 'Open pricing source',
    noCapabilitiesAvailable: 'No capability details are published for this model.',
    supportedFeatures: 'Supported features',
    simpleEstimate: 'Quick estimate',
    openFullCalculator: 'Open full calculator',
    openServiceTierDocs: 'Open service tier documentation',
    actions: '',
    providerType: 'Provider Type',
    viewPricing: 'View Pricing',
    pricingDetails: 'Pricing Details',
    // Service Tier Pricing
    serviceTier: 'Service Tier',
    serviceTiers: 'Service Tiers',
    selectServiceTiers: 'Service Tiers',
    serviceTierFilter: 'Service Tier Filter',
    serviceTierPricing: 'Service Tier Pricing',
    standardTier: 'Standard',
    defaultTier: 'Default',
    flexTier: 'Flex',
    batchTier: 'Batch',
    priorityTier: 'Priority',
    defaultTierDescription: 'Default pricing tier',
    standardTierDescription: 'Default pricing tier',
    flexTierDescription: 'Lower cost, variable latency',
    batchTierDescription: 'Asynchronous processing',
    priorityTierDescription: 'Higher availability',
    flexAvailable: 'Flex Available',
    supportsFlexPricing: 'Supports Flex Pricing',
    learnMoreAboutServiceTiers: 'Learn more about service tiers',
    // Service Tier Explanation Modal
    serviceTierExplanation: {
      title: 'Understanding Service Tiers',
      overview:
        'Service tiers allow you to optimize your API usage based on your specific needs. Different tiers offer various tradeoffs between cost, latency, and availability.',
      standardTitle: 'Standard Tier',
      standardDescription:
        'The default service tier that provides consistent, predictable performance with standard pricing.',
      standardFeature1: 'Predictable response times',
      standardFeature2: 'Standard rate limits apply',
      standardFeature3: 'Best for production workloads requiring consistent latency',
      flexTitle: 'Flex Tier',
      flexDescription:
        'A cost-optimized tier that offers significant savings in exchange for variable latency. Perfect for non-time-sensitive workloads.',
      flexFeature1: 'Up to 50% cost reduction compared to standard tier',
      flexFeature2: 'Variable latency - responses may take longer during peak times',
      flexFeature3: 'Ideal for batch processing, background tasks, or cost-sensitive applications',
      flexNote:
        'Flex tier requests are processed opportunistically when capacity is available. Response times may vary from seconds to minutes depending on demand.',
      howToUseTitle: 'How to Use Service Tiers',
      howToUseDescription: "To use a specific service tier, include the 'service_tier' parameter in your API request:",
      supportedModelsTitle: 'Supported Models',
      supportedModelsDescription:
        'Currently, only select OpenAI models support flex pricing. The list of supported models may expand over time.',
      modelAliases: 'Model Aliases',
      pricingTitle: 'Pricing Benefits',
      pricingDescription:
        'Flex tier pricing is typically 50% lower than standard tier pricing. The exact discount varies by model.',
      pricingExample: 'Example: If standard input price is $2.00/1M tokens, flex price would be ~$1.00/1M tokens.',
      latencyTitle: 'Latency Considerations',
      latencyDescription:
        'Standard tier provides consistent, low-latency responses ideal for real-time applications. Flex tier may have variable latency ranging from seconds to several minutes, making it best suited for asynchronous workloads where immediate response is not critical.',
      creditPackageWarningTitle: 'Important: Credit Packages',
      creditPackageWarning:
        'Flex tier usage is NOT covered by credit packages! If you are using credit packages, API calls with service_tier == flex will be charged from your standard balance instead of your package credits.'
    },
    inputPrice: 'Input Price',
    cachedInputPrice: 'Cached Input Price',
    cacheCreationInputPrice: 'Cache Creation Input Price',
    outputPrice: 'Output Price',
    audioInputPrice: 'Audio Input Price',
    audioOutputPrice: 'Audio Output Price',
    noPricingAvailable: 'No pricing information available',
    shortDesc1: 'Check your API usage and understand the limits to ensure seamless integration.',
    title: 'Access Limits',
    provider: 'Provider',
    providerTooltip:
      'Some models may have different providers than their owner (e.g., deepseek.r1-v1:0 is owned by DeepSeek but provided by AWS Bedrock). Same models on different providers might also come with different pricing.',
    model: 'Model',
    tpm: 'Token per Minute Limit (TPM)',
    rpm: 'Requests per Minute Limit (RPM)',
    info1: 'Our API uses OpenAI’s standard rate limits: Tokens per Minute (TPM) and Requests per Minute/Day (RPM/RPD).',
    readDoc1: 'For more details, Please read',
    readDoc2: 'Access Level Guide',
    readDoc3: 'provided by OpenAI.',
    usageTier: 'Access Level',
    noAccess: 'Free Access Level',
    free: 'Starter',
    tier: 'Level',
    completed: 'Completed',
    current: 'Current',
    upcoming: 'Upcoming',
    toIncreaseTier: 'To upgrade to the next access level',
    increaseYourLimits: 'Upgrade Access Level',
    youCurrentTier: 'Your account is at',
    ast: '',
    youWillmoveIf:
      'Your limits will automatically increase to the next usage level based on the following criteria. For more information, visit',
    toLearMore: 'Learn more about the limitations associated with each usage level.',
    tiers: {
      zero: {
        monthlyLimit: '',
        p1: 'Verify your email to unlock basic API access.',
        p2: '0 UNIT / month usage limit.',
        p3: '',
        p4: ''
      },
      tier0: {
        monthlyLimit: '',
        p1: 'Starter plan for email-verified users.',
        p2: 'Phone verification upgrades you to Access Level 1.',
        p3: '',
        p4: ''
      },
      tier1: {
        p1: 'Verify your phone number. No total paid threshold is required.',
        monthlyLimit: '100 UNIT / month usage limit.',
        p3: '',
        p4: ''
      },
      tier2: {
        p1: 'At least 10 UNIT spent on the API since account creation.',
        p2: '',
        monthlyLimit: '500 UNIT / month usage limit.',
        p3: '',
        p4: ''
      },

      tier3: {
        p1: 'At least 50 UNIT spent on the API since account creation.',
        p2: '',
        monthlyLimit: '1000 UNIT / month usage limit.',
        p3: '',
        p4: ''
      },
      tier4: {
        p1: 'At least 250 UNIT spent on the API since account creation.',
        p2: 'At least 14 days passed since first successful payment.',
        monthlyLimit: '5,000 UNIT / month usage limit.',
        p3: '',
        p4: ''
      },
      tier5: {
        p1: 'At least 1,000 UNIT spent on the API since account creation.',
        p2: 'At least 30 days passed since first successful payment.',
        monthlyLimit: '10,000 UNIT / month usage limit.',
        p3: '',
        p4: ''
      }
    },
    // Tier Upgrade System Localizations
    upgradeTitle: 'Upgrade Your Access Tier',
    maxTierTitle: 'Maximum Tier Reached',
    upgradeDescription:
      'Increase your API access limits by upgrading to a higher tier. Higher tiers unlock more models, increased rate limits, and premium features.',
    maxTierDescription:
      "Congratulations! You've reached the highest access tier with maximum benefits and unlimited access to all features.",
    tierProgress: 'Tier Progress',
    howItWorks: 'How Tier Upgrades Work',
    importantNotes: 'Important Information',
    currentTier: 'Current Tier',
    nextTier: 'Next Tier',
    progress: 'Progress',
    totalPaid: 'Total Paid',
    required: 'Required',
    remaining: 'Remaining',
    currentBenefits: 'Current Benefits',
    nextTierBenefits: 'Next Tier Benefits',
    upgradeNow: 'Upgrade Now',
    maxTierReached: 'Maximum Tier Achieved!',
    upgradeToNextTier: 'Upgrade to Next Tier',
    unlockBenefits: 'Unlock all premium benefits instantly',
    instantUpgrade: 'Instant upgrade • No waiting time • Keep all credits',

    // Step-by-step process
    step1Title: 'Verify Phone or Top Up',
    step1Description:
      'Phone verification upgrades email-verified accounts to Access Level 1 with no payment threshold. To reach Access Level 2 and higher, top up your account.',
    step2Title: 'Automatic Tier Calculation',
    step2Description:
      "The system calculates your IRT payment's UNIT equivalent at payment time to track total paid. Access Level 2+ upgrades are based on this total lifetime value in UNIT.",
    step3Title: 'Enjoy Enhanced Limits',
    step3Description:
      'Access higher rate limits, more models, and premium features immediately after your tier upgrade.',
    step4Title: 'Keep Your Credits',
    step4Description:
      "All your topped-up credits remain available for API usage. Tier upgrades don't consume your credits.",
    step5Title: 'Permanent Benefits',
    step5Description: 'Once upgraded, your tier benefits are permanent and will never be downgraded.',

    // Amount selection features
    selectAmount: 'Select Amount to Top Up',
    suggestedAmount: 'Suggested',
    suggestedAmountTooltip: 'Recommended amount with 1% buffer to protect against exchange rate fluctuations',
    selectedAmount: 'Selected Amount',
    minimumRequired: 'Minimum required',
    exchangeRate: 'Exchange rate',
    useSuggested: 'Use Suggested',

    // Tier selection features
    selectTargetTier: 'Choose Target Tier',
    selectTierPlaceholder: 'Select tier to upgrade to',
    selectedTier: 'Selected Tier',
    tier1PhoneVerificationUpgrade:
      'Verify your phone number to upgrade to Access Level 1. No payment or total paid threshold is required.',
    activationGrantNewUser:
      'Verify your phone number to receive {amount} Tomans of free credit.',
    activationGrantTopup:
      'Add your phone number to top up {amount} Tomans and reach {total} Tomans of total activation credit.',
    activationGrantBadge: '+{amount} Tomans',
    emailVerificationRequired: 'Email verified',
    emailVerified: 'Email verified',
    phoneVerified: 'Phone verified',
    targetTierBenefits: 'Target Tier Benefits',
    upgradeToSelectedTier: 'Upgrade to Selected Tier',
    resetToNext: 'Reset to Next',
    recommended: 'Recommended',
    cost: 'Cost',

    // Authentication and verification messages
    notLoggedIn: 'Not Logged In',
    loginRequired: 'Please log in to access tier benefits and upgrade options.',
    loginNow: 'Log In',
    phoneNotVerified: 'Phone Not Verified',
    phoneVerificationRequired: 'Please verify your phone number to unlock tier benefits.',
    verifyPhone: 'Verify Phone',
    notAuthenticated: 'Authentication Required',
    authenticationRequired: 'Please complete authentication to access your tier benefits.',
    authenticateNow: 'Authenticate',
    accessRestricted: 'Access Restricted',
    verificationRequired: 'Please complete verification to access tier benefits.',
    getVerified: 'Get Verified',

    // Important notes
    note1: 'Access Level 1 requires phone verification; Access Level 2+ is based on lifetime spending',
    note2: 'All topped-up credits remain available for API usage',
    note3: 'Higher tiers unlock access to more advanced AI models and features',

    // Tier Benefits
    benefits: {
      tier0: {
        basic: 'Basic API access with starter limits',
        limited: 'Access to essential models only'
      },
      tier1: {
        increased: 'Increased rate limits and token capacity',
        priority: 'Priority support and faster response times',
        models: 'Access to additional AI models'
      },
      tier2: {
        higher: 'Higher monthly usage limits (500 UNIT/month)',
        advanced: 'Access to advanced reasoning models',
        support: 'Enhanced customer support'
      },
      tier3: {
        premium: 'Premium access with 1000 UNIT/month limit',
        enhanced: 'Enhanced model selection and capabilities',
        features: 'Access to beta features and new releases'
      },
      tier4: {
        enterprise: 'Enterprise-level access (5000 UNIT/month)',
        maximum: 'Maximum rate limits and priority processing',
        dedicated: 'Dedicated support and custom configurations'
      },
      tier5: {
        unlimited: 'Unlimited access to all features and models',
        all: 'Access to all current and future AI models',
        priority: 'Highest priority support and custom solutions'
      }
    }
  },
  usage: {
    totalUsed: 'Total Used',
    totalAudio: 'Total Audio',
    audioInputSeconds: 'Audio Input(s)',
    audioOutputSeconds: 'Audio Output(s)',
    all: 'All',
    success: 'Success',
    pending: 'Pending',
    failed: 'Failed',
    summary: 'Summary',
    download: 'Download',
    action: 'Action',
    status: 'Status',
    expiresAt: 'Expires Date',
    generatedAt: 'Generated Date',
    consumptionReport: 'API Consumption Report',
    generateReport: 'Generate Report',
    timeFrame: 'Time Frame',
    meanExchangeRate: 'Mean Exchange Rate',
    inputTokens: 'Input Tokens',
    outputTokens: 'Output Tokens',
    cachedTokens: 'Cached Tokens',
    request: 'Request',
    totalTokens: 'Total tokens',
    totalRequests: 'Total requests',
    costs: 'Costs',
    cost: 'Cost',
    tokens: 'Tokens',
    requests: 'Requests',
    title: 'Usage',
    daily: 'Daily',
    hourly: 'Hourly'
  },
  feedback: {
    sendFeedback: 'Submit Feedback',
    description: 'Share your thoughts with us',
    title: 'Title',
    titleInputPlaceHolder: "What's on your mind?",
    body: 'Feedback',
    bodyInputPlaceHolder: 'Your feedback, anything you want to share with us.',
    footerDescription:
      'Providing feedback can help us improve our system and enhance the user experience for everyone.',
    sendButton: 'Send',
    thankYouTitle: 'Thank You!',
    thankYouMessage:
      'We got your feedback. It usually takes two days for us to get back with an answer but sometimes sooner.',
    okayButton: 'Okay',
    sendFailed: 'Sending Feedback failed',
    sendSuccess: 'Feedback sent',
    bodyCantBeEmpty: "Feedback can't be empty",
    bodyTooShort: 'Feedback is too short'
  },
  languages: {
    'fa-IR': 'Persian',
    'en-US': 'English'
    // Add other languages as needed
  },
  paymentStatus: {
    success: 'Success',
    pending: 'Pending',
    failed: 'Failed',
    processing: 'Processing'
  },
  status: {
    pending: 'Pending',
    completed: 'Completed',
    failed: 'Failed'
  },
  reports: {
    longerFramesRateLimit:
      'For reports with a timeframe exceeding 3 days, only one request is permitted every 24 hours.',
    reportGenerationSubmitted:
      'Report submitted successfully. Check its status below; some reports can take up to 60 minutes.',
    downloadFailed: 'The report could not be downloaded. Try again after checking its status and expiry.',
    fetchFailed: 'The reports list could not be loaded. Try refreshing the page.',
    generatedSuccessfully: 'The report was generated and downloaded successfully.',
    generationFailed: 'The report could not be generated. Try again later.',
    linkedReportUnavailable: 'The linked report is unavailable, expired, or no longer belongs to this account.',
    title: 'API Consumption Reports',
    timeFrame: 'Time Frame',
    generateReport: 'Generate Report',
    reportSummary: 'Report Summary',
    downloadReport: 'Download',
    viewSummary: 'Summary',
    lastHour: 'Last hour',
    last6Hours: 'Last 6 hours',
    last12Hours: 'Last 12 hours',
    lastDay: 'Last 24 hours',
    last2Days: 'Last 48 hours',
    last3Days: 'Last 72 hours',
    lastWeek: 'Last week',
    last28Days: 'Last 28 days',
    lastMonth: 'Last month',
    last3Months: 'Last 3 months',
    last6Months: 'Last 6 months',
    lastYear: 'Last year',
    allTime: 'All time',
    columns: {
      language: 'Language',
      generatedAt: 'Generated At',
      timeFrame: 'Time Frame',
      expiresAt: 'Expires At',
      status: 'Status',
      origin: 'Origin'
    },
    origin: {
      selfService: 'Self service',
      support: 'Support'
    },
    summary: {
      user: 'User',
      dateRange: 'Date Range',
      generatedAt: 'Generated At',
      totalTransactions: 'Total Transactions',
      totalCostUnits: 'Total Cost Units',
      totalPaidUnits: 'Total Paid Units',
      totalPaidIRT: 'Total Paid IRT',
      totalPaidGrantIRT: 'Total Paid Grant IRT',
      financialDetails: 'Costs overview'
    }
  },
  billing: {
    addresses: {
      title: 'Billing addresses',
      subtitle: 'Create and manage the addresses used for billing, invoices, and support requests.',
      add: 'Add address',
      addFirst: 'Add your first address',
      total: 'Saved addresses',
      currentDefault: 'Current default',
      historyProtection: 'Historical records',
      historyProtectionValue: 'Protected',
      none: 'None',
      noName: 'Untitled',
      default: 'Default',
      makeDefault: 'Make default',
      edit: 'Edit',
      delete: 'Delete',
      deleteAll: 'Delete all addresses',
      searchPlaceholder: 'Search label, city, address, or postal code',
      empty: 'No billing addresses saved',
      noResults: 'No addresses match your search',
      loadFailed: 'Your addresses could not be loaded.',
      retry: 'Try again',
      defaultSuccess: 'Default address updated',
      defaultFailed: 'The default address could not be updated',
      deleteSuccess: 'Address deleted',
      deleteFailed: 'The address could not be deleted',
      defaultDeleteBlocked: 'Select another default address before deleting this one.',
      inUseDeleteBlocked: 'This address is used by a historical payment, invoice, or support request.',
      deleteConfirm: 'Delete {name}? This address will be removed from your active address book.',
      deleteConfirmAction: 'Delete address',
      deleteAllConfirmTitle: 'Delete all saved addresses?',
      deleteAllConfirmDescription:
        'All addresses, including the default, will disappear from your active address book. Historical billing records remain unchanged.',
      deleteAllConfirmAction: 'Delete all',
      deleteAllSuccess: '{count} addresses deleted',
      deleteAllFailed: 'The address book could not be deleted',
      summaryLabel: 'Address summary',
      statusRegion: 'Address book status',
      loadingLabel: 'Loading your addresses'
    },
    invoices: {
      title: 'Invoices & receipts',
      subtitle: 'Payment documents issued for your account.',
      total: 'Total documents',
      filters: 'Filters',
      allTypes: 'All document types',
      allStatuses: 'All statuses',
      standard: 'Standard receipt',
      vat: 'VAT invoice',
      type: 'Document type',
      status: 'Status',
      dateRange: 'Payment date',
      startDate: 'From date',
      endDate: 'To date',
      payment: 'Payment',
      paymentPlaceholder: 'Payment transaction ID',
      invalidPaymentId: 'Enter a valid payment transaction UUID.',
      invalidDateRange: 'From date must be on or before to date.',
      apply: 'Apply filters',
      reset: 'Reset',
      refresh: 'Refresh',
      tableDate: 'Date',
      tableType: 'Document type',
      tablePayment: 'Payment',
      tableAmount: 'Paid amount',
      tableStatus: 'Status',
      tableDocument: 'Documents',
      actions: 'Actions',
      receipt: 'Receipt',
      vatInvoice: 'VAT invoice',
      downloadReceipt: 'Download receipt',
      downloadVat: 'Download VAT invoice',
      resendEmail: 'Resend by email',
      requestDocuments: 'Request documents',
      requestReceipt: 'Request receipt',
      requestVat: 'Request VAT invoice',
      openInvoice: 'Open invoice',
      loadFailed: 'Invoices could not be loaded.',
      refreshFailed: 'Invoices could not be refreshed. Existing results are still available.',
      downloadFailed: 'The document could not be downloaded.',
      downloadSuccess: 'Document downloaded.',
      resendFailed: 'The email could not be queued.',
      resendQueued: 'Invoice email queued.',
      requestFailed: 'The document request could not be queued.',
      requestQueued: 'Document generation queued.',
      requestAlreadyAvailable: 'The document is already available.',
      requestAlreadyProcessing: 'Document generation is already in progress.',
      empty: 'No invoices found',
      emptyDescription: 'No payment documents match these filters.',
      toman: 'Toman',
      categories: {
        subscription: 'Subscription',
        credit_topup: 'Credit top-up',
        credit_package: 'Credit package'
      },
      documentStatuses: {
        generating: 'Generating',
        receiptGenerating: 'Payment receipt is being prepared',
        vatGenerating: 'Stamped VAT invoice is being prepared',
        available: 'Available',
        unavailable: 'Unavailable'
      }
    },
    noCreditPackages: 'No Credit Package!',
    manageCreditPackages: 'Manage Credit Packages',
    packagesTotalUnit: 'Total value in UNIT',
    expirationTimeline: 'Expiration Timeline',
    creditBreakdown: 'Credit Packages',
    unnamedPackage: 'Credit Package',
    sortOptions: {
      featured: 'Featured',
      price: 'Price (Low to High)',
      valueRatio: 'Value Ratio',
      newest: 'Newest',
      oldest: 'Oldest',
      expiration: 'Expiration Time'
    },
    packages: {
      myPackages: 'My Packages',
      promotional: 'Promotional',
      summary: {
        total: 'Total Packages',
        active: 'Active Packages',
        usage: 'Average Usage',
        remaining: 'Total Remaining',
        totalSources: 'Total Sources',
        packages: 'Credit Packages',
        grants: 'Grants',
        totalBalance: 'Total Balance'
      },
      tabs: {
        overview: 'Overview',
        usage: 'Usage Analytics',
        expiration: 'Expiration Timeline'
      },
      otp: {
        title: 'Verify Your {amount} Purchase',
        description: 'Please enter the 6-digit verification code sent to your phone to complete your purchase.',
        invalidLength: 'Invalid OTP length',
        send: 'Send Code',
        resent: 'OTP resent successfully',
        expiresIn: 'Code expires in {time}',
        expired: 'Verification code has expired',
        cancel: 'Cancel',
        verify: 'Verify Code',
        resend: 'Send New Code'
      },
      timeline: {
        expired: 'Expired',
        thisMonth: 'This Month',
        nextMonth: 'Next Month',
        noExpiration: 'No packages have expiration dates',
        expiredCount: 'Expired packages',
        expiringThisWeek: 'Expiring this week',
        expiringThisMonth: 'Expiring this month',
        safePeriod: 'Safe period (30+ days)',
        summary: 'Summary',
        later: 'Later',
        remaining: 'Remaining'
      },
      filters: {
        title: 'Filters',
        reset: 'Reset Filters',
        allServices: 'All Services',
        serviceType: 'Service Type',
        apiOnly: 'API Only',
        subscriptionOnly: 'Subscription Only',
        showPromotional: 'Show Promotional Packages',
        priceRange: 'Price Range',
        subServices: 'Sub Services',
        modelFamilies: 'Model Families',
        subscriptionTiers: 'Subscription Tiers'
      },
      authRequired: {
        title: 'Authentication Required',
        description: 'Please log in to view your purchased packages and track their usage.'
      },
      paymentMethods: {
        bankCard: 'Bank Card',
        creditBalance: 'Credit Balance'
      },
      status: {
        all: 'All',
        active: 'Active',
        expired: 'Expired',
        exhausted: 'Exhausted'
      },
      totalAmountBePaid: 'Total Amount to Pay',
      totalCreditsReceiving: 'Total Credits Receiving',
      empty: 'No packages available',
      emptyDescription: 'There are currently no credit packages available for purchase',
      allServices: 'All Services',
      noExpiration: 'No Expiration',
      creditPackages: 'Credit Packages',
      grantCredits: 'Grant Credits',
      generalBalance: 'General Balance',
      generalBalanceDescription: 'Your main wallet balance for all services',
      creditsPerToman: 'more credits',
      expired: 'Expired',
      expirestoday: 'Expires Today',
      expiresTomorrow: 'Expires Tomorrow',
      expiresInDays: 'Expires in {days} days',
      expiresInWeeks: 'Expires in {weeks} weeks',
      expiresOn: ' on {date}',
      redirectingToPayment: 'Redirecting to payment gateway',
      purchaseComplete: 'Purchase completed successfully',
      purchaseSuccessMessage:
        'Your credit package has been purchased and added to your account. You can now view and manage it in your packages section.',
      goToMyPackages: 'Go to My Packages',
      purchaseFailed: 'Purchase failed. Please try again.',
      insufficientCredit: 'Insufficient Credit Balance',
      insufficientCreditMessage:
        "You don't have enough credit balance to complete this purchase. You need {shortfall} more.",
      choosePaymentOption: 'Choose a payment option:',
      useDirectPayment: 'Use Direct Card Payment',
      topUpCredit: 'Top Up Credit Balance',
      otpFailed: 'OTP verification failed',
      paymentCheckFailed: 'Failed to check payment status. Please try again.',
      openPaymentPage: 'Open Payment Page',
      paymentPending: 'Your payment is still pending. Please complete the payment or try again later.',
      paymentNotFound: 'Transaction not found. Please try the purchase again.',
      clearFilters: 'Clear Filters',
      browse: 'Browse Packages',
      title: 'Credit Packages',
      description: 'Purchase credit packages to access our AI services and manage your account balance.',
      marketplace: 'Marketplace',
      purchaseTitle: 'Purchase Package',
      quantity: 'Quantity',
      packages: 'packages',
      paymentMethod: 'Payment Method',
      unitPrice: 'Unit Price',
      toman: 'Toman',
      totalAmount: 'Total Amount',
      totalCredits: 'Total Credits',
      cancel: 'Cancel',
      confirmPurchase: 'Confirm Purchase',
      processingPayment: 'Processing Payment...',
      noPackagesFound: 'No packages found',
      purchasedOn: 'Purchased on {date}',
      usage: 'Usage',
      remaining: 'Remaining',
      used: 'Used',
      viewDetails: 'View Details',
      viewDetailsTooltip: 'Click to view detailed usage statistics',
      featured: 'Featured',
      apiService: 'API Service',
      subscriptionService: 'Subscription Service',
      scope: 'Scope',
      validFor: 'Valid for {days} days',
      maxPerUser: 'Max {count} per user',
      unavailable: 'Unavailable',
      purchase: 'Purchase',
      browsePackages: 'Browse Packages',
      noPackages: 'No packages found',
      package: 'Package',
      availableModels: 'Available Models',
      balance: 'Balance',
      grant: 'Grant',
      maxQuantity: 'Max Available Quantity',
      packageScope: 'Package Scope',
      valueRatioTooltip: "You'll get more credit to spend compared the amount you pay for",
      packageScopeTooltip:
        'The list of authorized services covered by the credit package may include specific models or services. This package is exclusively designed for use within the scope of authorized coverage as detailed in the package description. By purchasing this package, you will not be able to benefit from discounts on other models or services not covered by the package. If you use services that are not included in the coverage, charges will be calculated at standard rates',
      agreements: {
        title: 'Purchase Agreement',
        description: 'Please read and accept the following terms before proceeding with your purchase:',
        balanceRequirement:
          'To utilize credit packages effectively, your general account balance must maintain a positive value. API services will be automatically deactivated if the general balance reaches zero or becomes negative. We recommend maintaining a minimum balance of 0.5 UNIT (or equivalent) to ensure uninterrupted service.',
        expirationPolicy:
          'Credit packages include a fixed expiration date that cannot be extended under any circumstances. Once expired, packages cannot be renewed or restored, regardless of remaining unused credits.',
        serviceCoverage:
          'Each credit package applies exclusively to the services and models specified in its description. Credits cannot be transferred or applied to other services, models, or features not explicitly included in the package terms.',
        acceptTerms: 'I have read and accept all terms and conditions above',
        mustAcceptTerms: 'You must accept the terms and conditions to proceed with the purchase.',
        balanceRequirementTitle: 'Account Balance Requirement',
        expirationPolicyTitle: 'Package Expiration Policy',
        serviceCoverageTitle: 'Service Coverage Limitation',
        serviceTierLimitationTitle: 'Service Tier Limitation',
        serviceTierLimitation:
          "Credit packages only cover API requests made with the default 'standard' service tier. If you use the 'flex' service tier (by setting service_tier=\"flex\" in your API requests), those costs will NOT be deducted from your package credits and will instead be charged to your standard account balance."
      }
    },
    notificationWillBe: 'Notifications will be sent to',
    thresholdsMustBeDivisibleByFive: 'Thresholds must be divisible by 5',
    thresholdsMustBeLeast: 'Thresholds must be at least ',
    creditNotificationSaved: 'Notification settings saved successfully',
    additionalRecipientsDescription:
      'Notifications are sent to the email address and phone number registered in your account. However, if you need notifications to be sent to additional phone numbers or email addresses, you can add them below.',
    addUpToTwoEmailsAndPhones: 'Add up to 2 additional email addresses and phone numbers',
    additionalRecipients: 'Additional Recipients',
    notificationThresholds: 'Notification Thresholds',
    receiveAlertsWhen: 'Receive alerts when your credit balance reaches specified thresholds',
    creditNotificationSettings: 'Credit Notification Settings',
    packageBalanceWarning: {
      title: 'Credit Package Balance Warning',
      message:
        'You have active credit packages, but your general account balance is zero or negative. API services will be automatically deactivated until you recharge your account.',
      requirement: 'A positive general balance is required to use credit packages and keep your API keys active.',
      action: 'Recharge your account now to reactivate your API services.',
      rechargeButton: 'Recharge Account'
    },
    loadingCreditNotificationSettings: 'Loading your notification settings',
    creditNotificationDisabled: 'Credit notifications are currently disabled',
    creditNotificationAt: 'Notifications enabled at these thresholds',
    creditNotification: 'Credit Notifications',
    rateExpired: 'Exchange Rate Expired',
    clickRefreshToUpdate: 'Click refresh to update rates',
    refreshRate: 'Refresh Rate',
    amountMustBePositive: 'Exchange amounts must be greater than zero',
    invalidExchangeAmount: 'Invalid exchange amount. Please check your input.',
    invalidExchangeParameters: 'Invalid exchange parameters',
    exchangeReviewFailed: 'Failed to review exchange. Please try again.',
    error: 'Error',
    exchangeSuccessful: 'Exchange completed successfully',
    exchangeFailedUnknown: 'Exchange failed for unknown reason',
    exchangeValidationFailed: 'Exchange validation failed',
    unauthorizedExchange: 'Unauthorized to perform exchange',
    tooManyRequests: 'Too many requests, please try again later',
    tooManyRequestsDesc: '',
    exchangeFailed: 'Failed to complete exchange',
    refreshDataFailed: 'Failed to refresh data',
    totalPaidInUnitTooltip:
      'Shows the total amount of credits (in UNIT) added to this account since creation. Each top-up is calculated using the exchange rate that was active at the time of purchase, not the current rate.',
    totalPaidInUnit: 'Total Paid In Unit',
    historyAmount: 'Amount',
    paymentId: 'Id',
    trackingCode: 'Tracking Code',
    paymentStatusFailed: 'Failed to recheck payment status',
    paymentStatusUpdated: 'Payment status updated',
    paymentHistorySearchPlaceholder: 'Tracking code, transaction ID or payment ID',
    // Deep-link (?txid= / ?id= / ?tracking=) outcomes when the payment is not in
    // the loaded history payload. The identifier itself is rendered separately in
    // a <bdi> so the LTR code never gets bidi-reordered inside RTL copy.
    deepLinkPending:
      'This payment exists but has not been recorded in your history yet — the bank has not reported a result. Refresh in a moment.',
    deepLinkMissing: 'No payment matching this identifier was found in your account.',
    deepLinkUnavailable: 'We could not verify this payment right now. Please try again in a moment.',
    paymentTracking: {
      processingTitle: 'Waiting for payment…',
      processingDescription:
        'We opened the bank gateway in a new tab. Complete the payment there, then come back here — this page will check the result automatically.',
      pendingTitle: 'Payment is still pending',
      pendingDescription:
        'The bank has not confirmed your payment yet. If you completed it, wait a moment and recheck, or look it up in your payment history using the tracking code.',
      successTitle: 'Payment confirmed',
      successDescription: 'Your payment was received and your balance has been updated.',
      failedTitle: 'Payment could not be confirmed',
      failedDescription:
        'We could not verify this payment. If you believe you were charged, use the tracking code to look it up in your payment history or contact support.',
      viewPaymentHistory: 'Look up in Payment History',
      copyTrackingCode: 'Copy tracking code',
      keepThisCode: 'Keep this tracking code — you can use it to find this payment later.',
      closeGuardTitle: 'Leave before your payment is confirmed?',
      closeGuardDescription:
        'Your payment is still being processed. If you leave now, copy the tracking code so you can check the result later in your payment history.',
      closeGuardConfirm: 'Keep tracking',
      closeGuardLeave: 'Leave anyway'
    },
    totalAmount: 'Total Amount',
    pendingTransactions: 'Pending Transactions',
    confirmedTransactions: 'Confirmed Transactions',
    selectStatus: 'Select Status',
    selectItemType: 'Select Item Type',
    paymentHistory: 'Payment History',
    paymentHistoryLoadFailed: 'Payment history could not be loaded. Try again.',
    totalTransactions: 'Total Transactions',
    purchaseItem: 'Type',
    subscription: 'Subscription',
    credit: 'Credit',
    confirmationDate: 'Confirmation Date',
    paidAmount: 'Paid Amount',
    discount: 'Discount',
    howToUseApi1: 'Get the remaining credit via API',
    sampleOutput: 'Sample response:',
    howToUseApi2:
      "Explanation: 'remaining_irt' is equivalent to 'remaining credit in Toman', 'remaining_unit' is equivalent to 'remaining credit converted to units (Tether rate)', 'exchange_rate' is the real-time conversion rate, and finally 'total_unit' is equivalent to all credits including those increased through bank payments, gift credits, grants, etc., based on the real-time conversion rate.",
    exhausted: 'exhausted',
    remainingDays: 'remaining days',
    remainingHours: 'remaining hours',
    remainingMinutes: 'remaining minutes',
    remaining: 'Remaining',
    expiration: 'Expiration',
    grantsTotalUnit: 'Total value in UNIT',
    unnamedGrant: 'Unnamed',
    grants: 'Grants',
    exchangeRateUSDT: 'USDT Rate',
    fee: 'Fees',
    timesUp: 'Transaction invalidated',
    reviewValidTill: 'Details invalidated in ',
    secondsValidAst: 'seconds.',
    exchangeTo: 'Exchange to',
    exchangeFrom: 'Exchange from',
    exchangeRate: 'Exchange rate',
    feeAmount: 'Fees',
    shortDesc1: 'Manage your billing information, view invoices, and update payment methods.',
    title: 'Billing',
    topup: 'TopUp',
    minAmount: 'Minimum',
    maxAmount: 'Maximum',
    IRI: 'IRR',
    IRT: 'IRT',
    UNIT: 'UNIT',
    total: 'Total',
    recharge: 'Recharge',
    confirm: 'Confirm',
    and: '',
    pay: 'Pay',
    remaningCredit: 'Remaining Credit',
    remainingCredit: 'Remaining Credit',
    remainingCreditTotalUnit: 'Total Remaining Credit in UNIT',
    zero: '0',
    noCredits: 'No Credit left',
    sourceAmount: 'Exchange',
    targetAmount: 'To',
    amount: 'Amount',
    exchange: 'Exchange',
    exchangeTitle: 'Currency Exchange',
    confirmAndExchange: 'Confirm & Exchnage',
    close: 'close',
    exchangeConfirmFailed: 'Exchange failed.',
    exchangeConfirmed: 'Exchange confirmed.',
    totalCost: 'Total Cost',
    loginToViewCredit: 'Login to view your actual credit balance and transaction history',
    phoneVerification: {
      title: 'Connect a phone number to continue',
      description:
        'To protect against fraud, accounts without a verified phone number are limited to {amount} IRT of payments per week. Please verify a phone number to continue.',
      weeklyLimitAmount: '5,000,000',
      infoBanner:
        'This limit applies to your total payments over the last 7 days. Enter and verify your phone number below; once verified, the limit is lifted and you can retry this payment.',
      verifyHere: 'Enter and verify your phone number below',
      alternativeNote:
        'If you prefer not to connect a phone number, you can reduce the payment amount or wait until earlier payments fall outside the 7-day window.',
      backToPayment: 'Back to payment'
    }
  },
  affiliate: {
    stepsTitle: 'Start Your Affiliate Journey',
    stepsDescription: 'Follow these simple steps to start earning rewards',
    step1Title: 'Get Your Invite Code',
    step1Description: 'Your personal invite code is ready to share',
    step1Description2: 'Sign In to Get Your Code',
    step2Title: 'Invite Friends',
    step2Description: 'Share your invite code with friends and colleagues',
    step2Description2: 'When they sign up using your code, both of you get benefits!',
    step3Title: 'Earn Rewards',
    step3Description: 'Earn commission for every transaction your invitees make',
    step3Description2: 'Track your earnings right here on this page!',
    title: 'Affiliate Marketing',
    descriptionLg:
      'Join our affiliate program and promote AvalAI to your network using the link below. Earn a share of the sales revenue and boost your income.',
    descriptionXs: 'Earn 10% commission on "Plus" subscription sales for one year from the date of your referral!',
    totalUsers: 'Total Referrals',
    usersAddedThisMonth: 'Referrals This Month',
    totalIncomeThisMonth: 'Earnings This Month',
    totalIncomeConfirmed: 'Total Earnings',
    totalIncomePending: 'Pending Earnings',
    inWithdrawalProcess: 'Withdrawal in Process',
    lastSettledIncome: 'Last Withdrawal',
    usersInMonth: 'Monthly Referrals',
    username: 'Username',
    registrationDate: 'Registration Date',
    lastTransactionDate: 'Last Transaction',
    confirmedCommission: 'Confirmed Commission',
    pendingCommission: 'Pending Commission',
    netIncome: 'Net Income',
    transactions: 'Transactions',
    noTransaction: 'No Transactions'
  },
  api: {
    couldNotFetchShowingCatched: 'Could not fetch latest key data. Showing cached data.',
    loadingKeyData: 'Loading the API key settings',
    keyNotFound: "API key not found, Please try refresh the page if you believe there's an error.",
    maxApiKeysReached: 'Max API keys reached, Please remove some keys before creating a new one.',
    invalidRequest: 'Invalid request. Please review the key details and try again.',
    noPermission: "You don't have permission to perform this action.",
    tooManyRequests: 'Too many requests. Please wait a moment and try again.',
    keyCreateFailed: 'Could not create the API key. Please try again.',
    keyEditFailed: 'Could not save the API key changes. Please try again.',
    endpointAccess: 'Endpoint Access',
    allowedEndpoints: 'Allowed Endpoints',
    allowedIntents: 'Allowed Intents',
    allEndpointsAllowed: 'All endpoints allowed',
    allIntentsAllowed: 'All intents allowed',
    noEndpointsAvailable: 'No endpoints available',
    noIntentsAvailable: 'No intents available',
    ipFormatHelp: 'Supported formats: IPv4 (e.g., 192.168.1.1), IPv6, and CIDR notation (e.g., 192.168.1.0/24)',
    invalidCIDRFormat: 'Invalid CIDR format',
    invalidCIDRRange: 'Invalid CIDR range (0-128)',
    invalidIPv4CIDRRange: 'Invalid IPv4 CIDR range (0-32)',
    invalidIPv4Address: 'Invalid IPv4 address',
    invalidIPv6Address: 'Invalid IPv6 address',
    ipExamples: 'Examples',
    max256IpsWarning: 'Maximum 256 IPs allowed. Some IPs were not imported.',
    noUsage: 'None',
    budgetUsed: 'Usage',
    keyModified: 'Key modified successfully',
    apiV4RangeNumebrs: 'IPv4 address numbers must be between 0 and 255',
    noModelsAvailable: 'No models available',
    allModelsAllowed: 'All models allowed',
    allowedModels: 'Allowed Models',
    forever: 'Forever',
    keyExpirationDay: 'Time To Live (days)',
    iPRestrictions: 'IP Restrictions',
    pleaseEnterValidIp: 'Please enter a valid IPv4 or IPv6 address',
    neverExpires: 'Never expires',
    keyExpiration: 'Key Expiration',
    totalBudget: 'Total Budget',
    noLimit: 'No limit',
    monthlyBudget: 'Monthly Budget',
    usageLimits: 'Usage Limits',
    ipAddressInfoFooter: 'Leave empty to allow all IPs. Enter IPv4 or IPv6 addresses or CIDR.',
    enterIpAddress: 'Enter IP address',
    uploadIpTips: 'Upload .txt or .csv',
    importIPs: 'Import IPs',
    securitySettings: 'Security Settings',
    advancedSettings: 'Advanced Settings',
    deleteAllIps: 'Delete All IPs',
    shortDesc1: 'Securely manage your API keys to authenticate and interact with our APIs.',
    noName: 'No name',
    showOnce: 'Secret key showing once, Please save it somewhere safe.',
    close: 'close',
    api: 'API',
    confirmRevoke: 'Are you sure to revoke the API key?',
    guardrail: {
      title: 'Guardrail Settings',
      description: 'Protect your API calls with guardrails',
      enabled: 'Guardrails Enabled',
      disabled: 'Guardrails Disabled',
      explanation: 'Guardrail Explanation',
      explanationTitle: 'How Guardrails Work',
      explanationContent:
        'Guardrails help protect your API calls by detecting and redacting sensitive information like API keys and tokens. When enabled, all API calls are processed through the detect-secrets system before reaching the LLM models, with sensitive data replaced by [REDACTED].',

      // Modal section titles
      currentImplementation: 'Current Implementation',
      performanceImpact: 'Performance Impact',
      howActivated: 'How Guardrails Are Activated',
      recommendation: 'Our Recommendation',
      futureDevelopment: 'Future Development',
      securityNotice: 'Security Notice',

      // Recommendation section
      recommended: 'Recommended',
      recommendationDesc:
        "We strongly recommend enabling guardrails for enhanced security. While it adds some latency, the protection it provides is valuable for most use cases. However, if your application requires minimal latency and you're confident in your data handling, you can disable this feature.",

      // Performance impact section
      latencyImpact:
        'Enabling guardrails adds a preprocessing step that increases request latency by approximately 200ms to 3000ms depending on the size and complexity of your input data.',
      latencyTooltip: 'Latency impact varies based on request size and complexity',
      disableForLowLatency:
        "If your application requires minimal latency and you're confident no sensitive data is being sent, you may choose to disable this feature to reduce overhead.",

      // Current implementation section
      detectSecrets: 'detect-secrets',
      implementationDetails:
        'Currently, our guardrail system implements <strong>{0}</strong>, which uses the <a href="{1}" target="_blank" rel="noopener">Yelp/detect-secrets</a> open-source project to detect and clean sensitive data such as API keys and tokens in your API calls.',
      redactionProcess:
        'When the guardrail detects sensitive information, it automatically replaces it with <code>[REDACTED]</code> before the request reaches the LLM models. This process leaves no logs of the sensitive data being cleaned, providing an additional layer of security.',

      // Activation methods section
      userLevelTitle: 'User-level activation',
      userLevelDesc: 'When enabled in your user settings, all API calls are automatically scanned and protected',
      perRequestTitle: 'Per-request activation',
      perRequestDesc:
        'You can include <code>guardrails: ["hide-secrets"]</code> in your API request data to activate guardrails for that specific call, even if disabled at the user level',

      // Future development section
      futureDesc:
        'Currently, users cannot define custom guardrails, but we plan to enhance this system with more advanced security measures and customization options in future updates.',

      // Security notice section
      securityDesc:
        'While our guardrail system provides an additional layer of security, it is not guaranteed to detect all sensitive information. The effectiveness depends on the underlying detect-secrets project. We recommend following security best practices and avoiding sending sensitive information in your API calls whenever possible.'
    },
    removeConfirmYes: 'Confirm & revoke',
    removeConfirmNo: 'Cancel',
    remove: 'Revoke',
    edit: 'Edit',
    update: 'Update',
    editSecretKey: 'Edit secret key',
    editingSecretKey: 'Editing secret key',
    cancel: 'Cancel',
    createNewSecret: 'Create secret key',
    cName: 'Name',
    cSecret: 'Secret Key',
    cCreated: 'Created',
    cLastUsed: 'Last used',
    cActions: 'Actions',
    title: 'API Keys',
    editKey: 'Edit Secret Key',
    createKey: 'Create new key',
    keyName: 'Name',
    keyNamePlaceholder: 'My Test Key',
    createNewKey: 'Create secret key',
    maskedKeysShown: 'Your API keys are listed below.',
    howToUse1: 'To use your keys, set base_url="https://api.avalai.ir/v1" in OpenAI SDK.',
    howToUse2: 'this post',
    konid: '',
    info2:
      'Do not share your API key with others, or expose it in the browser or other client-side code.  Please note that we do not display your secret API keys again after you generate them.',
    howToUse3:
      "Use official OpenAI libraries/frameworks, or ensure your HTTP requests follow OpenAI's standard structure to access all services.",
    propagatingKey: 'Propagating API Key',
    propagationMessage:
      'Your API key is being securely propagated to our infrastructure. This usually takes about 30 seconds.',
    propagationStatus: 'Syncing across regions...'
  },
  summary: {
    requests: 'Requests',
    noUsageDataTooltip: 'No usage data available. Once data is recorded, it will appear here',
    remainingCredit: 'Remaining Credit',
    totalTokens: 'Total Tokens',
    totalRequests: 'Total Requests',
    remainingCreditUnit: 'Remaining (UNIT)',
    remainingCreditIrt: 'Remaining (IRT)',
    usageTrends: 'Usage Trends',
    last7Days: 'Last 7 Days',
    last28Days: 'Last 28 Days',
    modelTokenDistribution: 'Model Token Distribution',
    dailyRequests: 'Daily Requests',
    topModelsUsage: 'Top Models Usage',
    hourlyUsageTokens: 'Hourly Token Usage',
    hourlyUsageRequests: 'Hourly Requests',
    period1Hour: 'Last Hour',
    period6Hours: 'Last 6 Hours',
    period12Hours: 'Last 12 Hours',
    period24Hours: 'Last 24 Hours',
    cost: 'Cost',
    inputTokens: 'Input Tokens',
    outputTokens: 'Output Tokens',
    activeGrants: 'Active Grants',
    expiresIn: 'Expires In',
    days: 'Days',
    recentTransactions: 'Recent Transactions',
    currency: 'Currency',
    modelTokenUsage: 'Model Token Usage',
    last1Hour: 'Last 1 Hour',
    last6Hours: 'Last 6 Hours',
    last12Hours: 'Last 12 Hours',
    last24Hours: 'Last 24 Hours',
    dailyTrendNotAvailable: 'Detailed daily trend view is available for 7-day and 28-day periods.',
    totalCost: 'Total Cost'
  },
  error: {
    fetchFailed: 'Fetch data failed'
  },
  system: {
    title: 'AvalAI'
  },
  common: {
    to: 'To',
    input: 'Input',
    output: 'Output',
    remainingTime: 'Remaining Time',
    at: 'at',
    allTiers: 'All Tiers',
    allModels: 'All Models',
    outof: 'Out of',
    days: 'Days',
    hours: 'Hours',
    minutes: 'Minutes',
    moreItems: 'more',
    tiers: 'Tiers',
    models: 'Models',
    discountOff: 'off',
    discount: 'discount',
    fetchFailed: 'Fetch data failed',
    sort: 'Sort',
    tier: 'level',
    copy: 'Copy',
    projectUpdates: 'Project Updates',
    viewAll: 'View All',
    readMore: 'Read More',
    loadMore: 'Load More',
    noResults: 'No Results Found',
    resultsFoundInOtherTabs: 'Results Found in Other Tabs',
    noResultsInCurrentTab: 'No Result found in This Tab',
    and: 'and',
    next: 'Next',
    additionalPersianOnly: '',
    additionalEnglishOnly: 'additional',
    additional: 'additional',
    emailAddress: 'email address',
    phoneNumber: 'phone number',
    fetchError: 'Failed to fetch data',
    tier1AndAbove: 'Tier 1 or above',
    tier3AndAvove: 'Tier 3 or above',
    tier5Only: 'Tier 5',
    requiresTier1: 'This feature requires Tier 1 or above',
    requiresTier3: 'Custom thresholds require Tier 3 or above',
    requiresTier5: 'Additional recipients require Tier 5',
    fixErrorsBeforeSaving: 'Please fix the form errors before saving',
    failedToSaveSettingsTryAgain: 'Failed to save settings. Please try again.',
    equivalent: 'Equivalent',
    manage: 'Manage',
    threshold: 'Threshold',
    saveChanges: 'Save Changes',
    saving: 'Saving',
    phone: 'phone',
    email: 'Email',
    recipients: 'Recipients',
    thresholds: 'thresholds',
    custom: 'Custom',
    default: 'Default',
    retry: 'Retry',
    pageLoading: 'Loading page...',
    pageLoadError: 'Failed to load page',
    pageLoadErrorDesc: 'An error occurred while loading this page. Please try again.',
    useInApi: 'Use in API',
    seconds: 'Seconds',
    docs: 'Documentation',
    learnMore: 'Learn More',
    save: 'Save',
    select: 'Select',
    comingSoon: 'Coming Soon',
    attach: 'Attach',
    back: 'Back',
    clickToCopy: 'Click to copy',
    disabled: 'Disabled',
    enabled: 'Enabled',
    hide: 'Hide',
    configure: 'Configure',
    show: 'Show',
    systemStatus: 'System Status',
    page: 'page',
    total: 'total',
    showLess: 'Show Less',
    showMore: 'Show More',
    downloadError: 'Dowload failed, please try again.',
    downloadSuccess: 'Download Succeeded',
    downloadCSV: 'Download CSV',
    downloadExcel: 'Download Excel',
    download: 'Download',
    api: 'API',
    credit: 'Credit',
    subscription: 'Subscription',
    recheck: 'Recheck',
    nothingFound: 'Nothing found',
    time: 'Time',
    date: 'Date',
    somethingWentWrongRefreshPage: 'Something went wrong, Please retry again',
    shortCuts: 'Quick Access',
    phoneAlreadyVerified: 'Phone number verified successfully, refreshing in a moment...',
    phoneVerificationRequired: 'A verified phone number required, Please enter your phone number.',
    backToChat: 'Chat Platform',
    copied: 'Copied',
    copyFailed: 'Something went wrong',
    optional: 'optional',
    action: 'Action',
    add: 'Add',
    addSuccess: 'Add Success',
    backToHome: 'Back to home',
    batchDelete: 'Batch Delete',
    cancel: 'Cancel',
    close: 'Close',
    check: 'Check',
    columnSetting: 'Column Setting',
    config: 'Config',
    confirm: 'Confirm',
    delete: 'Delete',
    deleteSuccess: 'Delete Success',
    confirmDelete: 'Are you sure you want to delete?',
    edit: 'Edit',
    index: 'Index',
    keywordSearch: 'Please enter keyword',
    logout: 'Logout',
    logoutConfirm: 'Are you sure you want to log out?',
    lookForward: 'Coming soon',
    modify: 'Modify',
    modifySuccess: 'Modify Success',
    noData: 'No Data',
    operate: 'Operate',
    pleaseCheckValue: 'Please check whether the value is valid',
    refresh: 'Refresh',
    reset: 'Reset',
    search: 'Search',
    switch: 'Switch',
    tip: 'Tip',
    trigger: 'Trigger',
    update: 'Update',
    updateSuccess: 'Update Success',
    userCenter: 'User Center',
    yesOrNo: {
      yes: 'Yes',
      no: 'No'
    },
    newsCategories: {
      announcement: 'Announcement',
      api: 'API',
      models: 'Models',
      performance: 'Performance',
      billing: 'Billing',
      security: 'Security',
      feature: 'Feature',
      documentation: 'Documentation',
      tutorial: 'Tutorial',
      release: 'Release'
    },
    noUpdates: 'No updates available'
  },
  request: {
    logout: 'Logout user after request failed',
    logoutMsg: 'User status is invalid, please log in again',
    logoutWithModal: 'Pop up modal after request failed and then log out user',
    logoutWithModalMsg: 'User status is invalid, please log in again',
    refreshToken: 'The requested token has expired, refresh the token',
    tokenExpired: 'The requested token has expired'
  },
  theme: {
    themeSchema: {
      title: 'Theme Schema',
      light: 'Light',
      dark: 'Dark',
      auto: 'Follow System'
    },
    layoutMode: {
      title: 'Layout Mode',
      vertical: 'Vertical Menu Mode',
      horizontal: 'Horizontal Menu Mode',
      'vertical-mix': 'Vertical Mix Menu Mode',
      'horizontal-mix': 'Horizontal Mix menu Mode'
    },
    themeColor: {
      title: 'Theme Color',
      primary: 'Primary',
      info: 'Info',
      success: 'Success',
      warning: 'Warning',
      error: 'Error',
      followPrimary: 'Follow Primary'
    },
    scrollMode: {
      title: 'Scroll Mode',
      wrapper: 'Wrapper',
      content: 'Content'
    },
    page: {
      animate: 'Page Animate',
      mode: {
        title: 'Page Animate Mode',
        fade: 'Fade',
        'fade-slide': 'Slide',
        'fade-bottom': 'Fade Zoom',
        'fade-scale': 'Fade Scale',
        'zoom-fade': 'Zoom Fade',
        'zoom-out': 'Zoom Out',
        none: 'None'
      }
    },
    fixedHeaderAndTab: 'Fixed Header And Tab',
    header: {
      height: 'Header Height',
      breadcrumb: {
        visible: 'Breadcrumb Visible',
        showIcon: 'Breadcrumb Icon Visible'
      }
    },
    tab: {
      visible: 'Tab Visible',
      cache: 'Tab Cache',
      height: 'Tab Height',
      mode: {
        title: 'Tab Mode',
        chrome: 'Chrome',
        button: 'Button'
      }
    },
    sider: {
      inverted: 'Dark Sider',
      width: 'Sider Width',
      collapsedWidth: 'Sider Collapsed Width',
      mixWidth: 'Mix Sider Width',
      mixCollapsedWidth: 'Mix Sider Collapse Width',
      mixChildMenuWidth: 'Mix Child Menu Width'
    },
    footer: {
      visible: 'Footer Visible',
      fixed: 'Fixed Footer',
      height: 'Footer Height',
      right: 'Right Footer'
    },
    themeDrawerTitle: 'Theme Configuration',
    pageFunTitle: 'Page Function',
    configOperation: {
      copyConfig: 'Copy Config',
      copySuccessMsg: 'Copy Success, Please replace the variable "themeSettings" in "src/theme/settings.ts"',
      resetConfig: 'Reset Config',
      resetSuccessMsg: 'Reset Success'
    }
  },

  sponsorship: {
    common: {
      irt: 'Toman',
      notAvailable: 'N/A',
      seconds: '{count} seconds'
    },
    programs: {
      startups: {
        name: 'AvalAI Startup Sponsorship',
        description:
          'Progressive API credit for eligible startups, with clear verification and growth milestones.'
      },
      unknown: {
        name: 'AvalAI sponsorship program',
        description: 'Program details are not available right now.'
      }
    },
    actions: {
      application_create: {
        label: 'Start application',
        description: 'Create your sponsorship application and continue with company information.'
      },
      application_reapply: {
        label: 'Apply again',
        description: 'Start a new application now that the reapplication window is open.'
      },
      application_update_company: {
        label: 'Update company information',
        description: 'Review and save the company information requested for this application.'
      },
      application_update_identity: {
        label: 'Update representative information',
        description: 'Re-enter the legal representative details through the protected identity step.'
      },
      verification_retry: {
        label: 'Retry identity verification',
        description: 'Check the representative details and start a new verification attempt.'
      },
      verification_start: {
        label: 'Verify identity',
        description: 'Save the representative details and start identity verification.'
      },
      application_submit: {
        label: 'Submit application',
        description: 'Review the saved details and submit this application to AvalAI.'
      },
      application_step_submit: {
        label: 'Save this requirement',
        description: 'Send this requirement using the current program definition.'
      },
      level_continue: {
        label: 'Continue level journey',
        description: 'Open the exact available requirement for the current sponsorship level.'
      },
      application_withdraw: {
        label: 'Withdraw application',
        description: 'Withdraw the current application after confirming the irreversible state change.'
      },
      status_view: {
        label: 'View application status',
        description: 'Open the current decision, evidence timeline, and available next step.'
      }
    },
    nextEvents: {
      application_not_started: 'Start an application when you are ready.',
      applicant_company_details_required: 'Company information is the next required step.',
      applicant_identity_required: 'Legal representative information is required next.',
      identity_verification_required: 'Start identity verification after reviewing the representative details.',
      identity_verification_queued: 'Identity verification is queued with the provider.',
      identity_verification_running: 'The provider is checking the representative identity.',
      identity_verification_failed: 'Identity verification did not pass. Review the details before retrying.',
      identity_verification_retry_available: 'A new identity verification attempt is available.',
      application_submission_required: 'Review the saved application and submit it for assessment.',
      applicant_step_unavailable: 'This requirement is currently read-only and cannot be submitted here.',
      application_review_pending: 'The application is waiting for the AvalAI review team.',
      application_modification_required: 'Update only the fields identified in the latest reviewer feedback.',
      application_cooldown_active: 'Reapplication becomes available when the policy deadline ends.',
      application_reapply_available: 'The reapplication window is open.',
      credit_grant_pending: 'The approved sponsorship credit is waiting for operator activation.',
      credit_active: 'The current credit remains available until its displayed expiry.',
      next_level_available: 'The next sponsorship level is ready to continue.',
      next_level_manual_gate: 'The next level is waiting for an AvalAI manual review.',
      application_complete: 'This sponsorship application journey is complete.'
    },
    timing: {
      applicant_controlled: 'You control when this step is completed.',
      provider_controlled: 'The identity provider controls this processing time.',
      reviewer_controlled: 'The AvalAI review team controls this review time.',
      policy_deadline: 'This policy deadline is enforced automatically.',
      operator_controlled: 'An authorized AvalAI operator completes this step.',
      credit_deadline: 'The displayed credit expiry is authoritative.',
      complete: 'No further timing event is pending.'
    },
    errors: {
      validation_failed: 'Some information is invalid. Review the highlighted fields and try again.',
      authentication_required: 'Your session expired. Verify your phone number to continue safely.',
      action_forbidden: 'Your account is not allowed to perform this sponsorship action.',
      resource_not_found: 'This sponsorship program or application is no longer available.',
      revision_conflict: 'The application changed in another session. Review the latest saved version before continuing.',
      idempotency_conflict: 'This request identifier was already used for a different operation. Start a new action.',
      action_not_available: 'That action is no longer available. Follow the current next step instead.',
      workspace_v2_not_enabled:
        'This account is not enabled for the sponsorship workspace. No changes were sent.',
      cooldown_active: 'Reapplication is still blocked until the displayed cooldown deadline.',
      schema_revision_conflict: 'The form requirements changed. Reload the current step and review your draft.',
      rate_limited: 'Too many requests were sent. Wait for the displayed retry period before trying again.',
      verification_unavailable: 'Identity verification is temporarily unavailable. Your application remains unchanged.',
      temporary_unavailable: 'The sponsorship service is temporarily unavailable. Please retry safely.'
    },
    operations: {
      queued: 'Verification is queued.',
      running: 'Verification is in progress.',
      failed: 'Verification failed.',
      retryable_error: 'Verification could not finish and may be retried.',
      passed: 'Verification passed.',
      cancelled: 'Verification was cancelled.',
      manual_override: 'Verification was completed by an authorized AvalAI reviewer.',
      unknown: 'Verification status is unavailable. Refresh before taking another action.'
    },
    recovery: {
      sessionExpiredTitle: 'Verify your session',
      sessionExpiredDescription: 'Your session expired. Complete phone verification, then the current workspace will reload.',
      sessionExpiredAction: 'Verify and reload',
      conflictTitle: 'A newer application version is available',
      conflictDescription: 'Review the latest saved values before confirming or re-entering your changes.',
      conflictAction: 'Review latest version',
      ambiguousWrite: 'The write result is uncertain. Do not repeat the action while receipt recovery is running.',
      receiptPending: 'The operation receipt is still being checked.',
      rateLimited: 'Wait {seconds} seconds before retrying this sponsorship request.',
      rateLimitedSingular: 'Wait 1 second before retrying this sponsorship request.'
    },
    privacy: {
      identity: 'Identity numbers, phone verification, and provider details are never stored in the browser draft.',
      draftStorage: 'Only non-sensitive company fields are saved locally for up to 48 hours.',
      documentDisabled: 'Document upload is disabled. AvalAI will request supporting evidence through the manual review process.',
      unknownFallback: 'This state is not supported by the current client. Refresh the canonical workspace before continuing.'
    },
    evidence: {
      submit: 'Save requirement',
      saved: 'Requirement saved.',
      definitionChanged: 'This requirement changed. Review the updated fields before trying again.',
      fieldFallback: 'Application field {index}',
      formError: 'Review the highlighted fields and try again.',
      reviewUpdatedDefinition: 'I reviewed the updated requirement.',
      fields: {
        demo_url: 'Product demo URL',
        demo_notes: 'Product demo notes',
        market_summary: 'Market summary',
        users_count: 'User count',
        traction_summary: 'Traction summary',
        revenue_summary: 'Revenue summary',
        monthly_revenue_irt: 'Monthly revenue (Toman)'
      }
    },
    status: {
      draft: 'Draft',
      submitted: 'Submitted',
      under_review: 'Under review',
      needs_modification: 'Needs modification',
      approved: 'Approved',
      rejected: 'Rejected',
      active: 'Active',
      cooldown: 'Cooldown',
      completed: 'Completed',
      withdrawn: 'Withdrawn',
      locked: 'Locked',
      available: 'Available',
      in_progress: 'In progress',
      credit_granted: 'Credit granted',
      level_active: 'Level active',
      level_completed: 'Level completed',
      next_level_locked: 'Next level locked',
      pending: 'Pending',
      passed: 'Verified',
      failed: 'Failed',
      manual_override: 'Manually verified',
      unknown: 'Unknown status',
      applicationSummary: 'Application summary',
      title: 'Application status',
      none: 'You have not started an application yet.',
      cooldownUntil: 'Can re-apply after',
      creditUsage: 'Credit usage',
      grantedAmount: 'Granted amount',
      remaining: 'Remaining',
      expiresOn: 'Expires on',
      submissions: 'Step submissions',
      withdraw: 'Withdraw application',
      withdrawTitle: 'Withdraw application?',
      withdrawConfirm:
        'Withdrawing cancels your current application. You can start a new application when you are ready.',
      withdrawSuccess: 'Application withdrawn.',
      withdrawFailed: 'Could not withdraw the application. Please try again.',
      startNewApplication: 'Start a new application',
      needsModificationTitle: 'Changes requested',
      needsModificationHint:
        'The review team has requested modifications to your application. Please review the feedback and resubmit.',
      editAndResubmit: 'Edit & resubmit',
      expiresIn: 'Expires in',
      daysLeft: '{days} days left',
      expired: 'Expired',
      consumed: 'consumed',
      submittedOn: 'Submitted on',
      updatedOn: 'Last updated',
      highestLevel: 'Highest level reached',
      sectionCompany: 'Company',
      sectionRepresentative: 'Legal representative',
      sectionTimeline: 'Timeline',
      nextStep: "What's next",
      narrative: {
        generic:
          'Your sponsorship application status has been updated. Review the details below and follow any available next step.',
        draft: 'Your application is a draft. Finish the remaining steps and submit it for review.',
        submitted: 'Your application has been submitted. The AvalAI team will review it shortly.',
        under_review: "The AvalAI team is reviewing your application. We'll notify you once there's an update.",
        needs_modification: 'The review team requested changes. Update the highlighted details and resubmit.',
        approved: 'Your application is approved. Your sponsorship credit is being activated.',
        credit_granted: 'Your sponsorship credit has been granted and is ready to use.',
        rejected: 'This application was not approved. You may re-apply after the cooldown period.',
        active: 'Your sponsorship is active. Track your credit usage and level progress below.',
        level_active: 'Your sponsorship level is active. Track your credit usage and level progress below.',
        cooldown: "You're in a cooldown period. You can re-apply once it ends.",
        completed:
          "You've completed the sponsorship program. You can start a new application if you want to apply again.",
        level_completed: "You've completed this level. Review the next requirements to continue.",
        next_level_locked: 'Your next sponsorship level is locked until its required steps are complete.',
        withdrawn: 'You withdrew this application. You can start a new application when you are ready.'
      }
    },
    levels: {
      journeyTitle: 'Level overview',
      journeyLead: 'Review each sponsorship level, its requirements, and your current unlock status.',
      levelOf: 'Level {level} of {total}',
      stepsProgress: '{done}/{total} steps done',
      currentLevel: 'You are here',
      locked: 'Locked',
      unlockAfter: 'Unlocks after completing Level {level}',
      autoUnlock: 'Unlocks automatically when the previous level completes',
      manualReview: 'AvalAI review',
      manualReviewHint: 'Reviewed & approved by the AvalAI team',
      awaitingReview: 'Awaiting AvalAI review',
      needsModificationHint: 'Changes requested. Review the feedback and resubmit this level.',
      approvedHint: 'Approved. Credit grant is being prepared.',
      rejectedHint: 'This level was rejected. Review the feedback before re-applying.',
      completed: 'Completed',
      completionReasons: {
        exhausted: 'Credit exhausted',
        expired: 'Package expired',
        manual: 'Manually completed'
      },
      requiredStep: 'Required',
      optionalStep: 'Optional',
      reviewerNotes: 'Reviewer notes',
      documentUploadDeferred:
        'Evidence upload is not available here yet. AvalAI will request supporting documents during manual review.',
      previewSteps: 'View requirements',
      hideSteps: 'Hide requirements',
      noProgress: 'Apply to start your level journey.',
      unknownName: 'Sponsorship level',
      unknownDescription: 'Details for this sponsorship level are not available.'
    },
    levelNames: {
      '1': 'Level 1 — Onboarding',
      '2': 'Level 2 — Product Verification',
      '3': 'Level 3 — MVP / Market',
      '4': 'Level 4 — Proven Traction',
      '5': 'Level 5 — Scale'
    },
    levelDescriptions: {
      '1': 'Your starting credit. Submit your company details and verify the legal representative to activate it.',
      '2': 'Unlocks after your Level 1 credit is consumed or expires. Share a product demo so we can verify your product.',
      '3': 'For startups at MVP stage or in market. AvalAI reviews market presence and user-acquisition signals before approval.',
      '4': 'For startups with demonstrated traction. AvalAI reviews growth and traction signals before approval.',
      '5': 'For startups with revenue and product-market fit. Requires a final manual review by the AvalAI team.'
    },
    stepDescriptions: {
      company_form: 'Provide your incorporated company details.',
      identity_check: 'The legal representative provides their national ID and phone for verification.',
      product_demo: 'Share a product demo link or concise product notes when AvalAI requests this level review.',
      market_evidence: 'Summarize MVP or market presence for AvalAI review.',
      traction_docs: 'Summarize growth and traction for AvalAI review.',
      revenue_proof: 'Summarize revenue and product-market-fit signals for AvalAI review.',
      manual_review: 'Final manual review by the AvalAI team.',
      unknown: 'Details for this sponsorship requirement are not available.'
    },
    steps: {
      company_form: 'Company information',
      identity_check: 'Identity verification',
      product_demo: 'Product demo',
      market_evidence: 'Market & user acquisition',
      traction_docs: 'Traction review',
      revenue_proof: 'Revenue & PMF review',
      manual_review: 'Manual review',
      unknown: 'Sponsorship requirement'
    },
    apply: {
      title: 'Apply for Startup Sponsorship',
      introLead: 'Get API credits for your startup. Complete a short application; higher levels unlock as you grow.',
      start: 'Start application',
      stepIntro: 'Intro',
      stepAuth: 'Verify phone',
      stepCompany: 'Company',
      stepIdentity: 'Identity',
      stepReview: 'Review',
      verifyIdentity: 'Verify identity',
      editIdentity: 'Edit identity details',
      reviewLead: 'Review your information, then submit for review.',
      submit: 'Submit application',
      submitted: 'Application submitted for review.',
      saveFailed: 'Could not save your information. Please try again.',
      stepFailed: 'Could not record this step. Please try again.',
      fixFieldErrors: 'Please fix the highlighted fields.',
      onFile: 'Already on file — leave blank to keep',
      loadFailed: 'Could not load the program. Please try again.',
      loadDescription: 'We could not load the latest sponsorship data. Please retry before continuing.',
      serverLoadFailed:
        'The sponsorship service is temporarily unavailable. Please retry shortly or contact support if it continues.',
      rateLimited: 'Too many sponsorship requests were sent recently. Please wait a moment, then retry.',
      retry: 'Retry',
      reset: 'Reset form',
      resetTitle: 'Reset the form?',
      resetConfirm: "This clears the company and identity details you've entered. This cannot be undone.",
      draftRestored: 'Restored your saved progress.',
      conflictCompanyChangesDescription: 'The saved company information changed while you were editing.',
      conflictCompanyChangesDetail:
        'Review the saved and draft company values before confirming this change.',
      conflictCompanyUnchangedDescription: 'The application state changed while you were editing.',
      conflictCompanyUnchangedDetail:
        'No safe company fields differ, but the application state is newer. Review the current next step before continuing.',
      conflictIdentityDescription: 'The identity information changed while you were editing.',
      conflictIdentityDetail:
        'For your security, sensitive identity inputs were cleared. Enter them again before continuing.',
      conflictGenericDescription: 'The application changed while this action was being completed.',
      conflictGenericDetail:
        'Review the latest application state and its current next step before continuing.',
      draftSaved: 'Saved'
    },
    fields: {
      companyName: 'Company name',
      companyRegisterId: 'Company registration ID',
      companyNationalId: 'Company national ID',
      website: 'Website',
      domain: 'Domain',
      legalRepName: 'Legal representative full name',
      legalRepNationalId: 'Legal representative national ID',
      contactPhone: 'Contact phone',
      verification: 'Identity verification'
    },
    validation: {
      required: '{field} is required.',
      companyName: 'Enter the registered company name.',
      companyRegisterId: 'Enter the company registration ID.',
      companyNationalId: 'Company national ID must be 11 digits.',
      website: 'Enter a valid HTTPS website URL.',
      domain: 'Enter a valid domain name without protocol.',
      legalRepName: 'Enter the legal representative full name.',
      legalRepNationalId: 'Enter a valid national ID.',
      contactPhone: 'Enter a valid mobile number.',
      otp: 'Enter the valid verification code sent to your phone.'
    },
    auth: {
      phoneHint:
        "Enter your phone number; we'll send a verification code. A new account is created automatically if needed.",
      phoneInputLabel: 'Phone number',
      codeInputLabel: 'Verification code',
      sendCode: 'Send code',
      resend: 'Resend code',
      resendIn: 'Resend in {time}s',
      verifyAndContinue: 'Verify & continue',
      codeSent: 'Verification code sent.',
      applyingAsPrefix: 'Applying as',
      continue: 'Continue',
      useDifferentNumber: 'Use a different number',
      welcomeNew: 'Welcome! Your account has been created.',
      welcomeBack: 'Welcome back!',
      codeInvalid: 'The code is invalid or expired.',
      sendFailed: 'Could not send the code. Please try again.',
      tooManyRequests: 'Too many requests. Please try again later.',
      forbidden: 'This action is not allowed.',
      userNotFound: 'No account found for this number.',
      phoneConflict: 'This phone number is already linked to another account.'
    },
    verification: {
      pendingTitle: 'Identity verification in progress',
      pendingHint: "Identity verification is in progress. We'll update your application once it completes.",
      passedHint: 'Your identity has been verified.',
      failedHint: 'Identity verification did not pass. Please check the details and try again.',
      manual_overrideHint: 'Your identity was verified by the AvalAI review team.',
      stillPending: 'Verification is still running. You can leave this page; the status will update automatically.'
    },
    hub: {
      memberTitle: 'Your sponsorship',
      memberLead: 'Track your benefits, credit usage and level progression.',
      prospectTitle: 'Grow your startup with sponsored API credits',
      prospectLead:
        'Join the Startup Sponsorship Program to receive API credits across five levels as your company grows.',
      pendingTitle: 'Your application is in progress',
      pendingLead: "We'll keep you posted. You can review or continue your application below.",
      nextLevelActionTitle: 'Your next level is ready',
      nextLevelActionLead: 'Complete the newly unlocked level requirements from your level journey.',
      currentLevel: 'Current level',
      yourBenefits: 'Your benefits',
      benefitCredit: 'Sponsored API credit for your startup',
      benefitModels: 'Access to premium AI models',
      benefitSupport: 'Priority support',
      benefitGrowth: 'Higher levels unlock as you grow',
      nextLevel: 'Next level',
      nextLevelHint: 'Complete the current level to unlock the next one.',
      viewStatus: 'View status',
      viewLevels: 'View levels',
      continueApplication: 'Continue application',
      continueLevelJourney: 'Continue level journey',
      applyNow: 'Apply now',
      plansTitle: 'Sponsorship plans',
      plansLead: 'Five levels of API credit, unlocked progressively as your startup grows.',
      howItWorks: 'How it works',
      step1Title: 'Apply',
      step1Desc: 'Verify your phone and submit your company details in a short wizard.',
      step2Title: 'Verify',
      step2Desc: 'We verify your identity and review your application.',
      step3Title: 'Get credits',
      step3Desc: 'On approval, sponsored API credit is granted to your account.',
      step4Title: 'Grow & level up',
      step4Desc: 'Use your credit; higher levels unlock as you hit milestones.',
      eligibilityTitle: 'Who can apply',
      eligibilityItem1: 'Incorporated startups',
      eligibilityItem2: 'A verifiable legal representative identity',
      eligibilityItem3: 'A product or MVP for higher levels',
      cooldownNotice: 'You can re-apply after the cooldown period ends.',
      programFallbackNotice:
        'Live program data is temporarily unavailable. You can still review the sponsorship levels; retry before applying.',
      badge: 'Startup Sponsorship Program',
      heroStatCredit: '100M+',
      heroStatCreditLabel: 'Toman in credits',
      heroStatLevels: '5',
      heroStatLevelsLabel: 'Growth levels',
      heroStatFree: '0',
      heroStatFreeLabel: 'Upfront cost',
      secondaryCta: 'See the plans',
      planLevel: 'Level {level}',
      planUpTo: 'up to',
      planSelect: 'Start here',
      ctaBandTitle: 'Ready to accelerate your startup?',
      ctaBandSubtitle: 'Apply in minutes. Verify your phone, share your company details, and get your first credits.',
      trustLine: 'No credit card. No upfront cost. Credits granted on approval.',
      faqTitle: 'Frequently asked questions',
      faq1Q: 'How much does it cost?',
      faq1A: 'Nothing upfront. Sponsored API credits are granted to approved startups at no cost.',
      faq2Q: 'How do I move to a higher level?',
      faq2A:
        'Higher levels unlock as you consume your current credit and prove milestones like a product demo, traction, or revenue.',
      faq3Q: 'How long does approval take?',
      faq3A: 'After you submit, our team reviews your application and notifies you of the decision.'
    }
  },

  modelStudio: {
    title: 'Model Studio',
    subtitle: 'Test chat, multimodal, tools, structured output, and generated code.',
    overviewTitle: 'Overview',
    overviewSubtitle: 'Resume recent work or start a focused model task.',
    overviewConnectionTitle: 'Connection setup',
    overviewConnectionDescription:
      'Choose or generate a key in Playground when you are ready to run.',
    overviewConnectionAction: 'Open Playground',
    overviewResumeEyebrow: 'Continue where you left off',
    overviewResumeWorkflowDescription: 'Saved workflow',
    overviewResumeRequestDescription: 'Recorded request',
    overviewResumeEmptyTitle: 'Start your first run',
    overviewResumeEmptyDescription: 'Open Playground to build and run a model request.',
    overviewStartFirstRun: 'Start in Playground',
    overviewQuickActions: 'Quick starts',
    overviewOpenPlayground: 'Open Playground',
    overviewOpenPlaygroundDescription: 'Continue with your current local Studio state.',
    overviewBrowsePrompts: 'Browse prompts',
    overviewBrowsePromptsDescription: 'Open saved configurations and reusable prompt setups.',
    overviewCompareModels: 'Compare models',
    overviewCompareModelsDescription: 'Evaluate one prompt across two models.',
    overviewCreateWorkflow: 'Create workflow',
    overviewCreateWorkflowDescription: 'Start a blank reusable configuration.',
    overviewRecentWorkflows: 'Recent workflows',
    overviewRecentRequests: 'Recent requests',
    overviewViewAll: 'View all',
    overviewNoWorkflows: 'No saved workflows yet.',
    overviewNoRequests: 'No recorded requests yet.',
    overviewOpenWorkflow: 'Open workflow: {name}',
    overviewInspectRequest: 'Inspect request: {name}',
    overviewTokens: '{count} tokens',
    overviewLatency: '{count} ms',
    promptsTitle: 'Prompt Library',
    promptsSubtitle: 'Save, organize, and reuse complete Playground configurations.',
    promptsEmptyTitle: 'Build your prompt library',
    promptsEmptyDescription:
      'Save a reusable Playground configuration or create a prompt here.',
    createPrompt: 'Create prompt',
    openPlayground: 'Open Playground',
    browsePrompts: 'Browse prompts',
    promptBack: 'Back',
    promptSearchPlaceholder: 'Search prompts',
    promptClearFilters: 'Clear filters',
    promptsFilteredEmpty: 'No prompts match these filters.',
    promptMode: 'Mode',
    promptModel: 'Model',
    promptName: 'Name',
    promptDescription: 'Description',
    promptTags: 'Tags',
    promptPin: 'Pin prompt',
    promptUnpin: 'Unpin prompt',
    promptDuplicate: 'Duplicate prompt',
    promptDelete: 'Delete prompt',
    promptOpenInPlayground: 'Open in Playground',
    promptActions: 'Prompt actions',
    promptStatusDirty: 'Unsaved changes',
    promptStatusClean: 'No changes',
    promptStatusNew: 'New prompt',
    promptStatusSaved: 'Saved prompt',
    promptRequiresReattachment: 'File required',
    promptNameRequired: 'Enter a prompt name.',
    promptNameTooLong: 'Use 60 characters or fewer.',
    promptNameDuplicate: 'A saved prompt already uses this name.',
    promptDescriptionTooLong: 'Use 240 characters or fewer.',
    promptTooManyTags: 'Use no more than eight tags.',
    promptTagTooLong: 'Use 24 characters or fewer per tag.',
    promptUpdate: 'Update prompt',
    promptSaveAsNew: 'Save as new',
    promptSaveToLibrary: 'Save to Library',
    promptSaveDialogTitle: 'Save prompt to Library',
    promptSaveAsNewDialogTitle: 'Save prompt as new',
    promptPersistenceUnavailable: 'Prompt storage is unavailable.',
    promptHandoffNotFound: 'That saved prompt is no longer available.',
    promptLoaded: 'Loaded {name} as a working copy.',
    promptReattachFile: 'Reattach file',
    promptAudioReattachmentHelp: 'Select this file again before running the audio prompt.',
    promptListLabel: 'Saved prompts',
    promptSelectLabel: 'Edit prompt: {name}',
    promptEditorNewTitle: 'Create prompt',
    promptEditorSavedTitle: 'Edit prompt',
    promptStorageReadOnly:
      'Browser storage is unavailable. You can review or open this prompt, but changes cannot be saved.',
    promptConfiguration: 'Prompt configuration',
    promptSystemPrompt: 'System prompt',
    promptMessages: 'Messages',
    promptMessageRole: 'Message role',
    promptMessageContent: 'Message content',
    promptAddMessage: 'Add message',
    promptRemoveMessage: 'Remove message',
    promptVariables: 'Variables',
    promptAddVariable: 'Add variable',
    promptRemoveVariable: 'Remove variable',
    promptOutputFormat: 'Output format',
    promptFunctions: 'Function declarations',
    promptAddFunction: 'Add function',
    promptRemoveFunction: 'Remove function',
    promptMcpServers: 'MCP server declarations',
    promptAddMcpServer: 'Add MCP server',
    promptRemoveMcpServer: 'Remove MCP server',
    promptAttachmentPlaceholder: 'Reattach saved files before running this prompt.',
    promptAudioFilePlaceholder: 'Reattach {name} before running this audio prompt.',
    promptRoleSystem: 'System',
    promptRoleUser: 'User',
    promptRoleAssistant: 'Assistant',
    promptRoleDeveloper: 'Developer',
    promptUnsavedTitle: 'Discard unsaved changes?',
    promptUnsavedDescription: 'Continuing will discard the changes in this prompt editor.',
    promptDiscardChanges: 'Discard changes',
    promptDeleteTitle: 'Delete prompt?',
    promptDeleteDescription: 'Delete {name}? This action cannot be undone.',
    promptDeleteConfirm: 'Delete prompt',
    promptMalformedTitle: 'Some prompts could not be read',
    promptMalformedDescription:
      '{count} malformed prompt record(s) were preserved without changes.',
    promptStorageUnsupportedTitle: 'Prompt data is from a newer version',
    promptStorageUnsupportedDescription:
      'This browser data cannot be edited safely with the current Model Studio version.',
    promptStorageWriteFailedTitle: 'Prompt changes could not be saved',
    promptStorageWriteFailedDescription:
      'Your loaded prompts remain visible, but further mutations are disabled to protect local data.',
    promptModelMetadataNotice:
      'Model metadata is temporarily unavailable. The saved model remains selectable.',
    promptFilterModes: 'Filter by mode',
    promptFilterTags: 'Filter by tags',
    promptSortLabel: 'Sort prompts',
    promptPinnedOnly: 'Pinned only',
    promptSelected: 'Selected {name}.',
    promptMissing: 'This prompt is no longer available.',
    promptCreated: 'Created {name}.',
    promptUpdated: 'Updated {name}.',
    promptSavedAsNew: 'Saved {name} as a new prompt.',
    promptDuplicated: 'Duplicated {name}.',
    promptPinned: 'Prompt pinned.',
    promptUnpinned: 'Prompt unpinned.',
    promptDeleted: 'Deleted {name}.',
    workflowsTitle: 'Workflows',
    workflowsSubtitle: 'Reuse model configurations for repeatable development tasks.',
    newWorkflow: 'New workflow',
    workflowTemplates: 'Starter workflows',
    workflowSearchPlaceholder: 'Search workflows',
    workflowsPinnedOnly: 'Pinned only',
    workflowsEmpty: 'No workflows match this view.',
    workflowOpenInPlayground: 'Open',
    workflowPin: 'Pin',
    workflowUnpin: 'Unpin',
    workflowRename: 'Rename',
    workflowActions: 'Workflow actions',
    workflowDuplicate: 'Duplicate',
    workflowDelete: 'Delete',
    workflowDeleteConfirm: 'Delete this workflow?',
    workflowRenameTitle: 'Rename workflow',
    workflowSave: 'Save',
    workflowRenamed: 'Workflow renamed.',
    workflowDuplicated: 'Workflow duplicated.',
    workflowDeleted: 'Workflow deleted.',
    workflowSortLabel: 'Sort workflows',
    workflowSortUpdated: 'Recently updated',
    workflowSortName: 'Name',
    workflowSortMode: 'Mode',
    workflowTemplateStructuredTitle: 'Structured extraction',
    workflowTemplateStructuredDescription: 'Return validated JSON from documents or text.',
    workflowTemplateSupportTitle: 'Support assistant',
    workflowTemplateSupportDescription: 'Start a tool-ready support conversation.',
    workflowTemplateImageTitle: 'Image brief',
    workflowTemplateImageDescription: 'Reuse image settings and output dimensions.',
    compareTitle: 'Compare',
    compareSubtitle: 'Evaluate model responses side by side with one shared request.',
    compareConnect: 'Connect',
    runBoth: 'Run both',
    comparePromptPlaceholder: 'Enter one prompt for both models',
    compareModelA: 'Select model A',
    compareModelB: 'Select model B',
    compareResults: 'Comparison results',
    comparePromptRequired: 'Enter a prompt before comparing models.',
    compareConnectRequired: 'Connect an API key before running this comparison.',
    compareReady: 'Ready',
    compareComplete: 'Complete',
    comparePreferred: 'Preferred',
    compareMarkPreferred: 'Mark preferred',
    compareOutdated: 'Outdated',
    compareFaster: 'Faster',
    compareFewerTokens: 'Fewer tokens',
    compareLowerCost: 'Lower cost',
    comparePreferredTabLabel: '{model}, Preferred',
    compareFailed: 'Failed',
    compareResultEmpty: 'Run the comparison to see this response.',
    compareLatency: 'Latency',
    compareTokens: 'Tokens',
    compareCost: 'Estimated cost',
    compareRerun: 'Rerun',
    copyResponse: 'Copy',
    compareCopied: 'Response copied.',
    compareCopyFailed: 'Could not copy the response.',
    openInPlayground: 'Open in Playground',
    requestsTitle: 'Requests',
    requestsSubtitle: 'Inspect, replay, and troubleshoot locally recorded model calls.',
    requestsSearch: 'Search request or model',
    requestsAllModes: 'All modes',
    requestsAllStatuses: 'All statuses',
    requestsEmpty: 'No requests match this view.',
    requestsBack: 'Back',
    requestDetails: 'Request details',
    requestReplay: 'Replay',
    requestSuccess: 'Success',
    requestError: 'Error',
    requestsFilters: 'Filters',
    requestsAnyTime: 'Any time',
    requestsPastHour: 'Past hour',
    requestsPastDay: 'Past day',
    requestsPastWeek: 'Past week',
    requestsPastMonth: 'Past month',
    requestModeFilter: 'Filter by mode',
    requestStatusFilter: 'Filter by status',
    requestTimeFilter: 'Filter by time',
    requestMinimumTokens: 'Minimum tokens',
    requestMaximumCost: 'Maximum cost (USD)',
    requestModel: 'Model',
    requestMode: 'Mode',
    requestResponse: 'Response',
    requestPayload: 'Request payload',
    requestCode: 'Request code',
    requestCodeCopied: 'Request code copied.',
    requestCodeCopyFailed: 'Could not copy the request code.',
    requestDelete: 'Delete request',
    requestDeleted: 'Request deleted.',
    requestDeleteConfirm: 'Delete this request?',
    requestSelect: 'Select a request to inspect it.',
    historyCleared: 'Request history cleared.',
    storageUnavailableTitle: 'Local storage is unavailable',
    storageUnavailable:
      'Changes remain available in this session, but the browser could not save them locally. Existing stored data was not deleted.',
    handoffNotFound: 'That saved workflow or request is no longer available.',
    workflowTemplateStructuredPrompt: 'Extract the key facts and return valid JSON.',
    workflowTemplateSupportPrompt: 'Help the customer resolve this support request.',
    workflowTemplateImagePrompt: 'Create a clean product concept on a neutral background.',
    setup: 'Setup',
    controls: 'Controls',
    configure: 'Configure',
    studioSetup: 'Studio setup',
    studioControls: 'Studio controls',
    setupRail: 'Setup rail',
    controlsRail: 'Controls rail',
    railOpen: 'Open',
    railClosed: 'Closed',
    openStudioSetup: 'Open studio setup panel',
    openStudioControls: 'Open studio controls panel',
    closeStudioSetup: 'Close studio setup panel',
    closeStudioControls: 'Close studio controls panel',
    openAttachments: 'Open chat attachments',
    focusWorkspace: 'Focus',
    focusWorkspaceAction: 'Focus workspace',
    focusComposerAction: 'Focus chat composer',
    restoreWorkspace: 'Restore',
    restoreWorkspaceAction: 'Restore side rails',
    expandRail: 'Expand rail',
    collapseRail: 'Collapse rail',
    connection: 'Connection',
    connectionDetails: 'Connection details',
    manageConnection: 'Manage connection',
    hideConnectionDetails: 'Hide connection details',
    avalai: 'AvalAI',
    custom: 'Custom',
    dashboardApiKey: 'Dashboard API key',
    dashboardApiKeySelect: 'Select existing API key',
    keySetupPaths: 'API key setup paths',
    recommended: 'Recommended',
    browserKeyPath: 'Generate browser key',
    browserKeyPathDescription: 'Create a dashboard-scoped key for this Studio session.',
    existingKeyPath: 'Use existing key',
    existingKeyPathDescription: 'Load your dashboard API keys, then choose one for browser SDK calls.',
    dashboardApiKeySelectPlaceholder: 'Choose a dashboard API key',
    loadApiKeys: 'Load API keys',
    loadApiKeysAction: 'Load existing dashboard API keys',
    refreshApiKeys: 'Refresh API keys',
    refreshApiKeysAction: 'Refresh existing dashboard API keys',
    noApiKeysFound: 'No API keys found.',
    apiKeysFetchError: 'Could not load your API keys.',
    selectedApiKeyFetchError: 'Could not retrieve the selected API key.',
    selectedApiKeySecretUnavailable:
      'The selected key secret is not available. Generate a dashboard key for browser calls.',
    selectedApiKeyReady: 'Selected API key is ready for browser SDK calls.',
    dashboardKeyReady: 'Ready for browser SDK calls.',
    dashboardKeyMissing: 'No dashboard key loaded.',
    ready: 'Ready',
    needed: 'Needed',
    keyReady: 'Key ready',
    keyNeeded: 'Key needed',
    connectionInvalid: 'Connection invalid',
    freshKeyNotice: 'A fresh dashboard key was generated. It may take a short moment to propagate.',
    signInForDashboardKey: 'Please sign in to retrieve your dashboard API key.',
    dashboardKeyFetchError: 'Could not retrieve a dashboard API key.',
    selectOrGenerateKeyError: 'Select or generate an API key before running a request.',
    runUnavailable: 'Select an API key and complete the required input before running.',
    requestInProgress: 'A request is running. Stop it before changing settings.',
    dashboardKeyRequestInProgress:
      'A dashboard API key request is running. Wait for it to finish before changing key settings.',
    chatMessageRequired: 'Enter or add a chat message before running.',
    chatNothingToClear: 'The chat is already empty.',
    imagePromptRequired: 'Enter an image prompt before generating.',
    speechInputRequired: 'Enter text to synthesize before running speech.',
    embeddingInputRequired: 'Enter text before creating an embedding.',
    requestJsonRequired: 'Enter request JSON before running.',
    resetParameters: 'Reset parameters',
    resetSettings: 'Reset settings',
    selectAudioFileError: 'Select an audio file before running transcription or translation.',
    requestCancelled: 'Request cancelled.',
    requestFailed: 'The request failed before a response was returned.',
    providerAuthenticationFailed:
      'The API key was rejected or is not authorized for this request. Open Studio setup, refresh or replace the key, then retry.',
    providerRateLimited: 'The provider is rate-limiting requests. Wait a moment, then retry.',
    providerNetworkError: 'Could not connect to the provider. Check your network connection, then retry.',
    providerRequestRejected:
      'The provider rejected this request. Review the selected model and parameters, then retry.',
    providerUnavailable: 'The provider is temporarily unavailable. Wait a moment, then retry.',
    modelMetadataError: 'Could not load model metadata.',
    generateApiKey: 'Generate API key',
    generateDashboardKeyAction: 'Generate a dashboard API key for Model Studio browser calls',
    refreshDashboardKey: 'Refresh dashboard key',
    refreshDashboardKeyAction: 'Refresh the generated dashboard API key for Model Studio browser calls',
    customProvider: 'Custom provider',
    providerLabel: 'Provider label',
    customBaseUrl: 'API base URL',
    customBaseUrlPlaceholder: 'https://api.example.com/v1',
    customBaseUrlInvalid: 'Enter a valid HTTP(S) API base URL before running requests.',
    customBaseUrlHttpsRequired:
      'Use an HTTPS API base URL. In development, HTTP is allowed only for localhost loopback endpoints.',
    customApiKey: 'API key',
    customKeyPlaceholder: 'Paste API key for this session',
    customKeyNotice: 'Custom keys stay in memory for this session and are never stored.',
    clearCustomKey: 'Clear key',
    clearCustomKeyAction: 'Clear the custom API key from this session',
    roleUser: 'User',
    roleAssistant: 'Assistant',
    viewRawResponse: 'View raw response',
    viewFormattedResponse: 'View formatted response',
    rawResponseSource: 'Raw response source',
    roleSystem: 'System',
    roleDeveloper: 'Developer',
    prompt: 'Prompt',
    savePreset: 'Save preset',
    applyPreset: 'Apply',
    applyPresetWithName: 'Apply preset {name}',
    removePresetWithName: 'Remove preset {name}',
    history: 'Recent runs',
    noLocalHistory: 'No recent runs yet.',
    applyHistory: 'Restore',
    applyHistoryWithName: 'Restore recent run {name}',
    removeHistoryWithName: 'Remove recent run {name}',
    clearHistory: 'Clear',
    clearHistoryConfirm: 'Clear all recent runs?',
    clearHistoryConfirmPositive: 'Clear',
    clearHistoryConfirmNegative: 'Cancel',
    clearHistoryAction: 'Clear all recent Model Studio runs',
    removePresetConfirm: 'Remove this saved preset?',
    removePresetConfirmPositive: 'Remove',
    removePresetConfirmNegative: 'Cancel',
    presetNamePlaceholder: 'Name this preset',
    presetName: 'Studio preset',
    workflows: 'Workflows',
    openWorkflows: 'Open saved and recent workflows',
    closeWorkflows: 'Close workflows',
    saveCurrentWorkflow: 'Save current',
    recentWorkflows: 'Recent',
    savedWorkflows: 'Saved',
    manageWorkflowsInSetup: 'Manage all in Setup',
    loadWorkflowWithName: 'Load workflow {name}',
    workflowLoaded: 'Loaded {name}. Press Run when you are ready.',
    workflowLoadFailed: 'Could not load {name}. Your current setup was not run.',
    workflowSaved: 'Saved {name} in this browser.',
    workflowSavedForSession: '{name} is available for this session but may not survive a refresh.',
    workflowName: 'Workflow name',
    workflowNamePlaceholder: 'Name this workflow',
    workflowNameRequired: 'Enter a workflow name.',
    workflowNameTooLong: 'Use 60 characters or fewer.',
    workflowNameDuplicate: 'A saved workflow already uses this name.',
    workflowMutationLocked: 'Wait for the active request to finish or stop it before changing workflows.',
    recentWorkflowsEmpty: 'Completed runs will appear here for quick reuse.',
    savedWorkflowsEmpty: 'Save the current setup to reuse it later.',
    workflowPersistenceUnavailable: 'Browser storage is unavailable. Changes may not survive a refresh.',
    modePromptInCanvas: "Edit this mode's prompt or input in the center canvas.",
    variables: 'Variables',
    addVariable: 'Add variable',
    variableName: 'Variable name',
    variableValue: 'Variable value',
    variableNamePlaceholder: 'customer_name',
    variableValuePlaceholder: 'Value used for this variable',
    removeVariable: 'Remove variable {name}',
    noPromptVariables: 'No prompt variables yet.',
    systemInstructions: 'System instructions',
    attachments: 'Attachments',
    attachFiles: 'Attach files, images, or audio for supported models.',
    attachmentTypeFile: 'File',
    attachmentTypeImage: 'Image',
    attachmentTypeAudio: 'Audio',
    attachmentIgnored: 'Ignored by this model',
    unsupportedAttachmentsIgnored:
      '{count} attachment(s) will be ignored because the selected model does not support that input type.',
    removeAttachment: 'Remove {name}',
    remove: 'Remove',
    presets: 'Presets',
    noLocalPresets: 'No local presets yet.',
    compare: 'Compare',
    exitCompare: 'Exit compare',
    compareUnavailable:
      'Compare is available for chat and image modes when the selected model supports the active capability.',
    stop: 'Stop',
    run: 'Run',
    runProfile: 'Run profile',
    rerun: 'Rerun',
    chat: 'Chat',
    images: 'Images',
    imageGeneration: 'Image generation',
    imageGenerationUnavailableReason: 'The selected model metadata does not advertise image generation.',
    audio: 'Audio',
    embeddings: 'Embeddings',
    rawApi: 'Raw API',
    compactModeChat: 'Chat',
    compactModeImages: 'Images',
    compactModeAudio: 'Audio',
    compactModeEmbeddings: 'Embed',
    compactModeRawApi: 'API',
    compactConfigure: 'Config',
    compactCode: 'Code',
    compactInspector: 'Inspect',
    askAnything: 'Ask anything. Use attachments and settings from the rails.',
    streamEvents: '{count} stream events',
    conversationEmpty: 'Your conversation will appear here.',
    chatDraftReady: 'Draft ready in the composer.',
    chatDraftReadyHint: 'Edit it below, add it to context, or run it when a key is ready.',
    firstRunTitle: 'Make your first request',
    firstRunDescription: 'Connect securely, choose a starter, then review your prompt before running.',
    firstRunProgressLabel: 'First request setup',
    firstRunProgressValue: '{current} of {total}',
    firstRunCompleted: 'Completed',
    firstRunCurrent: 'Current step',
    firstRunReopenStep: 'Review completed step: {step}',
    firstRunFocusComposer: 'Focus composer',
    returningChatTitle: 'Start a new request',
    returningChatDescription: 'Write your request in the composer below when you are ready.',
    firstRunConnectTitle: 'Connect to run your first request',
    firstRunConnectDescription:
      'Generate a temporary dashboard key, or configure another connection in Setup.',
    firstRunPromptTitle: 'What do you want to test?',
    firstRunPromptDescription: 'Write a prompt below or start with an example.',
    firstRunExamplesLabel: 'Start with an example',
    firstRunChooseTitle: 'Choose a starting point',
    firstRunChooseDescription: 'Your selected starter stays ready while the connection is prepared.',
    firstRunReviewTitle: 'Review and run',
    firstRunReviewDescription: 'Edit the prompt in the composer and run it only when you are ready.',
    firstRunGenerateDashboardKey: 'Generate dashboard key',
    firstRunGeneratingDashboardKey: 'Generating dashboard key',
    firstRunConnectionReady: 'Connection ready',
    firstRunConnectionNeeded: 'Connection needed',
    firstRunWaiting: 'Waiting',
    firstRunSelected: 'Selected',
    firstRunRetry: 'Retry key generation',
    firstRunShortcut: 'Review your prompt, then press Ctrl or Command + Enter.',
    starterPrompts: 'Starter prompts',
    starterSummarize: 'Summarize this release note for a technical support team.',
    starterStructuredOutput: 'Return a JSON object with title, summary, risks, and next_steps.',
    starterToolPlanning: 'Plan the tools and parameters needed to answer a customer billing question.',
    imageStarterProduct: 'A clean product photo of a glass API token vault on a white desk.',
    imageStarterDiagram: 'A crisp isometric diagram showing user prompt, API gateway, model, and response.',
    imageStarterScene: 'A cinematic workspace where developers compare two AI model outputs on large screens.',
    audioStarterSupport: 'Hi, thanks for contacting AvalAI support. I can help you rotate your API key.',
    audioStarterProductUpdate: 'Model Studio now helps you test prompts, compare models, and export code.',
    audioStarterNarration: 'In this walkthrough, we will connect an API key, choose a model, and run the request.',
    embeddingStarterSearch: 'Search query: best practices for rotating production API keys',
    embeddingStarterClassification: 'Classify this support ticket: customer cannot find their generated API key.',
    embeddingStarterSimilarity:
      'Compare semantic similarity between invoice dispute, billing question, and refund request.',
    streamingResponse: 'Streaming response...',
    imagePrompt: 'Image prompt',
    imagePromptPlaceholder: 'Describe the image you want to generate or edit.',
    generatedImageAlt: 'Generated image',
    generatedImageAltWithIndex: 'Generated image {index}',
    generatedCompareImageAlt: '{label} generated image {index}',
    downloadImage: 'Download image',
    downloadImageWithIndex: 'Download image {index}',
    downloadCompareLaneImage: 'Download {label} image {index}',
    downloadAudioOutput: 'Download generated audio: {fileName}',
    base64ImageGenerated: 'Base64 image generated',
    imageOutput: 'Image output',
    generatedImagesEmpty: 'Generated images will appear here.',
    generateImage: 'Generate image',
    audioTask: 'Audio task',
    speech: 'Speech',
    transcription: 'Transcription',
    translation: 'Translation',
    speechInputPlaceholder: 'Enter text to synthesize.',
    audioContextPlaceholder: 'Optional prompt or context for this audio.',
    selectAudioFile: 'Select audio file',
    removeAudioFile: 'Remove {name}',
    selectedAudioFileHelp: 'This file will be sent directly through the OpenAI browser SDK.',
    audioFileRequiredHelp: 'Required for transcription and translation requests.',
    output: 'Output',
    audioOutputEmpty: 'Transcripts or speech responses will appear here.',
    audioResponseReturned: 'Audio response returned. Inspect the raw response in the controls rail.',
    runAudio: 'Run audio',
    embeddingInput: 'Embedding input',
    embeddingInputPlaceholder: 'Enter text to embed.',
    vectorPreview: 'Vector preview',
    vectorPreviewEmpty: 'The first vector values will appear here.',
    createEmbedding: 'Create embedding',
    rawEndpoint: 'Endpoint',
    rawEndpointPlaceholder: '/responses',
    rawEndpointInvalid: 'Enter a relative API endpoint path such as /responses or /chat/completions.',
    rawRequestSummary: 'Request endpoint drives generated code',
    rawControlsNote:
      'Raw API endpoint and request JSON are edited in the center canvas. The snippets below follow that request.',
    formatJson: 'Format JSON',
    formatJsonRequiresJson: 'Enter request JSON before formatting.',
    formatJsonSchemaRequiresJson: 'Enter a JSON schema before formatting.',
    formatFunctionParametersRequiresJson: 'Enter function parameters JSON before formatting.',
    rawRequestTemplates: 'Request templates',
    rawStarterResponses: 'Responses',
    rawStarterChat: 'Chat completions',
    rawStarterEmbeddings: 'Embeddings',
    useStarterPrompt: 'Use starter prompt: {prompt}',
    useRequestTemplate: 'Use request template: {template}',
    requestJson: 'Request JSON',
    rawJsonPlaceholder: '{\'{"model":"gpt-4o-mini","input":"Hello"}\'}',
    rawJsonInvalid: 'Enter a valid JSON object before running this raw request.',
    jsonSchemaInvalid: 'Enter a valid JSON object for the structured output schema.',
    functionParametersInvalid: 'Enter a valid JSON object for the function parameters.',
    response: 'Response',
    rawResponseEmpty: 'Raw response output will appear here.',
    runRawRequest: 'Run raw request',
    model: 'Model',
    selectModel: 'Select model',
    modelCapabilities: 'Model capabilities',
    capabilitiesAvailable: '{count} available',
    vision: 'Vision',
    tools: 'Tools',
    capabilityAvailable: '{label} is available',
    capabilityUnavailable: '{label} is unavailable',
    unsupportedBySelectedModel: 'Unsupported by selected model',
    capabilityUnavailableReason: 'The selected model metadata does not advertise this capability.',
    visionUnavailableReason: 'Vision or image endpoints are not advertised.',
    parameters: 'Parameters',
    temperature: 'Temperature',
    temp: 'Temp',
    topP: 'Top P',
    max: 'Max',
    maxOutput: 'Max output',
    reasoningEffort: 'Reasoning effort',
    reasoningUnavailableReason: 'The selected model metadata does not advertise reasoning controls.',
    verbosity: 'Verbosity',
    serviceTier: 'Service tier',
    none: 'None',
    minimal: 'Minimal',
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    xhigh: 'XHigh',
    auto: 'Auto',
    default: 'Default',
    flex: 'Flex',
    priority: 'Priority',
    text: 'Text',
    jsonMode: 'JSON mode',
    jsonSchema: 'JSON schema',
    structuredOutput: 'Structured output',
    structuredOutputUnavailableReason: 'The selected model metadata does not advertise structured output.',
    systemMessages: 'System messages',
    systemMessagesUnavailableReason: 'The selected model metadata does not advertise system messages.',
    webSearch: 'Web search',
    webSearchUnavailableReason: 'The selected model metadata does not advertise web search.',
    vectorStoreIds: 'Vector store ids',
    fileSearchUnavailableReason: 'The selected model metadata does not advertise file search.',
    functionName: 'Function name',
    functionDescription: 'Function description',
    functionCallingUnavailableReason: 'The selected model metadata does not advertise function calling.',
    mcpServerLabel: 'MCP server label',
    mcpServerUrl: 'MCP server URL',
    mcpApproval: 'MCP approval',
    mcpApprovalAlways: 'Always require approval',
    mcpApprovalNever: 'Do not require approval',
    mcpToolsUnavailableReason: 'The selected model metadata does not advertise tool support for MCP servers.',
    mcpServerInvalid: 'Enter an MCP server label and a valid HTTP(S) URL.',
    modeSettings: 'Mode settings',
    modeNavigation: 'Model Studio modes',
    mode: 'Mode',
    imageSize: 'Image size',
    quality: 'Quality',
    background: 'Background',
    transparent: 'Transparent',
    opaque: 'Opaque',
    voice: 'Voice',
    format: 'Format',
    dimensions: 'Dimensions',
    code: 'Code',
    codeLanguageNavigation: 'Generated code languages',
    codeContextMode: 'Generated code follows the current {mode} settings.',
    codeContextCompare: 'Generated code follows the active compare lane: {lane}.',
    codeCapabilityWarning:
      'The selected model metadata does not advertise {mode} support. Change the model or mode before using this code.',
    codeSampleInputNotice: 'These snippets include sample input until you enter input in the canvas.',
    codeStatusModelMismatch: 'Model mismatch',
    codeStatusSampleInput: 'Sample input',
    copy: 'Copy',
    copySnippet: 'Copy {language} snippet',
    copyMessage: 'Copy message',
    copyMessageWithContext: 'Copy {role} message: {preview}',
    copied: 'Copied',
    copyMessageFailed: 'Could not copy message. It is selected so you can copy it manually.',
    removeMessage: 'Remove message',
    removeMessageWithContext: 'Remove {role} message: {preview}',
    copyFailed: 'Could not copy snippet. It is selected so you can copy it manually.',
    download: 'Download',
    downloadSnippet: 'Download {language} snippet',
    downloaded: 'Snippet download started',
    downloadFailed: 'Could not download snippet',
    lines: '{count} lines',
    inspector: 'Inspector',
    inspectorEmpty: 'Run a request to inspect the raw response.',
    latency: 'Latency: {value} ms',
    usage: 'Usage: {value}',
    inspectorUsageTotal: 'Total tokens: {value}',
    inspectorUsageInput: 'Input tokens: {value}',
    inspectorUsageOutput: 'Output tokens: {value}',
    notRun: 'Not run',
    compareChatResponses: 'Compare chat responses',
    compareImageGenerations: 'Compare image generations',
    compareContextHelp:
      'Primary and variant lanes share the prompt context. Select a lane to drive the generated code in the controls rail.',
    compareLaneCapabilityUnavailable: '{label} lane uses {model}, which does not support this mode.',
    sharedChatPlaceholder: 'Add a shared chat message for both lanes.',
    messagesInContext: '{count} message in shared context | {count} messages in shared context',
    addMessage: 'Add message',
    clearChat: 'Clear chat',
    sharedImagePromptPlaceholder: 'Describe the image prompt shared by both lanes.',
    primary: 'Primary',
    variant: 'Variant',
    useForCode: 'Use for code',
    usingForCode: 'Using for code',
    useLaneForCode: 'Use {label} for code',
    usingLaneForCode: '{label} is used for code',
    responseWillAppear: 'Response will appear here.',
    imageDataWillAppear: 'Generated image data will appear here.',
    runLane: 'Run {label}',
    runPrimary: 'Run Primary',
    runVariant: 'Run Variant'
  },

  route: {
    sponsorship: 'Startups',
    sponsorship_home: 'Overview',
    sponsorship_apply: 'Apply for Startup Sponsorship',
    sponsorship_status: 'Sponsorship Status',
    sponsorship_levels: 'Sponsorship Levels',
    'support_knowledge-base': 'Knowledge Base',
    support: 'support',
    support_dashboard: 'Dashboard',
    'support_create-ticket': 'Create Ticket',
    'support_my-tickets': 'My Tickets',
    'support_all-tickets': 'All Tickets',
    'support_ai-operations': 'AI Operations',
    agentOnlyBadge: 'Agent',
    agentOnlyBadgeTooltip: 'Visible to support agents and admins',
    // "support_ticket-details": "Ticket Details",
    models: 'models',
    'model-studio': 'Model Studio',
    'model-studio_overview': 'Overview',
    'model-studio_playground': 'Playground',
    'model-studio_prompts': 'Prompts',
    'model-studio_workflows': 'Workflows',
    'model-studio_compare': 'Compare',
    'model-studio_requests': 'Requests',
    calculator: 'Cost Calculator',
    tokenizer: 'Tokenizer',
    // assistants: "Assistants",
    // storage: "Storage",
    billing_addresses: 'Addresses',
    billing_history: 'history',
    billing_invoices: 'Invoices',
    usage_reports: 'reports',
    usage_overview: 'overview',
    billing_credit: 'credit',
    billing_packages: 'packages',
    affiliate: 'Affiliate',
    usage: 'Usages',
    limits: 'limits',
    billing: 'billing',
    'api-keys': 'API',
    login: 'Login',
    403: 'No Permission',
    404: 'Page Not Found',
    500: 'Server Error',
    home: 'Home',
    exception: 'Exception',
    exception_403: '403',
    exception_404: '404',
    exception_500: '500'
    // docs: 'Documents',
    // "docs_whats-new": "What's New",
    // docs_vision: "Computer Vision",
    // "docs_text-to-speech": "Text to Speech",
    // "docs_text-generation": "Text Generation",
    // "docs_structured-outputs": "Structured Outputs",
    // "docs_speech-to-text": "Speech to Text",
    // "docs_safety-best-practices": "Safety Best Practices",
    // docs_reasoning: "Reasoning & Logic",
    // "docs_release-notes": "Release Notes",
    // "docs_realtime-websocket": "WebSocket Integration",
    // "docs_realtime-webrtc": "WebRTC Integration",
    // "docs_realtime-model-capabilities": "Realtime Model Capabilities",
    // docs_realtime: "Realtime Features",
    // "docs_rate-limits": "Rate Limits",
    // docs_quickstart: "Quick Start Guide",
    // "docs_prompt-generation": "Prompt Generation",
    // "docs_prompt-examples": "Prompt Examples",
    // "docs_prompt-engineering": "Prompt Engineering",
    // "docs_prompt-caching": "Prompt Caching",
    // "docs_production-best-practices": "Production Best Practices",
    // "docs_predicted-outputs": "Predicted Outputs",
    // docs_overview: "Overview",
    // "docs_optimizing-llm-accuracy": "Optimizing LLM Accuracy",
    // docs_moderation: "Content Moderation",
    // docs_models: "Models",
    // "docs_model-selection": "Model Selection Guide",
    // docs_libraries: "Libraries & SDKs",
    // "docs_latency-optimization": "Latency Optimization",
    // "docs_image-generation": "Image Generation",
    // "docs_function-calling": "Function Calling",
    // "docs_fine-tuning": "Fine-tuning Models",
    // docs_evals: "Model Evaluations",
    // "docs_error-codes": "Error Codes",
    // docs_distillation: "Model Distillation",
    // docs_embeddings: "Embeddings",
    // docs_deprecations: "Deprecation Notices",
    // "docs_deep-dive": "Technical Deep Dive",
    // docs_changelog: "Changelog",
    // docs_batch: "Batch Processing",
    // docs_assistant_usage: "Assistant Usage Guide",
    // docs_assistant_tools: "Assistant Tools",
    // docs_assistant_quickstart: "Assistant Quick Start",
    // "docs_audio-generation": "Audio Generation",
    // "docs_assistant_whats-new": "Assistant Updates",
    // docs_assistant_overview: "Assistant Overview",
    // docs_assistant_tools_overview: "Tools Overview",
    // "docs_assistant_tools_function-calling": "Function Calling Tools",
    // "docs_assistant_tools_file-search": "File Search Tools",
    // "docs_assistant_tools_code-interpreter": "Code Interpreter",
    // docs_assistant_migration: "Assistant Migration Guide",
    // docs_assistant: "AI Assistant",
    // "docs_assistant_deep-dive": "Assistant Technical Details",
    // "docs_advanced-usage": "Advanced Usage",
    // "docs_actions_sending-files": "Sending Files with Actions",
    // docs_actions_production: "Actions in Production",
    // docs_actions_introduction: "Introduction to Actions",
    // docs: "Documentation",
    // "docs_accuracy-optimization": "Accuracy Optimization",
    // docs_actions: "Actions",
    // "docs_actions_actions-library": "Actions Library",
    // "docs_actions_data-retrieval": "Data Retrieval Actions",
    // docs_actions_authentication: "Actions Authentication",
    // "docs_actions_getting-started": "Getting Started with Actions",
  },
  page: {
    login: {
      common: {
        // visitAsGuest: 'Visit as guest',
        login: 'Login',
        needLogin: 'You need to login first',
        continueAsGuest: 'Continue as Guest',
        loginBenefits: 'Login to unlock full access to your dashboard',
        unlockFeatures: 'Login to unlock:',
        grantHeroTitle: 'Get {amount} Tomans free credit',
        grantHeroSubtitle: 'Create your account and start using the API right away — the credit lands in your balance automatically.',
        grantCtaPrimary: 'Sign up & claim your credit',
        grantEmailTopupNote: 'Already registered with email? Verify your phone to receive {amount} Tomans more and reach {total} Tomans total.',
        loginRequired: 'Login required for this action',
        loginOrRegister: 'Login / Register',
        userNamePlaceholder: 'Please enter user name',
        phonePlaceholder: 'Please enter phone number',
        codePlaceholder: 'Please enter verification code',
        passwordPlaceholder: 'Please enter password',
        confirmPasswordPlaceholder: 'Please enter password again',
        codeLogin: 'Verification code login',
        confirm: 'Confirm',
        back: 'Back',
        validateSuccess: 'Verification passed',
        loginSuccess: 'Login successfully',
        welcomeBack: 'Welcome back, {userName} !',
        benefits: {
          'api-keys': {
            a: 'Create and manage API keys',
            b: 'Monitor API usage and costs',
            c: 'Configure rate limits and permissions'
          },
          billing: {
            a: 'View detailed billing history',
            b: 'Add credits to your account',
            c: 'Download invoices and receipts'
          },
          packages: {
            a: 'View and manage your credit packages',
            b: 'Purchase new credit packages',
            c: 'Monitor your credit packages'
          },
          home: {
            a: 'Access personalized dashboard',
            b: 'View real-time usage data',
            c: 'Customize settings and preferences'
          },
          models: {
            a: 'Access all available models',
            b: 'View detailed model information',
            c: 'Compare model capabilities'
          },
          usage: {
            a: 'Detailed usage analytics',
            b: 'Export usage reports',
            c: 'Track spending over time'
          },
          affiliate: {
            a: 'Earn commissions from referrals',
            b: 'Track invited users and earnings',
            c: 'Withdraw earned commissions'
          },
          support: {
            a: 'Create and track your support tickets',
            b: 'Reply to agents and follow conversations',
            c: 'Get personalized help with your account'
          }
        }
      },
      pwdLogin: {
        title: 'Password Login',
        rememberMe: 'Remember me',
        forgetPassword: 'Forget password?',
        register: 'Register',
        otherAccountLogin: 'Other Account Login',
        otherLoginMode: 'Other Login Mode',
        superAdmin: 'Super Admin',
        admin: 'Admin',
        user: 'User'
      },
      codeLogin: {
        title: 'Verification Code Login',
        getCode: 'Get verification code',
        sendFailed: 'Verification code failed, Please try again',
        reGetCode: 'Reacquire after {time}s',
        sendCodeSuccess: 'Verification code sent successfully',
        sendCodeSuccessViaFallback: 'Verification code sent via {provider}',
        imageCodePlaceholder: 'Please enter image verification code',
        codeNotValid: 'Code not valid or expired',
        phoneAlreadyAssociated: 'This phone number is already connected to another account.',
        phoneAlreadyAssociatedHelp:
          'If you own this phone number, first delete the account currently linked to it from the account deletion page to release the number, then try again.',
        deleteLinkedAccount: 'Open account deletion page',
        fallbackProvider: {
          bale: 'Bale Messenger'
        },
        fallbackProviderLink: {
          bale: 'https://web.bale.ai/'
        },
        openFallbackProvider: 'Open {provider}',
        fallbackOtpTitle: 'Alternative Verification Method',
        fallbackOtpWhyTitle: 'Why am I seeing this?',
        fallbackOtpWhyDescription:
          'We tried to send you a verification code via SMS, but our SMS service is temporarily unavailable. To ensure you can still access your account securely, we have sent your verification code through an alternative channel.',
        fallbackOtpSmsNotResponding:
          'The SMS provider is not responding at the moment. Your code has been safely sent via {provider} instead.',
        fallbackOtpStep1: 'We attempted to send an SMS but the service was unavailable',
        fallbackOtpStep2: 'Your verification code has been securely sent to {provider}',
        fallbackOtpStep3: 'Enter the code you received to complete verification',
        fallbackOtpAlternativeTitle: 'Prefer to receive SMS?',
        fallbackOtpAlternativeDescription:
          'If you prefer to receive the verification code via SMS instead, you can wait a few minutes and try again. Our system always attempts SMS delivery first before using alternative methods.',
        fallbackOtpRetryLater: 'Please wait a few minutes and try again. The SMS service may become available shortly.',
        fallbackOtpInfoButton: 'Why this method?'
      },
      register: {
        title: 'Register',
        agreement: 'I have read and agree to',
        protocol: '《User Agreement》',
        policy: '《Privacy Policy》'
      },
      resetPwd: {
        title: 'Reset Password'
      },
      bindWeChat: {
        title: 'Bind WeChat'
      },
      guestMode: {
        message: "You're browsing as a guest. Login for full access to all features.",
        timeRemaining: 'Guest session expires in {time}',
        upgradePrompt: 'Enjoying the platform? Create an account to save your progress.'
      },
      benefits: {
        createApiKeys: 'Create and manage API keys',
        manageKeys: 'Full key management capabilities',
        viewUsage: 'Detailed usage analytics',
        viewBilling: 'Access billing history',
        addCredits: 'Add credits and manage payments',
        downloadInvoices: 'Download invoices and receipts',
        personalizedDashboard: 'Personalized dashboard experience',
        realTimeData: 'Real-time data and notifications',
        customSettings: 'Custom settings and preferences'
      }
    },
    about: {
      title: 'About',
      introduction: `Soybean Admin is an elegant and powerful admin template, based on the latest front-end technology stack, including Vue3, Vite5, TypeScript, Pinia and UnoCSS. It has built-in rich theme configuration and components, strict code specifications, and an automated file routing system. In addition, it also uses the online mock data solution based on ApiFox. Soybean Admin provides you with a one-stop admin solution, no additional configuration, and out of the box. It is also a best practice for learning cutting-edge technologies quickly.`,
      projectInfo: {
        title: 'Project Info',
        version: 'Version',
        latestBuildTime: 'Latest Build Time',
        githubLink: 'Github Link',
        previewLink: 'Preview Link'
      },
      prdDep: 'Production Dependency',
      devDep: 'Development Dependency'
    },
    home: {
      offer1: '350 million Tomans',
      offer2: '550 million Tomans',
      offer3: '1 billion Tomans',
      offer1Benefit: '50 million Tomans',
      offer2Benefit: '100 million Tomans',
      offer3Benefit: '200 million Tomans',
      specialOffer: 'Special Offer: Free credit up to 200 million Tomans!',
      inChargeMoreGetMore: 'Top up your account and receive free credit. The more you top up, the more credit you get!',
      offerExpiresIn: 'Offer is valid until November 21. Credit expires in 60 days.',
      shortDesc1: 'Providing leading Artificial Intelligence services',
      // desc1Title: 'Easy Access',
      desc1:
        'AvalAI is your premier gateway to the most advanced artificial intelligence models available today. By registering a single developer account with us, you unlock access to a universe of opportunities. Our platform seamlessly integrates top AI services, including OpenAI, Anthropic, Meta, Mistral AI, Cohere, Google (Gemini) and Deepseek, with more providers on the horizon. All this is available at the official provider rates, with no additional costs.',
      desc2:
        'Experience hassle-free access with AvalAI. Our platform is designed to eliminate common barriers such as geographical restrictions, allowing you to focus solely on innovation. We offer secure transactions without hidden fees, immediate activation of user accounts, and an impressive 99.9% uptime of our infrastructure.',
      desc3:
        'At AvalAI, we are committed to providing a smooth and efficient experience for developers, researchers, and businesses alike. Leverage the power of leading AI technologies to propel your projects and ideas to new heights. Join us at AvalAI and start transforming the future today.',
      greeting: 'Welcome',
      weatherDesc: 'Today is cloudy to clear, 20℃ - 25℃!',
      projectCount: 'Project Count',
      todo: 'Todo',
      message: 'Message',
      downloadCount: 'Download Count',
      registerCount: 'Register Count',
      schedule: 'Work and rest Schedule',
      study: 'Study',
      work: 'Work',
      rest: 'Rest',
      entertainment: 'Entertainment',
      visitCount: 'Visit Count',
      turnover: 'Turnover',
      dealCount: 'Deal Count',
      projectNews: {
        title: 'Project News',
        moreNews: 'More News',
        desc1: '',
        desc2: '',
        desc3: '',
        desc4: '',
        desc5: ''
      },
      creativity: 'Creativity'
    },
    function: {
      tab: {
        tabOperate: {
          title: 'Tab Operation',
          addTab: 'Add Tab',
          addTabDesc: 'To about page',
          closeTab: 'Close Tab',
          closeCurrentTab: 'Close Current Tab',
          closeAboutTab: 'Close "About" Tab',
          addMultiTab: 'Add Multi Tab',
          addMultiTabDesc1: 'To MultiTab page',
          addMultiTabDesc2: 'To MultiTab page(with query params)'
        },
        tabTitle: {
          title: 'Tab Title',
          changeTitle: 'Change Title',
          change: 'Change',
          resetTitle: 'Reset Title',
          reset: 'Reset'
        }
      },
      multiTab: {
        routeParam: 'Route Param',
        backTab: 'Back function_tab'
      },
      toggleAuth: {
        toggleAccount: 'Toggle Account',
        authHook: 'Auth Hook Function `hasAuth`',
        superAdminVisible: 'Super Admin Visible',
        adminVisible: 'Admin Visible',
        adminOrUserVisible: 'Admin and User Visible'
      }
    },
    manage: {
      common: {
        status: {
          enable: 'Enable',
          disable: 'Disable'
        }
      },
      role: {
        title: 'Role List',
        roleName: 'Role Name',
        roleCode: 'Role Code',
        roleStatus: 'Role Status',
        roleDesc: 'Role Description',
        menuAuth: 'Menu Auth',
        buttonAuth: 'Button Auth',
        form: {
          roleName: 'Please enter role name',
          roleCode: 'Please enter role code',
          roleStatus: 'Please select role status',
          roleDesc: 'Please enter role description'
        },
        addRole: 'Add Role',
        editRole: 'Edit Role'
      },
      user: {
        title: 'User List',
        userName: 'User Name',
        userGender: 'Gender',
        nickName: 'Nick Name',
        userPhone: 'Phone Number',
        userEmail: 'Email',
        userStatus: 'User Status',
        userRole: 'User Role',
        form: {
          userName: 'Please enter user name',
          userGender: 'Please select gender',
          nickName: 'Please enter nick name',
          userPhone: 'Please enter phone number',
          userEmail: 'Please enter email',
          userStatus: 'Please select user status',
          userRole: 'Please select user role'
        },
        addUser: 'Add User',
        editUser: 'Edit User',
        gender: {
          male: 'Male',
          female: 'Female'
        }
      },
      menu: {
        home: 'Home',
        title: 'Menu List',
        id: 'ID',
        parentId: 'Parent ID',
        menuType: 'Menu Type',
        menuName: 'Menu Name',
        routeName: 'Route Name',
        routePath: 'Route Path',
        routeParams: 'Route Params',
        layout: 'Layout Component',
        page: 'Page Component',
        i18nKey: 'I18n Key',
        icon: 'Icon',
        localIcon: 'Local Icon',
        iconTypeTitle: 'Icon Type',
        order: 'Order',
        keepAlive: 'Keep Alive',
        href: 'Href',
        hideInMenu: 'Hide In Menu',
        activeMenu: 'Active Menu',
        multiTab: 'Multi Tab',
        fixedIndexInTab: 'Fixed Index In Tab',
        button: 'Button',
        buttonCode: 'Button Code',
        buttonDesc: 'Button Desc',
        menuStatus: 'Menu Status',
        form: {
          home: 'Please select home',
          menuType: 'Please select menu type',
          menuName: 'Please enter menu name',
          routeName: 'Please enter route name',
          routePath: 'Please enter route path',
          page: 'Please select page component',
          layout: 'Please select layout component',
          i18nKey: 'Please enter i18n key',
          icon: 'Please enter iconify name',
          localIcon: 'Please enter local icon name',
          order: 'Please enter order',
          keepAlive: 'Please select whether to cache route',
          href: 'Please enter href',
          hideInMenu: 'Please select whether to hide menu',
          activeMenu: 'Please enter the route name of the highlighted menu',
          multiTab: 'Please select whether to support multiple tabs',
          fixedInTab: 'Please select whether to fix in the tab',
          fixedIndexInTab: 'Please enter the index fixed in the tab',
          button: 'Please select whether it is a button',
          buttonCode: 'Please enter button code',
          buttonDesc: 'Please enter button description',
          menuStatus: 'Please select menu status'
        },
        addMenu: 'Add Menu',
        editMenu: 'Edit Menu',
        addChildMenu: 'Add Child Menu',
        type: {
          directory: 'Directory',
          menu: 'Menu'
        },
        iconType: {
          iconify: 'Iconify Icon',
          local: 'Local Icon'
        }
      }
    }
  },
  form: {
    required: 'Cannot be empty',
    userName: {
      required: 'Please enter user name',
      invalid: 'User name format is incorrect'
    },
    phone: {
      required: 'Please enter phone number',
      invalid: 'Phone number format is incorrect'
    },
    pwd: {
      required: 'Please enter password',
      invalid: '6-18 characters, including letters, numbers, and underscores'
    },
    confirmPwd: {
      required: 'Please enter password again',
      invalid: 'The two passwords are inconsistent'
    },
    code: {
      required: 'Please enter verification code',
      invalid: 'Verification code format is incorrect'
    },
    email: {
      required: 'Please enter email',
      invalid: 'Email format is incorrect'
    }
  },
  dropdown: {
    closeCurrent: 'Close Current',
    closeOther: 'Close Other',
    closeLeft: 'Close Left',
    closeRight: 'Close Right',
    closeAll: 'Close All'
  },
  icon: {
    themeConfig: 'Theme Configuration',
    themeSchema: 'Theme Schema',
    lang: 'Switch Language',
    fullscreen: 'Fullscreen',
    fullscreenExit: 'Exit Fullscreen',
    reload: 'Reload Page',
    collapse: 'Collapse Menu',
    expand: 'Expand Menu',
    pin: 'Pin',
    unpin: 'Unpin'
  },
  storage: {
    uploadModalTitle: 'Upload a File',
    fileSelected: 'File selected',
    uploadFilePlaceholder: 'Upload a file or drag and drop here',
    fileNameLabel: 'Name',
    fileNameDescription: 'The name of the uploaded file',
    fileNamePlaceholder: 'Enter file name',
    purposeLabel: 'Purpose',
    purposeDescription: 'The purpose of the uploaded file',
    purposePlaceholder: 'Select purpose',
    learnMoreLink: 'Learn about file purposes',
    searchFilesPlaceholder: 'Search files ...',
    invalidFileType: 'Invalid file type for {purpose}',
    supportedFormatsAssistants: 'Supported formats: {formats}',
    supportedFormatsVision: 'Supported formats: {formats}',
    supportedFormatsJsonl: 'Only .jsonl files are supported',
    fileNotFound: 'File not found',
    fileUploadedButNotListed: 'File uploaded but not yet visible in list',
    fileUploadedAndListed: 'File uploaded and confirmed in list',
    downloadStarting: 'Starting download...',
    downloading: 'Downloading...',
    downloadComplete: 'Download complete',
    downloadError: 'Error downloading file',
    file: 'File',
    status: 'Status',
    fileId: 'File ID',
    purpose: 'Purpose',
    size: 'Size',
    createdAt: 'Created at',
    download: 'Download',
    delete: 'Delete',
    deleteConfirm: 'Are you sure you want to delete this file?',
    selectFile: 'Select a file to view details',
    files: 'Files',
    vectorStores: 'Vector Stores',
    upload: 'Upload',
    noFiles: 'No files uploaded',
    noVectorStores: 'No vector stores created',
    selectItem: 'Select an item to view details',
    uploadSuccess: 'File uploaded successfully',
    uploadError: 'Failed to upload file',
    fileDeleted: 'File deleted successfully',
    deleteError: 'Failed to delete file',
    fetchError: 'Failed to fetch data'
  },
  assistants: {
    vectorStore: 'Vector Store',
    noAssistants: 'No assistants found',
    createAssistantGetStarted: 'Create an assistant to get started with Assistants API.',
    defineResponseSchema: 'Define Response Schema',
    responseSchemaDescription: "Define the JSON schema for the assistant's responses",
    enterVectorStoreId: 'Enter vector store Id',
    selectExisting: 'Select Existing',
    uploadNew: 'Upload New',
    uploadFile: 'Upload File',
    generate: 'Generate',
    examples: 'Examples',
    getStockPrice: 'Get Stock Price',
    weatherForecast: 'Weather Forecast',
    calculator: 'Calculator',
    functions: 'Functions',
    addFunction: 'Add Function',
    editFunction: 'Edit Function',
    removeFunction: 'Remove Function',
    functionName: 'Function Name',
    functionDescription:
      'Define a function that the assistant can call. The function should be defined using JSON Schema format.',
    functionDefinitionPlaceholder: '   Enter function definition in JSON Schema format...',
    definition: 'Function Definition',
    strictMode: 'Strict Mode',
    strictModeHelp:
      'When enabled, the assistant will only call functions exactly as defined. Disable for more flexible function calling.',
    invalidDefinition: 'Invalid function definition. Please check the JSON Schema format.',
    duplicateFunctionName: 'A function with this name already exists.',
    functionRequired: 'Function definition is required',
    generateFunction: 'Generate Function',
    exampleFunctions: 'Example Functions',
    functionSaved: 'Function saved successfully',
    functionRemoved: 'Function removed successfully',
    functionValidationError: 'Function validation failed. Please check the definition.',
    learnMoreFunctions: 'Learn more about function definitions',
    modelRequired: 'Model is required',
    responseFormatRequired: 'Response format is required',
    temperatureInvalid: 'Temperature must be between 0 and 2',
    topPInvalid: 'Top P must be between 0 and 1',
    maxResultsInvalid: 'Max results must be within the allowed range',
    title: 'Assistants',
    selectToView: 'Select an assistant to view details',
    createNew: 'Create New Assistant',
    name: 'Name',
    namePlaceholder: 'Enter a user friendly name',
    nameRequired: 'Name is required',
    instructions: 'Instructions',
    instructionsPlaceholder: 'You are a helpful assistant...',
    instructionsRequired: 'Instructions are required',
    model: 'Model',
    tools: 'Tools',
    fileSearch: 'File Search',
    codeInterpreter: 'Code Interpreter',
    addFiles: 'Add Files',
    selectVectorStore: 'Select Vector Store',
    modelConfig: 'Model Configuration',
    responseFormat: 'Response Format',
    temperature: 'Temperature',
    topP: 'Top P',
    maxResults: 'Max Results',
    maxResultsHelp: 'Maximum number of results to return from file search',
    create: 'Create',
    attachFiles: 'Attach Files to File Search',
    attachVectorStore: 'Attach Vector Store',
    dragFilesHere: 'Drag your files here',
    clickToUpload: 'Click to Upload',
    fileUploadHelp: 'Files will be processed and made available for the assistant to search through',
    vectorStoreHelp: 'Select an existing vector store to allow the assistant to search through its contents',
    searchVectorStores: 'Search vector stores...',
    noVectorStoresFound: 'No vector stores found',
    vectorStoreSearchPlaceholder: 'Enter vector store id',
    attach: 'Attach',
    back: 'Back',
    learnMore: 'Learn more',
    fileName: 'File Name',
    fileSize: 'Size',
    fileStatus: 'Status',
    fileActions: 'Actions',
    removeFile: 'Remove',
    fileAttached: 'File attached successfully',
    vectorStoreAttached: 'Vector store attached successfully',
    fileRemoved: 'File removed',
    invalidFileType: 'Invalid file type',
    fileTooLarge: 'File is too large',
    uploadError: 'Error uploading file',
    temperatureHelp: "Controls randomness in the assistant's responses",
    topPHelp: "Controls diversity of the assistant's responses",
    fileSearchHelp: 'Enable searching through attached files',
    codeInterpreterHelp: 'Enable Python code execution capabilities'
  }
};

export default local satisfies App.I18n.Schema &
  (App.I18n.IsExactLocaleKeyShape<typeof local.sponsorship, App.I18n.Schema['sponsorship']> extends true
    ? unknown
    : { readonly __sponsorshipLocaleKeyShapeMismatch: never });
